/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
window.theme = window.theme || {}, window.Shopify = window.Shopify || {}, theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        hasLocalStorage: !0,
        mediaQuerySmall: "screen and (max-width: 769px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!("ontouchstart" in window || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
        stickyHeader: !1,
        rtl: "rtl" == document.documentElement.getAttribute("dir")
    }, theme.config.isTouch && (document.documentElement.className += " supports-touch"), console && console.log && console.log("Impulse theme (" + theme.settings.themeVersion + ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"), theme.recentlyViewed = {
        recent: {},
        productInfo: {}
    },
    function() {
        "use strict";
        var e, t, i, s, n, a, r, o, c;
        theme.delegate = {
            on: function(e, t, i) {
                return this.namespaces || (this.namespaces = {}), this.namespaces[e] = t, i = i || !1, this.addEventListener(e.split(".")[0], t, i), this
            },
            off: function(e) {
                if (this.namespaces) return this.removeEventListener(e.split(".")[0], this.namespaces[e]), delete this.namespaces[e], this
            }
        }, window.on = Element.prototype.on = theme.delegate.on, window.off = Element.prototype.off = theme.delegate.off, theme.utils = {
            defaultTo: function(e, t) {
                return null == e || e != e ? t : e
            },
            wrap: function(e, t) {
                e.parentNode.insertBefore(t, e), t.appendChild(e)
            },
            debounce: function(e, t, i) {
                var s;
                return function() {
                    var n = this,
                        a = arguments,
                        r = i && !s;
                    clearTimeout(s), s = setTimeout(function() {
                        s = null, i || t.apply(n, a)
                    }, e), r && t.apply(n, a)
                }
            },
            throttle: function(e, t) {
                var i = !1;
                return function() {
                    i || (t.apply(this, arguments), i = !0, setTimeout(function() {
                        i = !1
                    }, e))
                }
            },
            prepareTransition: function(e, t) {
                e.addEventListener("transitionend", function t(i) {
                    e.classList.remove("is-transitioning"), e.removeEventListener("transitionend", t)
                }), e.classList.add("is-transitioning"), e.offsetWidth, "function" == typeof t && t()
            },
            compact: function(e) {
                for (var t = -1, i = null == e ? 0 : e.length, s = 0, n = []; ++t < i;) {
                    var a = e[t];
                    a && (n[s++] = a)
                }
                return n
            },
            serialize: function(e) {
                var t = [];
                return Array.prototype.slice.call(e.elements).forEach(function(e) {
                    !e.name || e.disabled || ["file", "reset", "submit", "button"].indexOf(e.type) > -1 || ("select-multiple" !== e.type ? ["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked || t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value)) : Array.prototype.slice.call(e.options).forEach(function(i) {
                        i.selected && t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(i.value))
                    }))
                }), t.join("&")
            }
        }, theme.a11y = {
            trapFocus: function(e) {
                var t = {
                        focusin: e.namespace ? "focusin." + e.namespace : "focusin",
                        focusout: e.namespace ? "focusout." + e.namespace : "focusout",
                        keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus"
                    },
                    i = e.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'),
                    s = [].slice.call(i).filter(e => null !== e.offsetParent),
                    n = s[0],
                    a = s[s.length - 1];
                e.elementToFocus || (e.elementToFocus = e.container), e.container.setAttribute("tabindex", "-1"), e.elementToFocus.focus(), document.documentElement.off("focusin"), document.documentElement.on(t.focusout, function() {
                    document.documentElement.off(t.keydown)
                }), document.documentElement.on(t.focusin, function(i) {
                    i.target !== e.container && i.target !== a && i.target !== n || document.documentElement.on(t.keydown, function(e) {
                        var t;
                        9 === (t = e).keyCode && (t.target !== a || t.shiftKey || (t.preventDefault(), n.focus()))
                    })
                })
            },
            removeTrapFocus: function(e) {
                var t = e.namespace ? "focusin." + e.namespace : "focusin";
                e.container && e.container.removeAttribute("tabindex"), document.documentElement.off(t)
            },
            lockMobileScrolling: function(e, t) {
                var i = t || document.documentElement;
                document.documentElement.classList.add("lock-scroll"), i.on("touchmove" + e, function() {
                    return !0
                })
            },
            unlockMobileScrolling: function(e, t) {
                document.documentElement.classList.remove("lock-scroll"), (t || document.documentElement).off("touchmove" + e)
            }
        }, document.documentElement.on("keyup.tab", function(e) {
            9 === e.keyCode && (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"))
        }), theme.Currency = (e = theme && theme.settings && theme.settings.superScriptPrice, {
            formatMoney: function(t, i) {
                i || (i = theme.settings.moneyFormat), "string" == typeof t && (t = t.replace(".", ""));
                var s = "",
                    n = /\{\{\s*(\w+)\s*\}\}/,
                    a = i || "${{amount}}";

                function r(e, t, i, s) {
                    if (t = theme.utils.defaultTo(t, 2), i = theme.utils.defaultTo(i, ","), s = theme.utils.defaultTo(s, "."), isNaN(e) || null == e) return 0;
                    var n = (e = (e / 100).toFixed(t)).split(".");
                    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "")
                }
                switch (a.match(n)[1]) {
                    case "amount":
                        s = r(t, 2), e && s && s.includes(".") && (s = s.replace(".", "<sup>") + "</sup>");
                        break;
                    case "amount_no_decimals":
                        s = r(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        s = r(t, 2, ".", ","), e && s && s.includes(",") && (s = s.replace(",", "<sup>") + "</sup>");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        s = r(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        s = r(t, 0, " ")
                }
                return a.replace(n, s)
            },
            getBaseUnit: function(e) {
                if (e && e.unit_price_measurement && e.unit_price_measurement.reference_value) return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit
            }
        }), theme.Images = {
            imageSize: function(e) {
                if (!e) return "620x";
                var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                return null !== t ? t[1] : null
            },
            getSizedImageUrl: function(e, t) {
                if (!e || null == t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null != i) {
                    var s = e.split(i[0]),
                        n = i[0];
                    return this.removeProtocol(s[0] + "_" + t + n)
                }
                return null
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            },
            buildImagePath: function(e, t) {
                if (null == e) return [];
                if (t) {
                    let i = [];
                    return t.forEach(s => {
                        let n = `${e}?width=${s}`;
                        s === t[t.length - 1] ? n += ` ${s}w` : n += ` ${s}w,`, i.push(n)
                    }), i
                }
                return [e]
            }
        }, theme.initWhenVisible = function(e) {
            var t = e.threshold ? e.threshold : 0;
            new IntersectionObserver((t, i) => {
                t.forEach(t => {
                    t.isIntersecting && "function" == typeof e.callback && (e.callback(), i.unobserve(t.target))
                })
            }, {
                rootMargin: "0px 0px " + t + "px 0px"
            }).observe(e.element)
        }, theme.LibraryLoader = (s = "requested", n = "loaded", r = {
            youtubeSdk: {
                tagId: "youtube-sdk",
                src: "https://www.youtube.com/iframe_api",
                type: i = "script"
            },
            vimeo: {
                tagId: "vimeo-api",
                src: "https://player.vimeo.com/api/player.js",
                type: i
            },
            shopifyXr: {
                tagId: "shopify-model-viewer-xr",
                src: (a = "https://cdn.shopify.com/shopifycloud/") + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
                type: i
            },
            modelViewerUi: {
                tagId: "shopify-model-viewer-ui",
                src: a + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
                type: i
            },
            modelViewerUiStyles: {
                tagId: "shopify-model-viewer-ui-styles",
                src: a + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                type: t = "link"
            }
        }, {
            load: function(e, a) {
                var o = r[e];
                if (o && o.status !== s) {
                    if (a = a || function() {}, o.status !== n) {
                        switch (o.status = s, o.type) {
                            case i:
                                m = (c = o, l = a, (d = document.createElement("script")).src = c.src, d.addEventListener("load", function() {
                                    c.status = n, l()
                                }), d);
                                break;
                            case t:
                                m = (u = o, h = a, (p = document.createElement("link")).href = u.src, p.rel = "stylesheet", p.type = "text/css", p.addEventListener("load", function() {
                                    u.status = n, h()
                                }), p)
                        }
                        m.id = o.tagId, o.element = m;
                        var c, l, d, u, h, p, m, g = document.getElementsByTagName(o.type)[0];
                        g.parentNode.insertBefore(m, g)
                    } else a()
                }
            }
        }), theme.rteInit = function() {
            function e(e) {
                e.src = e.src;
                var t = document.createElement("div");
                t.classList.add("video-wrapper"), theme.utils.wrap(e, t)
            }
            document.querySelectorAll(".rte table").forEach(e => {
                var t = document.createElement("div");
                t.classList.add("table-wrapper"), theme.utils.wrap(e, t)
            }), document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(t => {
                e(t)
            }), document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(t => {
                e(t)
            }), document.querySelectorAll(".rte a img").forEach(e => {
                e.parentNode.classList.add("rte__image")
            })
        }, theme.Sections = function() {
            this.constructors = {}, this.instances = [], document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)), document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)), document.addEventListener("shopify:section:select", this._onSelect.bind(this)), document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)), document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)), document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this))
        }, theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
            _createInstance: function(e, t, i) {
                var s = e.getAttribute("data-section-id"),
                    n = e.getAttribute("data-section-type");
                if (void 0 !== (t = t || this.constructors[n])) {
                    i && this._findInstance(s) && this._removeInstance(s);
                    try {
                        var a = Object.assign(new t(e), {
                            id: s,
                            type: n,
                            container: e
                        });
                        this.instances.push(a)
                    } catch (r) {
                        console.error(r)
                    }
                }
            },
            _findInstance: function(e) {
                for (var t = 0; t < this.instances.length; t++)
                    if (this.instances[t].id === e) return this.instances[t]
            },
            _removeInstance: function(e) {
                for (var t, i = this.instances.length; i--;)
                    if (this.instances[i].id === e) {
                        t = this.instances[i], this.instances.splice(i, 1);
                        break
                    } return t
            },
            _onSectionLoad: function(e, t, i) {
                window.AOS && AOS.refreshHard(), theme && theme.initGlobals && theme.initGlobals();
                var s = t || e.target,
                    n = t || e.target.querySelector("[data-section-id]");
                if (n) {
                    this._createInstance(n);
                    var a = t ? i : this._findInstance(e.detail.sectionId);
                    s.querySelectorAll("[data-subsection]").length && this.loadSubSections(s), a && "function" == typeof a.onLoad && a.onLoad(e), setTimeout(function() {
                        window.dispatchEvent(new Event("scroll"))
                    }, 200)
                }
            },
            _onSectionUnload: function(e) {
                this.instances = this.instances.filter(function(t) {
                    var i = t.id === e.detail.sectionId;
                    return i && "function" == typeof t.onUnload && t.onUnload(e), !i
                })
            },
            loadSubSections: function(e) {
                e && e.querySelectorAll("[data-section-id]").forEach(e => {
                    this._onSectionLoad(null, e, e.dataset.sectionId)
                })
            },
            _onSelect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e)
            },
            _onDeselect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e)
            },
            _onBlockSelect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
            },
            _onBlockDeselect: function(e) {
                var t = this._findInstance(e.detail.sectionId);
                void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
            },
            register: function(e, t, i) {
                this.constructors[e] = t;
                var s = document.querySelectorAll('[data-section-type="' + e + '"]');
                i && (s = i.querySelectorAll('[data-section-type="' + e + '"]')), s.forEach((function(e) {
                    this._createInstance(e, t, i)
                }).bind(this))
            },
            reinit: function(e) {
                for (var t = 0; t < this.instances.length; t++) {
                    var i = this.instances[t];
                    i.type === e && "function" == typeof i.forceReload && i.forceReload()
                }
            }
        }), theme.Variants = function() {
            function e(e) {
                this.container = e.container, this.variants = e.variants, this.singleOptionSelector = e.singleOptionSelector, this.singleOptionLabel = e.singleOptionLabel, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.dynamicVariantsEnabled = e.dynamicVariantsEnabled, this.currentlySelectedValues = this._getCurrentOptions(), this.currentVariant = this._getVariantFromOptions(), this.container.querySelectorAll(this.singleOptionSelector).forEach(e => {
                    e.addEventListener("change", this._onSelectChange.bind(this))
                }), this.container.querySelectorAll(this.singleOptionLabel).forEach(e => {
                    e.addEventListener("mouseenter", this._onHoverChange.bind(this))
                }), this.container.querySelectorAll(this.singleOptionLabel).forEach(e => {
                    e.addEventListener("mouseleave", this._onHoverLeaveChange.bind(this))
                })
            }
            return e.prototype = Object.assign({}, e.prototype, {
                _getCurrentOptionsHover: function() {
                    var e = [];
                    if (this.container.querySelectorAll(this.singleOptionLabel).forEach(t => {
                            t.matches(":hover") && e.push({
                                value: t.dataset.value,
                                index: t.dataset.index
                            })
                        }), "option2" == e[0].index) {
                        var i = document.querySelector(".metal-swatch.swatchActive");
                        if(i){
                            t && e.push({
                                value: i.nextSibling.dataset.value,
                                index: i.nextSibling.dataset.index
                            });
                        }
                        var s = document.querySelector(".diamond-quality-swatch.swatchActive");
                        if(s){
                            t && e.push({
                                value: s.nextSibling.dataset.value,
                                index: s.nextSibling.dataset.index
                            })
                        }
                    } else {
                        if ("option1" == e[0].index) var n = "diamond-quality-swatch.swatchActive";
                        else n = "metal-swatch.swatchActive";
                        var a = document.querySelector("." + n);
                        if(a && a.nextSibling.dataset){
                            t && e.push({
                                value: a.nextSibling.dataset.value,
                                index: a.nextSibling.dataset.index
                            })
                        }
                    }
                    return e = theme.utils.compact(e)
                },
                _getCurrentOptions: function() {
                    var e = [];
                    return this.container.querySelectorAll(this.singleOptionSelector).forEach(t => {
                        var i = t.getAttribute("type");
                        "radio" === i || "checkbox" === i ? t.checked && e.push({
                            value: t.value,
                            index: t.dataset.index
                        }) : e.push({
                            value: t.value,
                            index: t.dataset.index
                        })
                    }), e = theme.utils.compact(e)
                },
                _numberFromOptionKey: function(e) {
                    return parseInt(e.substr(-1))
                },
                _getWeightedOptionMatchCount: function(e) {
                    return this._getCurrentOptions().reduce((t, {
                        value: i,
                        index: s
                    }) => {
                        let n = 4 - this._numberFromOptionKey(s);
                        return e[s] === i ? t + n : t
                    }, 0)
                },
                _getFullMatchHover(e) {
                    let t = this._getCurrentOptionsHover();
                    let h = this._getCurrentOptions();
                    let u = h.map(item => {
                        let match = t.find(i => i.index === item.index);
                        return match ? match : item;
                    });
                    return this.variants.find(i => {
                        let s = u.every(({
                            value: e,
                            index: t
                        }) => i[t] === e);
                        return e ? s && i.available : s
                    })
                },
                _getFullMatch(e) {
                    let t = this._getCurrentOptions();
                    return this.variants.find(i => {
                        let s = t.every(({
                            value: e,
                            index: t
                        }) => i[t] === e);
                        return e ? s && i.available : s
                    })
                },
                _getClosestAvailableMatch: function(e) {
                    if (!e) return null;
                    let t = this._getCurrentOptions(),
                        i = this.variants;
                    return (e && i.filter(i => t.filter(({
                        value: t,
                        index: i
                    }) => this._numberFromOptionKey(i) <= this._numberFromOptionKey(e.index)).every(({
                        value: e,
                        index: t
                    }) => i[t] === e) && i.available)).reduce((t, i) => {
                        if (null === t) return i;
                        let s = this._getWeightedOptionMatchCount(t, e);
                        return this._getWeightedOptionMatchCount(i, e) > s ? i : t
                    }, null)
                },
                _initVariantHiding: function(changePosition){
                    const productData = window.product;
                    const variants = productData.variants;
                    const optionGroups = document.querySelectorAll('[data-product-option]');
                    let selectedOptions = [];
                    let is_custom_change = false;
                    if (!optionGroups.length) return;

                    optionGroups.forEach((group, index) => {
                        const checked = group.querySelector('input:checked');
                        const select = group.querySelector('select');

                        if (checked) {
                        selectedOptions[index] = checked.value;
                        } else if (select) {
                        selectedOptions[index] = select.value;
                        } else {
                        selectedOptions[index] = null;
                        }
                    });
                    const checkNotNull = selectedOptions.filter(opt => opt == '');
                    if(checkNotNull.length > 0 || selectedOptions.length == 0) return false;
                    if(changePosition == 1){
                        this._updateOptionGroup("1", (variant, value) => {
                            return (
                            (!selectedOptions[0] || variant.option1 === selectedOptions[0]) &&
                            (!selectedOptions[2] || variant.option3 === selectedOptions[2]) &&
                            variant.option2 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                        this._updateOptionGroup("2", (variant, value) => {
                            return (
                            (!selectedOptions[0] || variant.option1 === selectedOptions[0]) &&
                            (!selectedOptions[2] || variant.option3 === selectedOptions[2]) &&
                            variant.option2 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                        this._updateOptionGroup("3", (variant, value) => {
                            return (
                            (!selectedOptions[0] || variant.option1 === selectedOptions[0]) &&
                            (!selectedOptions[1] || variant.option2 === selectedOptions[1]) &&
                            variant.option3 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                    }
                    if(changePosition == 2){
                        this._updateOptionGroup("1", (variant, value) => {
                            return (
                            (!selectedOptions[1] || variant.option2 === selectedOptions[1]) &&
                            (!selectedOptions[2] || variant.option3 === selectedOptions[2]) &&
                            variant.option1 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                        this._updateOptionGroup("3", (variant, value) => {
                            return (
                            (!selectedOptions[0] || variant.option1 === selectedOptions[0]) &&
                            (!selectedOptions[1] || variant.option2 === selectedOptions[1]) &&
                            variant.option3 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                    }
                    if(changePosition == 3 || is_custom_change){
                        this._updateOptionGroup("1", (variant, value) => {
                            return (
                            (!selectedOptions[1] || variant.option2 === selectedOptions[1]) &&
                            (!selectedOptions[2] || variant.option3 === selectedOptions[2]) &&
                            variant.option1 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                        this._updateOptionGroup("2", (variant, value) => {
                            return (
                            (!selectedOptions[0] || variant.option1 === selectedOptions[0]) &&
                            (!selectedOptions[2] || variant.option3 === selectedOptions[2]) &&
                            variant.option2 === value &&
                            variant.inventory_quantity > 0
                            );
                        });
                    }
                },
                _updateOptionGroup: function(position, conditionFn) {
                    const productData = window.product;
                    const variants = productData.variants;
                    let checkOptionElement = document.querySelectorAll(`[data-product-option][data-index='option${position}']`);
                    checkOptionElement.forEach(el => {
                        var optionValue = el.getAttribute('data-value');
                        var elVariant = variants.some(variant => conditionFn(variant, optionValue));
                        if(elVariant){
                            el.classList.remove('hide');
                        }
                        else{
                            el.classList.add('hide');
                        }
                        
                    });
                },
                _getVariantFromOptionsHover: function(e) {
                    return this._getFullMatchHover(!0) || null
                },
                _getVariantFromOptions: function(e) {
                    let t = this._getFullMatch(!0),
                        i = this._getClosestAvailableMatch(e),
                        s = this._getFullMatch(!1);
                    return this.dynamicVariantsEnabled ? t || i || s || null : s || null
                },
                _updateInputState: function(e, t) {
                    return t => {
                        if (null === e) return;
                        let i = t.dataset.index,
                            s = t.value,
                            n = t.getAttribute("type");
                        "radio" === n || "checkbox" === n ? t.checked = e[i] === s : t.value = e[i]
                    }
                },
                _onHoverChange: function({
                    srcElement: e
                }) {
                    let t = this._getVariantFromOptionsHover({
                        index: e.dataset.index,
                        value: e.dataset.value
                    });
                    if (document.querySelector("[data-product-price]").innerHTML = theme.Currency.formatMoney(t.price, theme.settings.moneyFormat).split(".")[0], t.compare_at_price > t.price) {
                        document.querySelector("[data-compare-price-el]").classList.remove("hidden"), document.querySelector("[data-compare-price]").innerHTML = theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat).split(".")[0], document.querySelector("[data-save-price]").classList.remove("hidden");
                        var i = t.compare_at_price - t.price;
                        i = "percent" == theme.settings.saveType ? Math.round(100 * i / t.compare_at_price) + "%" : theme.Currency.formatMoney(i, theme.settings.moneyFormat), document.querySelector("[data-save-price]").innerHTML = " -" + i
                    } else document.querySelector("[data-compare-price-el]").classList.add("hidden"), document.querySelector("[data-save-price]").classList.add("hidden")
                },
                _onHoverLeaveChange: function({
                    srcElement: e
                }) {
                    let t = this._getVariantFromOptions({
                        index: e.dataset.index,
                        value: e.dataset.value
                    });
                    if (document.querySelector("[data-product-price]").innerHTML = theme.Currency.formatMoney(t.price, theme.settings.moneyFormat).split(".")[0], t.compare_at_price > t.price) {
                        document.querySelector("[data-compare-price-el]").classList.remove("hidden"), document.querySelector("[data-compare-price]").innerHTML = theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat).split(".")[0], document.querySelector("[data-save-price]").classList.remove("hidden");
                        var i = t.compare_at_price - t.price;
                        i = "percent" == theme.settings.saveType ? Math.round(100 * i / t.compare_at_price) + "%" : theme.Currency.formatMoney(i, theme.settings.moneyFormat), document.querySelector("[data-save-price]").innerHTML = " -" + i
                    } else document.querySelector("[data-compare-price-el]").classList.add("hidden"), document.querySelector("[data-save-price]").classList.add("hidden")
                },
                _onSelectChange: function({
                    srcElement: e
                }) {
                    let t = this._getVariantFromOptions({
                        index: e.dataset.index,
                        value: e.value
                    });
                    if (typeof hideUnavailableOptions === "function") {
                        hideUnavailableOptions(); //defined in the file product-template.liquid
                    }
                    let optionIndex = e.dataset.index;
                    optionIndex = optionIndex.replace('option', '');
                    var i = t.option1;
                    let s = t.option2,
                        n = t.option3;

                    function a(e, t) {
                        null != t && (t = t.replace('"', ""));
                        let i = document.querySelectorAll(`.${e}-swatch.swatchActive`);
                        i && i.forEach(e => {
                            e.classList.remove("swatchActive")
                        });
                        let s = document.querySelectorAll(`.${e}-swatch[value="${t}"]`);
                        s && s.forEach(e => {
                            e.classList.add("swatchActive")
                        })
                    }
                    "Remi Rhode" == document.querySelector("#item-vendor").value && document.querySelector("#color_opt_index") && (i = 1 == document.querySelector("#color_opt_index").value ? t.option1 : t.option2), a("option1", i), a("option2", s), a("option3", n), a("color", i), document.querySelector("#product-template") && document.querySelector("#product-template");
                    let r = document.querySelector(".option1-swatch.swatchActive"),
                        o = document.querySelector(".option2-swatch.swatchActive"),
                        c = document.querySelector(".option3-swatch.swatchActive"),
                        l = document.querySelector(".color-swatch.swatchActive");
                    if (r) var d = r.getAttribute("data-option-name") + "_" + r.getAttribute("data-swatch-name");
                    else d = "";
                    if (l) var u = l.getAttribute("data-swatch-name");
                    else u = "";
                    if (o) var h = o.getAttribute("data-option-name") + "_" + o.getAttribute("data-swatch-name");
                    else h = "";
                    if (c) var p = c.getAttribute("data-option-name") + "_" + c.getAttribute("data-swatch-name");
                    else p = "";
                    if ("" != u) var m = u;
                    else m = d + "+" + h + "+" + p;
                    "+" == m.slice(-1) && (m = m.slice(0, -1));
                    const ss = document.querySelector('select[data-index="option3"]');
                    if (ss && ss.value) {
                        let a = ss.value.trim(),
                            t = ss.getAttribute('data-name') + "_" + a.split(" ")[0];
                        m = m + "+" + t
                    } /*let g=document.querySelectorAll(`.product__thumb-item[data-group="${m}"]`)*/
                    let g = this.container.querySelectorAll(`.product__thumb-item[data-group="${m}"]`);
                    if ("Remi Rhode" == document.querySelector("#item-vendor").value) {
                        if (jquery(".string-color-input").length) {
                            var f = jquery(".string-color-input.active").attr("data-value"),
                                v = jquery(".variant-input").find("input[type='radio']:checked").attr("data-string-swatch-name") + " / " + f;
                            jquery(`[data-group="${v}"]`).length && ($(".slider-nav").slick("slickUnfilter"), $(".slider-nav").slick("slickFilter", `[data-group="${v}"]`), $(".product__thumb-item.slick-current").trigger("click"), $(".slider-nav").slick("slickGoTo", "0"))
                        }
                        $(`[data-group="${m}"]`).length && ($(".slider-nav").slick("slickUnfilter"), $(".slider-nav").slick("slickFilter", `[data-group="${m}"]`))
                    } else {
                        /*let y=document.querySelectorAll(".product__thumb-item")*/
                        let y = this.container.querySelectorAll(".product__thumb-item");
                        "++" != m && y.forEach(function(e) {
                            e.classList.add("product__thumb-item-hide")
                        }), this.container.querySelectorAll(".product-main-slide").forEach(function(e) {
                            e.classList.add("product__main-item-hide")
                        });
                        var _ = 1;
                        g.forEach(e => {
                            e.classList.remove("product__thumb-item-hide"), 1 == _ && (e.dispatchEvent(new Event("click")), _++)
                        }), document.querySelectorAll(`.product-main-slide[data-group="${m}"]`).forEach(e => {
                            e.classList.remove("product__main-item-hide"), e.getAttribute("data-slick-index")
                        })
                    }
                    var S = document.querySelector(".glb-id-" + t.id);
                    if (S) {
                        u = !1;
                        let b = S.value;
                        var w = "";
                        if (document.querySelector("#pdp-canvas") && (w = document.querySelector("#pdp-canvas").getAttribute("src")), "" == w && (u = !0), "" != w) {
                            let L = new URL(w),
                                q = i.replace("14K", "");
                            q = (q = (q = (q = q.replace("18K", "")).replaceAll(" ", "")).toLowerCase()).replace("gold", "Gold"), L.searchParams.set("metalColor", q), L.searchParams.set("fileUrl", b), u ? document.querySelector("#pdp-canvas-input").value = L : document.querySelector("#pdp-canvas").setAttribute("src", L)
                        }
                    }
                    document.querySelectorAll(".metal-swatch.swatchActive").forEach(e => {
                        let t = e.getAttribute("data-color-name"),
                            i = document.querySelector(".product-canvas");
                        i ? i.contentWindow.postMessage({
                            metalColor: function(e) {
                                let t = e.toLowerCase().split(" ");
                                isNaN(parseInt(t[0])) || t.shift();
                                for (let i = 1; i < t.length; i++) t[i] = t[i][0].toUpperCase() + t[i].slice(1);
                                return t.join("")
                            }(t)
                        }, "https://d1vm5mhhx0407.cloudfront.net/index.html") : console.log("canvas color changed failed")
                    }), this.container.querySelectorAll(this.singleOptionSelector).forEach(this._updateInputState(t, e));
                    let k = this.currentlySelectedValues = this._getCurrentOptions(),
                        E = {
                            variant: t,
                            currentlySelectedValues: k,
                            value: e.value,
                            index: e.parentElement.dataset.index
                        };
                    if (this.container.dispatchEvent(new CustomEvent("variantChange", {
                            detail: E
                        })), document.dispatchEvent(new CustomEvent("variant:change", {
                            detail: E
                        })), t) {
                        var I = document.querySelectorAll(".product-image-canvas"),
                            C = document.querySelector(".low-inventory-msg");
                        if (C) {
                            let A = document.querySelector(".stock-" + t.id).value;
                            t.available ? "shopify" == t.inventory_management && A < 5 ? (C.classList.remove("hide"), C.innerHTML = "Low Stock") : C.classList.add("hide") : (C.classList.remove("hide"), C.innerHTML = "Out of Stock")
                        }
                        if (I && I.forEach(function(e) {
                                e.src = t.featured_image.src
                            }), this._updateMasterSelect(t), "Remi Rhode" == document.querySelector("#item-vendor").value && this._updateImages(t), this._updatePrice(t), this._updateUnitPrice(t), this._updateSKU(t), this.currentVariant = t, variantDetailsByVariantID.hasOwnProperty(t.id)) {
                            let T = variantDetailsByVariantID[t.id],
                                M = (T[0].handle, T[0].sku),
                                DS = T[0].diaspark_sku,
                                P = parseInt(T[0].quantity),
                                O = T[0].metalColor,
                                H = T[0].main_stone_count,
                                D = T[0].side_stone_1_count,
                                j = T[0].side_stone_2_count,
                                V = T[0].main_stone_detail_color,
                                F = T[0].main_stone_detail_clarity,
                                B = T[0].main_stone_detail_certification,
                                R = T[0].main_stone_cut,
                                N = T[0].finding_type,
                                U = T[0].lead_time,
                                z = T[0].matching_band,
                                W = T[0].blue_nile_price,
                                Q = T[0].blue_nile_price_per,
                                G = T[0].james_allen_price,
                                X = T[0].james_allen_price_per,
                                Y = T[0].brilliant_earth_price,
                                K = T[0].brilliant_earth_price_per,
                                VU = T[0].video_url,
                                CD = T[0].certified;
                            var J = metaData.daynamic_description[t.id],
                                I = document.getElementById('stock-label-text');
                                if (typeof getAvailableSizes === "function" && DS != '') {
                                    getAvailableSizes(DS); //defined in the file ring-size.liquid
                                }

                            const pdpCertifiedDtl = document.getElementById('pdp-certified-dtl')
                            if(pdpCertifiedDtl){
                                if(CD != ''){
                                    pdpCertifiedDtl.innerHTML = CD;
                                    pdpCertifiedDtl.parentElement.classList.remove('hide');
                                }
                                else{
                                    pdpCertifiedDtl.parentElement.classList.add('hide');
                                }
                            }

                            document.getElementById("video-product-canvas") && ("" != VU ? (document.getElementById("video-product-canvas").setAttribute("src", VU), document.getElementById("variant-video-media-el").classList.remove("hide","product__thumb-item-hide"), document.getElementById("variant-video-media-thumb").classList.remove("hide","product__thumb-item-hide")) : (document.getElementById("variant-video-media-el").classList.add("hide","product__thumb-item-hide"), document.getElementById("variant-video-media-thumb").classList.add("hide","product__thumb-item-hide"))), document.getElementById("variant-certificate-el") && ("IGI" == CD ? document.getElementById("variant-certificate-el").classList.remove("hide","product__thumb-item-hide") : document.getElementById("variant-certificate-el").classList.add("hide","product__thumb-item-hide"));
                            
                            let titleEl = document.querySelector('.diamond-product-single__title');
                            if (titleEl) {
                                let baseTitle = titleEl.getAttribute('data-base-title') || 'Lab Grown Diamond';
                                let newTitle = '';
                                let caratVal = t.option1 || '';
                                let shapeVal = t.option2 || '';

                                if (caratVal) newTitle += caratVal + ' ctw ';
                                if (shapeVal) newTitle += shapeVal + ' Shaped ';
                                if (CD) newTitle += CD + ' Certified ';

                                newTitle += baseTitle;
                                titleEl.innerText = newTitle.trim();
                            }
                            "" != J && (document.querySelector(".desc").innerHTML = J), document.querySelector("input.final_date").value = T[0].estimate_days + " Business Days", document.querySelectorAll(".est_delv_date").forEach(d=>{d.innerHTML=T[0].estimate_date})/* document.querySelector("#est_delv_date").innerHTML = T[0].estimate_date*/, "" == z ? document.querySelector(".matching-band-prd-section-wrapper").classList.add("hide") : document.querySelector(".matching-band-prd-section-wrapper").classList.remove("hide");
                                /*P > 0 ? document.querySelector("#pdp-stock-made-qty").innerHTML = "In Stock" : document.querySelector("#pdp-stock-made-qty").innerHTML = "Made-to-Order";*/
                                const stockElements=document.querySelectorAll(".pdp-stock-made-qty");let stockLabel="Made-to-order";P>0&&(stockLabel="In Stock");stockElements.forEach(e=>{e.innerHTML=stockLabel});
                                if (P > 0){
                                    /*(document.querySelector("#inline_properties_stock").value = "Yes"),*/
                                    /*document.querySelector("#pdp-product__tag").classList.remove("hide"),*/
                                    //(document.querySelector("#pdp-stock-made-qty").innerHTML = "In Stock");
                                    /*
                                        P < 50
                                            ? (document.querySelector("#pdp-product__tag").innerHTML = `Only ${P} Units Left`)
                                            : (document.querySelector("#pdp-product__tag").innerHTML = "In-Stock");*/
                                    if (P < 50) {
                                        I && (I.classList.add('unit-text-el'),I.innerHTML = `Only ${P} Units Left&nbsp;|&nbsp;`);
                                    } else {
                                        I && (I.classList.remove('unit-text-el'),I.innerHTML = "In-Stock&nbsp;|&nbsp;");
                                    }
                                }
                                else {
                                    I && (I.innerHTML = '')
                                    /*(document.querySelector("#inline_properties_stock").value = ""),*/
                                    //(document.querySelector("#pdp-stock-made-qty").innerHTML = "Made-to-Order");
                                    /*let DT = document.querySelector("#pdp-product__tag").getAttribute("data-tag-text");
                                    "" != DT
                                        ? (document.querySelector("#pdp-product__tag").classList.remove("hide"),
                                        (document.querySelector("#pdp-product__tag").innerHTML = DT))
                                        : document.querySelector("#pdp-product__tag").classList.add("hide");*/
                                }
                                // IGS-dyanamic code- 18-06
                                //let compareData = window.compareMetafields[t.id];
                                let compareData = null;
                                if (
                                    window.compareMetafields &&
                                    typeof window.compareMetafields === 'object'
                                ) {
                                    compareData = window.compareMetafields[t.id];
                                }
                                //console.log('Variant ID:', t.id, '| compareData:', compareData);
                                let tableSection = document.querySelector(".dtlcomparelook-section");
                                let mainCompareSection = document.querySelector(".dtlcomparelook-main-section");
                                if(compareData && compareData.comparison_price && compareData.comparison_price[0]){
                                    // if(mainCompareSection){
                                    //     mainCompareSection.classList.remove("hide");
                                    // }
                                    let compareSection = document.querySelector(".dtlcompare-section");

                                    if(compareSection){
                                        compareSection.classList.remove("hide");
                                    }
                                    if(tableSection){
                                        //console.log('HAS DATA', t.id, compareData);
                                        tableSection.classList.remove("hide");
                                        //tableSection.style.display = "block";
                                    }
                                    let compare = compareData.comparison_price[0];
                                    let table = document.querySelector(".dtlcompare-table");
                                    if(table){
                                        let html = `
                                            <td class="table__title">Price</td>
                                            <td class="text-center dtlcompare-von-price">
                                                $${t.price / 100}
                                            </td>`
                                        ;
                                        Object.keys(compare).forEach(function(key){
                                            html += `
                                                <td class="text-center">
                                                    ${compare[key]}
                                                </td>`
                                            ;
                                        });
                                        let priceRow = table.querySelector(".dtlcompare-price");
                                        if(priceRow){
                                            priceRow.innerHTML = html;
                                        }
                                        let headHtml = `
                                            <th class="text-center dtlcompare-head">
                                            <span class="visually-hidden">Compare</span>
                                            </th>
                                            <th class="text-center dtlcompare-head">
                                            Von Diamonds<br>
                                            <small>(Best Value)</small>
                                            </th>`
                                        ;
                                        Object.keys(compare).forEach(function(key){
                                            headHtml += `
                                                <th class="text-center dtlcompare-head">
                                                    ${key}
                                                </th>`
                                            ;
                                        });
                                        let headRow = table.querySelector("tr");
                                        if(headRow){
                                            headRow.innerHTML = headHtml;
                                        }
                                        // Savings row update

                                        let savingsRow = table.querySelector(".dtlcompare-savings");
                                        if(savingsRow){
                                            let savingsHtml = `
                                                <td class="table__title">
                                                    Savings (%)
                                                </td>
                                                <td class="text-center">
                                                    <span class="greendot-icon">--</span>
                                                </td>`
                                            ;
                                            Object.keys(compare).forEach(function(key){
                                                //let price = parseFloat(compare[key].replace('$',''));
                                                let price = parseFloat(
                                                    compare[key]
                                                    .replace(/\$/g, '')
                                                    .replace(/,/g, '')
                                                    .trim()
                                                );
                                                let currentPrice = t.price / 100;
                                                let saving = "";
                                                if(currentPrice < price){
                                                    saving = Math.floor(
                                                        ((price-currentPrice)/price)*100
                                                    ) + "%";
                                                }
                                                else{
                                                    saving = "--";
                                                }
                                                savingsHtml += `
                                                    <td class="text-center">
                                                        ${saving}
                                                    </td>`
                                                ;
                                            });
                                            savingsRow.innerHTML = savingsHtml;
                                        }
                                        // Shipping update

                                        let shippingRow = table.querySelector(".dtlcompare-shipping");
                                        if(shippingRow){
                                            let shippingHtml = `
                                                <td class="table__title">
                                                    Free Shipping
                                                </td>
                                                <td class="text-center">
                                                    <span class="greendot-icon">Yes</span>
                                                </td>`
                                            ;
                                            Object.keys(compare).forEach(function(){
                                                shippingHtml += `
                                                    <td class="text-center">
                                                        Yes
                                                    </td>`
                                                ;
                                            });
                                            shippingRow.innerHTML = shippingHtml;
                                        }
                                        // Returns update
                                        let returnsRow = table.querySelector(".dtlcompare-returns");
                                        if(returnsRow){
                                            let returnsHtml = `
                                                <td class="table__title">
                                                    Free Returns
                                                </td>
                                                <td class="text-center">
                                                    <span class="greendot-icon">
                                                    30 Days
                                                    </span>
                                                </td>`
                                            ;
                                            Object.keys(compare).forEach(function(){
                                                returnsHtml += `
                                                    <td class="text-center">
                                                        30 days
                                                    </td>`
                                                ;
                                            });
                                            returnsRow.innerHTML = returnsHtml;
                                        }
                                    }
                                    if(tableSection){
                                        tableSection.style.display = 'flex';
                                    }

                                    if(window.screen.width > 767){
                                        document.querySelector('.dtllook-section').style.maxWidth = '40%';
                                    }

                                    document.querySelectorAll(".featured-col-slider").forEach(slider => {
                                        slider.querySelectorAll('.grid-product').forEach(cell => {
                                            cell.classList.add('medium-up--one-half');
                                            cell.classList.remove('small--one-half','medium-up--one-quarter');
                                        });
                                        const flkty = Flickity.data(slider);

                                        if (flkty) {
                                            flkty.resize();
                                        }
                                        document.querySelectorAll(".featured-col-slider").forEach((slider) => {
                                            if (slider.classList.contains("flickity-enabled")) {
                                                var i = true,
                                                    s = slider.querySelectorAll(".flickity-button");

                                                s.forEach((button) => {
                                                    if (!button.disabled) {
                                                        i = false;
                                                    }
                                                });
                                                if (i) {
                                                    s.forEach((button) => {
                                                        button.classList.add("hide");
                                                    });
                                                }
                                                else{
                                                    s.forEach((button) => {
                                                        button.classList.remove("hide");
                                                    });
                                                }
                                            }
                                        });
                                    });
                                }
                                else if(tableSection){
                                    // if(mainCompareSection){
                                    //     mainCompareSection.classList.add("hide");
                                    // }
                                    let compareSection = document.querySelector(".dtlcompare-section");
                                    if(compareSection){
                                        compareSection.classList.add("hide");
                                    }
                                    tableSection.style.display = 'block';
                                    
                                    document.querySelector('.dtllook-section').style.maxWidth = '100%';

                                    document.querySelectorAll(".featured-col-slider").forEach(slider => {
                                        slider.querySelectorAll('.grid-product').forEach(cell => {
                                            cell.classList.remove('medium-up--one-half');
                                            cell.classList.add('small--one-half','medium-up--one-quarter');
                                        });
                                        const flkty = Flickity.data(slider);

                                        if (flkty) {
                                            flkty.resize();
                                        }

                                        document.querySelectorAll(".featured-col-slider").forEach((slider) => {
                                            if (slider.classList.contains("flickity-enabled")) {
                                                var i = true,
                                                    s = slider.querySelectorAll(".flickity-button");

                                                s.forEach((button) => {
                                                    if (!button.disabled) {
                                                        i = false;
                                                    }
                                                });
                                                if (i) {
                                                    s.forEach((button) => {
                                                        button.classList.add("hide");
                                                    });
                                                }
                                                else{
                                                    s.forEach((button) => {
                                                        button.classList.remove("hide");
                                                    });
                                                }
                                            }
                                        });
                                    });
                                }
                                // IGS-dyanamic code- 18-06
                                /*document.querySelector(".dtlcomparelook-section") && (void 0 !== W && "" != W ? (document.querySelector(".dtlcomparelook-section").classList.remove("hide"), document.querySelector(".dtlcompare-von-price").innerHTML = "$" + t.price / 100, document.querySelector(".blue-nile-price").innerHTML = W, document.querySelector(".blue-nile-percentage").innerHTML = Q, document.querySelector(".james-allen-price").innerHTML = G, document.querySelector(".james-allen-percentage").innerHTML = X, document.querySelector(".brilliant-earth-price") && (document.querySelector(".brilliant-earth-price").innerHTML = Y, document.querySelector(".brilliant-earth-percentage").innerHTML = K)) : document.querySelector(".dtlcomparelook-section").classList.add("hide")),*/ document.querySelectorAll(".product_sku_details_section").forEach(function(e) {
                                var t = document.querySelector(".prd-dtl-field-sku");
                                t && t.classList.remove("hide"), e.innerHTML = M
                            }), document.querySelectorAll(".inline_properties_sku").forEach(function(e) {
                                e.value = M
                            }), (document.querySelector("#inline_properties_diaspark_sku").value = DS);
                            document.querySelectorAll(".metal_color_details_section").forEach(function(e) {
                                if ("" != O) {
                                    var t = document.querySelector(".prd-dtl-field-metal");
                                    t && t.classList.remove("hide"), e.innerHTML = O
                                }
                            }), document.querySelectorAll(".main_stone_count_details_section").forEach(function(e) {
                                e.innerHTML = H
                            }), document.querySelectorAll(".side_stone_1_count_details_section").forEach(function(e) {
                                e.innerHTML = D
                            }), document.querySelectorAll(".side_stone_2_count_details_section").forEach(function(e) {
                                e.innerHTML = j
                            }), document.querySelectorAll(".diamond_color.item-detail").forEach(function(e) {
                                e.innerHTML = V
                            }), document.querySelectorAll(".diamond_clarity.item-detail").forEach(function(e) {
                                e.innerHTML = F
                            }), document.querySelectorAll(".main_stone_cut.item-detail").forEach(function(e) {
                                e.innerHTML = R
                            }), document.querySelectorAll(".finding-type.item-detail").forEach(function(e) {
                                e.innerHTML = N
                            }), U && console.log("Lead Time vale", U), document.querySelectorAll(".main_stone_certified_details_section.item-detail").forEach(function(e) {
                                B ? (e.innerHTML = B, e.parentElement.style.display = "flex") : e.parentElement.style.display = "none"
                            })
                        }

                        const variant = t;
                        if (!variant) return;

                        let carat = variant.option1 || '';
                        let shape = variant.option2 || '';
                        let finalTitle = '';

                        if(carat){
                            finalTitle += carat + ' ct ';
                        }
                        if(shape){
                            finalTitle += shape + ' ';
                        }
                        finalTitle += 'Diamond';
                        const titleEl = document.querySelector('.diamond-title');
                        if(titleEl){
                            titleEl.innerHTML = finalTitle;
                        }
                        
                        this.enableHistoryState && this._updateHistoryState(t)
                    }
                },
                _getDeliveryDate: function(e) {
                    var t = ["01/01", "26/01", "03/03", "19/03", "01/05", "25/05", "03/07", "15/08", "28/08", "07/09", "14/09", "20/10", "09/11", "10/11", "11/11", "26/11", "25/12"];
                    let i = Number(e) + 1,
                        s = Number(i);
                    if (isNaN(s)) throw Error("Invalid input for numBusinessDays");
                    let n = new Date;
                    for (; s > 1;) {
                        n.setDate(n.getDate() + 1);
                        var a = n.getDate() + "/" + (n.getMonth() + 1);
                        let r = n.getDay();
                        0 !== r && 6 !== r && !1 === t.includes(a) && s--
                    }
                    0 == n.getDay() ? n.setDate(n.getDate() + 1) : 6 == n.getDay() && n.setDate(n.getDate() + 2);
                    var o = n.getDate() + "/" + (n.getMonth() + 1);
                    !1 !== t.includes(o) && (n.setDate(n.getDate() + 1), 0 == n.getDay() ? n.setDate(n.getDate() + 1) : 6 == n.getDay() && n.setDate(n.getDate() + 2));
                    let c = n.toLocaleDateString("en-US", {
                            weekday: "long",
                            day: "numeric",
                            month: "short"
                        }),
                        l = document.querySelector("#est_delv_date");
                    l && (l.innerHTML = c);
                    let d = document.querySelector("input.final_date");
                    d && (d.value = e + " Business Days")
                },
                _updateImages: function(e) {
                    var t = e.featured_image || {},
                        i = this.currentVariant && this.currentVariant.featured_image || {};
                    e.featured_image && t.src !== i.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", {
                        detail: {
                            variant: e
                        }
                    }))
                },
                _updatePrice: function(e) {
                    this.currentVariant && e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.container.dispatchEvent(new CustomEvent("variantPriceChange", {
                        detail: {
                            variant: e
                        }
                    }))
                },
                _updateUnitPrice: function(e) {
                    this.currentVariant && e.unit_price === this.currentVariant.unit_price || this.container.dispatchEvent(new CustomEvent("variantUnitPriceChange", {
                        detail: {
                            variant: e
                        }
                    }))
                },
                _updateSKU: function(e) {
                    this.currentVariant && e.sku === this.currentVariant.sku || this.container.dispatchEvent(new CustomEvent("variantSKUChange", {
                        detail: {
                            variant: e
                        }
                    }))
                },
                _updateHistoryState: function(e) {
                    if (history.replaceState && e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({
                            path: t
                        }, "", t)
                    }
                },
                _updateMasterSelect: function(e) {
                    let t = this.container.querySelector(this.originalSelectorId);
                    t && (t.value = e.id, t.dispatchEvent(new Event("change", {
                        bubbles: !0
                    })))
                }
            }), e
        }(), window.vimeoApiReady = function() {
            let e, t;
            theme.config.vimeoLoading = !0, new Promise((i, s) => {
                e = setInterval(function() {
                    Vimeo && (clearInterval(e), clearTimeout(t), i())
                }, 500), t = setTimeout(function() {
                    clearInterval(e), s()
                }, 4e3)
            }).then(function() {
                theme.config.vimeoReady = !0, theme.config.vimeoLoading = !1, document.dispatchEvent(new CustomEvent("vimeoReady"))
            })
        }, theme.VimeoPlayer = function() {
            let e = "loading",
                t = "video-interactable",
                i = {
                    byline: !1,
                    loop: !0,
                    muted: !0,
                    playsinline: !0,
                    portrait: !1,
                    title: !1
                };

            function s(e, t, i) {
                this.divId = e, this.el = document.getElementById(e), this.videoId = t, this.iframe = null, this.options = i, this.options && this.options.videoParent && (this.parent = this.el.closest(this.options.videoParent)), this.setAsLoading(), theme.config.vimeoReady ? this.init() : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady), document.addEventListener("vimeoReady", this.init.bind(this)))
            }
            return s.prototype = Object.assign({}, s.prototype, {
                init: function() {
                    let e = i;
                    e.id = this.videoId, this.videoPlayer = new Vimeo.Player(this.el, e), this.videoPlayer.ready().then(this.playerReady.bind(this))
                },
                playerReady: function() {
                    this.iframe = this.el.querySelector("iframe"), this.iframe.setAttribute("tabindex", "-1"), "false" === this.options.loop && this.videoPlayer.setLoop(!1), "sound" === this.options.style ? this.videoPlayer.setVolume(1) : this.videoPlayer.setVolume(0), this.setAsLoaded(), new IntersectionObserver((e, t) => {
                        e.forEach(e => {
                            e.isIntersecting ? this.play() : this.pause()
                        })
                    }, {
                        rootMargin: "0px 0px 50px 0px"
                    }).observe(this.iframe)
                },
                setAsLoading: function() {
                    this.parent && this.parent.classList.add(e)
                },
                setAsLoaded: function() {
                    this.parent && (this.parent.classList.remove(e), this.parent.classList.add("loaded"), this.parent.classList.add(t), Shopify && Shopify.designMode && window.AOS && AOS.refreshHard())
                },
                enableInteraction: function() {
                    this.parent && this.parent.classList.add(t)
                },
                play: function() {
                    this.videoPlayer && "function" == typeof this.videoPlayer.play && this.videoPlayer.play()
                },
                pause: function() {
                    this.videoPlayer && "function" == typeof this.videoPlayer.pause && this.videoPlayer.pause()
                },
                destroy: function() {
                    this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy()
                }
            }), s
        }(), window.onYouTubeIframeAPIReady = function() {
            theme.config.youTubeReady = !0, document.dispatchEvent(new CustomEvent("youTubeReady"))
        }, theme.YouTube = function() {
            var e = "loading",
                t = {
                    width: 1280,
                    height: 720,
                    playerVars: {
                        autohide: 0,
                        autoplay: 1,
                        cc_load_policy: 0,
                        controls: 0,
                        fs: 0,
                        iv_load_policy: 3,
                        modestbranding: 1,
                        playsinline: 1,
                        rel: 0
                    }
                };

            function i(e, i) {
                this.divId = e, this.iframe = null, this.attemptedToPlay = !1, t.events = {
                    onReady: this.onVideoPlayerReady.bind(this),
                    onStateChange: this.onVideoStateChange.bind(this)
                }, this.options = Object.assign({}, t, i), this.options && (this.options.videoParent && (this.parent = document.getElementById(this.divId).closest(this.options.videoParent)), this.options.autoplay || (this.options.playerVars.autoplay = this.options.autoplay), "sound" === this.options.style && (this.options.playerVars.controls = 1, this.options.playerVars.autoplay = 0)), this.setAsLoading(), theme.config.youTubeReady ? this.init() : (theme.LibraryLoader.load("youtubeSdk"), document.addEventListener("youTubeReady", this.init.bind(this)))
            }
            return i.prototype = Object.assign({}, i.prototype, {
                init: function() {
                    this.videoPlayer = new YT.Player(this.divId, this.options)
                },
                onVideoPlayerReady: function(e) {
                    this.iframe = document.getElementById(this.divId), this.iframe.setAttribute("tabindex", "-1"), "sound" !== this.options.style && e.target.mute(), new IntersectionObserver((e, t) => {
                        e.forEach(e => {
                            e.isIntersecting ? this.play() : this.pause()
                        })
                    }, {
                        rootMargin: "0px 0px 50px 0px"
                    }).observe(this.iframe)
                },
                onVideoStateChange: function(e) {
                    switch (e.data) {
                        case -1:
                            this.attemptedToPlay && (this.setAsLoaded(), this.enableInteraction());
                            break;
                        case 0:
                            this.play(e);
                            break;
                        case 1:
                            this.setAsLoaded();
                            break;
                        case 3:
                            this.attemptedToPlay = !0
                    }
                },
                setAsLoading: function() {
                    this.parent && this.parent.classList.add(e)
                },
                setAsLoaded: function() {
                    this.parent && (this.parent.classList.remove(e), this.parent.classList.add("loaded"), Shopify && Shopify.designMode && window.AOS && AOS.refreshHard())
                },
                enableInteraction: function() {
                    this.parent && this.parent.classList.add("video-interactable")
                },
                play: function() {
                    this.videoPlayer && "function" == typeof this.videoPlayer.playVideo && this.videoPlayer.playVideo()
                },
                pause: function() {
                    this.videoPlayer && "function" == typeof this.videoPlayer.pauseVideo && this.videoPlayer.pauseVideo()
                },
                destroy: function() {
                    this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy()
                }
            }), i
        }(), c = !1, document.body.addEventListener("touchstart", function(e) {
            if (!e.target.closest(".flickity-slider")) return c = !1;
            c = !0, o = {
                x: e.touches[0].pageX,
                y: e.touches[0].pageY
            }
        }), document.body.addEventListener("touchmove", function(e) {
            c && e.cancelable && Math.abs({
                x: e.touches[0].pageX - o.x,
                y: e.touches[0].pageY - o.y
            }.x) > Flickity.defaults.dragThreshold && e.preventDefault()
        }, {
            passive: !1
        }), theme.AjaxRenderer = function() {
            function e({
                sections: e,
                onReplace: t,
                debug: i
            } = {}) {
                this.sections = e || [], this.cachedSections = [], this.onReplace = t, this.debug = Boolean(i)
            }
            return e.prototype = Object.assign({}, e.prototype, {
                renderPage: function(e, t, i = !0) {
                    let s = new URLSearchParams(window.location.search),
                        n = this.getUpdatedParams(s, t),
                        a = this.sections.map(t => {
                            let i = `${e}?section_id=${t.sectionId}&${n.toString()}`,
                                s = e => e.url === i;
                            return this.cachedSections.some(s) ? this.renderSectionFromCache(s, t) : this.renderSectionFromFetch(i, t)
                        });
                    return i && this.updateURLHash(n), Promise.all(a)
                },
                renderSectionFromCache: function(e, t) {
                    let i = this.cachedSections.find(e);
                    return this.log(`[AjaxRenderer] rendering from cache: url=${i.url}`), this.renderSection(i.html, t), Promise.resolve(t)
                },
                renderSectionFromFetch: function(e, t) {
                    return this.log(`[AjaxRenderer] redering from fetch: url=${e}`), new Promise((i, s) => {
                        fetch(e).then(e => e.text()).then(s => {
                            let n = s;
                            this.cachedSections = [...this.cachedSections, {
                                html: n,
                                url: e
                            }], this.renderSection(n, t), i(t)
                        }).catch(e => s(e))
                    })
                },
                renderSection: function(e, t) {
                    this.log(`[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`);
                    let i = (new DOMParser).parseFromString(e, "text/html");
                    if (this.onReplace) this.onReplace(i, t);
                    else if ("string" == typeof t.nodeId) {
                        var s = i.getElementById(t.nodeId);
                        if (!s) return;
                        document.getElementById(t.nodeId).innerHTML = s.innerHTML
                    } else t.nodeId.forEach(e => {
                        document.getElementById(e).innerHTML = i.getElementById(e).innerHTML
                    });
                    return t
                },
                getUpdatedParams: function(e, t) {
                    let i = new URLSearchParams(e),
                        s = ["sort_by", "q", "options[prefix]", "type"];
                    for (let [n, a] of i.entries()) t.getAll(n).includes(a) || s.includes(n) || i.delete(n);
                    for (let [r, o] of t.entries()) i.getAll(r).includes(o) || "" === o || i.append(r, o);
                    return i
                },
                updateURLHash: function(e) {
                    history.pushState({}, "", `${window.location.pathname}${e&&"?".concat(e)}`)
                },
                log: function(...e) {
                    this.debug && console.log(...e)
                }
            }), e
        }(), window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode && navigator.sendBeacon("https://api.archetypethemes.co/api/beacon", new URLSearchParams({
            shop: window.Shopify.shop,
            themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
            role: window.Shopify.theme.role,
            route: window.location.pathname,
            themeId: window.Shopify.theme.id,
            themeStoreId: window.Shopify.theme.theme_store_id || 0,
            isThemeEditor: !!window.Shopify.designMode
        })), theme.cart = {
            getCart: function() {
                return fetch("".concat(theme.routes.cart, "?t=").concat(Date.now()), {
                    credentials: "same-origin",
                    method: "GET"
                }).then(e => e.json())
            },
            getCartProductMarkup: function() {
                var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
                return fetch(e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax", {
                    credentials: "same-origin",
                    method: "GET"
                }).then(e => e.text()).catch(e => console.error(e))
            },
            changeItem: function(e, t) {
                return this._updateCart({
                    url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
                    data: JSON.stringify({
                        id: e,
                        quantity: t
                    })
                })
            },
            _updateCart: function(e) {
                return fetch(e.url, {
                    method: "POST",
                    body: e.data,
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                        Accept: "application/json"
                    }
                }).then(e => e.text()).then(e => e)
            },
            updateAttribute: function(e, t) {
                return this._updateCart({
                    url: "/cart/update.js",
                    data: JSON.stringify({
                        attributes: {
                            [e]: theme.cart.attributeToString(t)
                        }
                    })
                })
            },
            updateNote: function(e) {
                return this._updateCart({
                    url: "/cart/update.js",
                    data: JSON.stringify({
                        note: theme.cart.attributeToString(e)
                    })
                })
            },
            attributeToString: function(e) {
                return "string" != typeof e && "undefined" == (e += "") && (e = ""), e.trim()
            }
        }, theme.CartForm = function() {
            var e = "[data-subtotal]",
                t = "btn--loading",
                i = {
                    requiresTerms: !1
                };

            function s(t) {
                t && (this.form = t, this.wrapper = t.parentNode, this.location = t.dataset.location, this.namespace = ".cart-" + this.location, this.products = t.querySelector("[data-products]"), this.submitBtn = t.querySelector(".cart__checkout"), this.discounts = t.querySelector("[data-discounts]"), this.savings = t.querySelector("[data-savings]"), this.subtotal = t.querySelector(e), this.termsCheckbox = t.querySelector(".cart__terms-checkbox"), this.noteInput = t.querySelector('[name="note"]'), this.cartItemsUpdated = !1, this.termsCheckbox && (i.requiresTerms = !0), this.init())
            }
            return s.prototype = Object.assign({}, s.prototype, {
                init: function() {
                    this.initQtySelectors(), document.addEventListener("cart:quantity" + this.namespace, this.quantityChanged.bind(this)), this.form.on("submit" + this.namespace, this.onSubmit.bind(this)), this.noteInput && this.noteInput.addEventListener("change", function() {
                        var e = this.value;
                        theme.cart.updateNote(e)
                    }), document.addEventListener("cart:build", (function() {
                        this.buildCart()
                    }).bind(this))
                },
                reInit: function() {
                    this.initQtySelectors()
                },
                onSubmit: function(e) {
                    return this.submitBtn.classList.add(t), document.documentElement.classList.contains("js-drawer-open") && this.cartItemsUpdated || document.documentElement.classList.contains("cart-open") && this.cartItemsUpdated ? (this.submitBtn.classList.remove(t), e.preventDefault(), !1) : i.requiresTerms && !this.termsCheckbox.checked ? (alert(theme.strings.cartTermsConfirmation), this.submitBtn.classList.remove(t), e.preventDefault(), !1) : void 0
                },
                _parseProductHTML: function(e) {
                    let t = document.createElement("div");
                    return t.innerHTML = e, {
                        items: t.querySelector(".cart__items"),
                        discounts: t.querySelector(".cart__discounts")
                    }
                },
                buildCart: function() {
                    theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this))
                },
                cartMarkup: function(e) {
                    var t = this._parseProductHTML(e),
                        i = t.items,
                        s = parseInt(i.dataset.count),
                        n = i.dataset.cartSubtotal,
                        a = i.dataset.cartSavings;
                    this.updateCartDiscounts(t.discounts), this.updateSavings(a), s > 0 ? this.wrapper.classList.remove("is-empty") : this.wrapper.classList.add("is-empty"), this.updateCount(s), this.products.innerHTML = "", this.products.append(i), this.subtotal.innerHTML = theme.Currency.formatMoney(n, theme.settings.moneyFormat), this.reInit(), window.AOS && AOS.refreshHard(), Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize()
                },
                updateCartDiscounts: function(e) {
                    this.discounts && (this.discounts.innerHTML = "", this.discounts.append(e))
                },
                initQtySelectors: function() {
                    this.form.querySelectorAll(".js-qty__wrapper").forEach(e => {
                        new theme.QtySelector(e, {
                            namespace: this.namespace,
                            isCart: !0
                        })
                    })
                },
                initEngravingRemove: function() {
                    var e = this;
                    $(document).on("click", ".engraving--close-link", function(t) {
                        t.preventDefault(), document.querySelector(".cart-drawer-loader").classList.remove("hidden");
                        var i = $(this).attr("data-per"),
                            s = $(".webid_" + i).closest(".cart__item").attr("data-line"),
                            n = $(this).closest(".cart__item").attr("data-line");
                        $.ajax({
                            type: "POST",
                            url: "/cart/change.js",
                            data: {
                                line: parseInt(s),
                                quantity: 0
                            },
                            dataType: "json",
                            success: function(t) {
                                console.log(t);
                                var i = parseInt(n);
                                console.log(i);
                                var s = parseInt(n) - parseInt(1);
                                console.log(s), delete t.items[s].properties["Engraving Text"];
                                var a = t.items[s].properties;
                                console.log(a), $.ajax({
                                    type: "POST",
                                    url: "/cart/change.js",
                                    data: {
                                        line: i,
                                        properties: a
                                    },
                                    dataType: "json",
                                    success: function(t) {
                                        document.querySelector(".cart-drawer-loader").classList.add("hidden"), e.buildCart()
                                    }
                                })
                            }
                        })
                    })
                },
                initEngravingAdd: function() {
                    var e = this;
                    $(document).on("click", ".cart--add-engraving", function(t) {
                        t.preventDefault(), document.querySelector(".cart-drawer-loader").classList.remove("hidden");
                        var i = $(this).attr("data-id"),
                            s = $(this).attr("data-sku"),
                            n = $(this).closest(".engraving-box").find("input.engraving-text-input").val(),
                            a = $(this).closest(".cart__item").attr("data-line"),
                            r = $(this).attr("data-pid");
                        if (!n || "" === n.trim()) return document.querySelector(".cart-drawer-loader").classList.add("hidden"), void $(".engraving--error").text("Please Enter Engraving Text");
                        $.ajax({
                            type: "POST",
                            url: "/cart/add.js",
                            data: {
                                id: i,
                                quantity: 1,
                                properties: {
                                    "Engraving Text": n.trim(),
                                    "Engraving for SKU": s
                                }
                            },
                            dataType: "json",
                            success: function(t) {
                                $.ajax({
                                    type: "GET",
                                    url: "/cart.js",
                                    dataType: "json",
                                    success: function(t) {
                                        var i = parseInt(a),
                                            s = {
                                                ...t.items[i].properties,
                                                "Engraving Text": n
                                            };
                                        $.ajax({
                                            type: "POST",
                                            url: "/cart/add.js",
                                            data: {
                                                id: r,
                                                quantity: 1,
                                                properties: s
                                            },
                                            dataType: "json",
                                            success: function(t) {
                                                $.ajax({
                                                    type: "GET",
                                                    url: "/cart.js",
                                                    dataType: "json",
                                                    success: function(t) {
                                                        var i = parseInt(a) + parseInt(2),
                                                            s = parseInt(a) + parseInt(1),
                                                            n = parseInt(t.items[s].quantity) - parseInt(1);
                                                        $.ajax({
                                                            type: "POST",
                                                            url: "/cart/change.js",
                                                            data: {
                                                                line: i,
                                                                quantity: n
                                                            },
                                                            dataType: "json",
                                                            success: function(t) {
                                                                document.querySelector(".cart-drawer-loader").classList.add("hidden"), e.buildCart()
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    },
                                    error: function(e, t, i) {
                                        console.error("Error fetching cart data:", i)
                                    }
                                })
                            }
                        })
                    })
                },
                quantityChanged: function(e) {
                    var t = e.detail[0],
                        i = e.detail[1],
                        s = e.detail[2];
                    t && i && (s && s.classList.add("is-loading"), theme.cart.changeItem(t, i).then((function(i) {
                        let s = JSON.parse(i);
                        if (422 === s.status) alert(s.message);
                        else {
                            let n = s.items.find(e => e.key === t);
                            n && ("cart:quantity.cart-cart-drawer" === e.type || "cart:quantity.cart-header" === e.type) && (this.cartItemsUpdated = !0), (n && "cart:quantity.cart-cart-drawer" === e.type || n && "cart:quantity.cart-header" === e.type) && (n.quantity, this.cartItemsUpdated = !1), s.item_count > 0 ? this.wrapper.classList.remove("is-empty") : this.wrapper.classList.add("is-empty")
                        }
                        this.buildCart(), document.dispatchEvent(new CustomEvent("cart:updated", {
                            detail: {
                                cart: s
                            }
                        }))
                    }).bind(this)).catch(function(e) {}))
                },
                updateSubtotal: function(t) {
                    this.form.querySelector(e).innerHTML = theme.Currency.formatMoney(t, theme.settings.moneyFormat)
                },
                updateSavings: function(e) {
                    if (this.savings) {
                        if (e > 0) {
                            var t = theme.Currency.formatMoney(e, theme.settings.moneyFormat);
                            this.savings.classList.remove("hide"), this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", t)
                        } else this.savings.classList.add("hide")
                    }
                },
                updateCount: function(e) {
                    var t = document.querySelectorAll(".cart-link__bubble-num, .cart-header-right-count");
                    t.length && t.forEach(t => {
                        t.innerText = e
                    });
                    var i = document.querySelectorAll(".cart-link__bubble");
                    i.length && (e > 0 ? i.forEach(e => {
                        e.classList.add("cart-link__bubble--visible")
                    }) : i.forEach(e => {
                        e.classList.remove("cart-link__bubble--visible")
                    }))
                }
            }), s
        }(), theme.collapsibles = function() {
            var e = ".collapsible-content__inner",
                t = "is-open",
                i = ".collapsible",
                s = !1;

            function n(n) {
                if (!s) {
                    s = !0;
                    var r = n.currentTarget,
                        o = r.classList.contains(t),
                        c = r.classList.contains("collapsible-trigger--tab"),
                        l = r.getAttribute("aria-controls"),
                        d = document.getElementById(l);
                    if (l || (l = r.dataset.controls), l) {
                        if (d || document.querySelectorAll('[data-id="' + l + '"]').length > 0 && (d = r.parentNode.querySelector('[data-id="' + l + '"]')), d) {
                            var u = d.querySelector(e).offsetHeight,
                                h = d.classList.contains("collapsible--auto-height"),
                                p = d.parentNode.closest(".collapsible-content"),
                                m = u;
                            if (c) {
                                if (o) return void(s = !1);
                                document.querySelectorAll('.collapsible-trigger--tab[data-id="' + r.dataset.id + '"]').forEach(e => {
                                    e.classList.remove(t), a(document.querySelector("#" + e.getAttribute("aria-controls")), 0, !0)
                                })
                            }
                            if (o && h && setTimeout(function() {
                                    a(d, u = 0, o, h)
                                }, 0), o && !h && (u = 0), r.setAttribute("aria-expanded", !o), o ? r.classList.remove(t) : r.classList.add(t), a(d, u, o, h), p) {
                                var g = p.style.height;
                                o && "auto" === g && (m = 0), a(p, o ? p.offsetHeight - m : u + p.offsetHeight, !1, !1)
                            }
                            if (window.SPR) {
                                var f = d.querySelector(".spr-summary-actions-newreview");
                                if (!f) return;
                                f.off("click" + i), f.on("click" + i, function() {
                                    u = d.querySelector(e).offsetHeight, a(d, u, o, h)
                                })
                            }
                        } else s = !1
                    }
                }
            }

            function a(e, i, n, a) {
                if (e.classList.remove("hide"), theme.utils.prepareTransition(e, function() {
                        e.style.height = i + "px", n ? e.classList.remove(t) : e.classList.add(t)
                    }), !n && a) {
                    var r = e;
                    window.setTimeout(function() {
                        r.css("height", "auto"), s = !1
                    }, 500)
                } else s = !1
            }
            return {
                init: function(e) {
                    (e || document).querySelectorAll(".collapsible-trigger").forEach(e => {
                        var s = e.classList.contains(t);
                        e.setAttribute("aria-expanded", s), e.off("click" + i), e.on("click" + i, n)
                    })
                }
            }
        }(), theme.Disclosure = function() {
            var e = "disclosure-list--visible";

            function t(e) {
                this.container = e, this._cacheSelectors(), this._setupListeners()
            }
            return t.prototype = Object.assign({}, t.prototype, {
                _cacheSelectors: function() {
                    this.cache = {
                        disclosureForm: this.container.closest("[data-disclosure-form]"),
                        disclosureList: this.container.querySelector("[data-disclosure-list]"),
                        disclosureToggle: this.container.querySelector("[data-disclosure-toggle]"),
                        disclosureInput: this.container.querySelector("[data-disclosure-input]"),
                        disclosureOptions: this.container.querySelectorAll("[data-disclosure-option]")
                    }
                },
                _setupListeners: function() {
                    this.eventHandlers = this._setupEventHandlers(), this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList), this.cache.disclosureOptions.forEach(function(e) {
                        e.addEventListener("click", this.eventHandlers.connectOptions)
                    }, this), this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.addEventListener("click", this.eventHandlers.onBodyClick)
                },
                _setupEventHandlers: function() {
                    return {
                        connectOptions: this._connectOptions.bind(this),
                        toggleList: this._toggleList.bind(this),
                        onBodyClick: this._onBodyClick.bind(this),
                        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
                    }
                },
                _connectOptions: function(e) {
                    e.preventDefault(), this._submitForm(e.currentTarget.dataset.value)
                },
                _onDisclosureToggleFocusOut: function(e) {
                    !1 === this.container.contains(e.relatedTarget) && this._hideList()
                },
                _onDisclosureListFocusOut: function(t) {
                    var i = t.currentTarget.contains(t.relatedTarget);
                    this.cache.disclosureList.classList.contains(e) && !i && this._hideList()
                },
                _onDisclosureKeyUp: function(e) {
                    27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus())
                },
                _onBodyClick: function(t) {
                    var i = this.container.contains(t.target);
                    this.cache.disclosureList.classList.contains(e) && !i && this._hideList()
                },
                _submitForm: function(e) {
                    this.cache.disclosureInput.value = e, this.cache.disclosureForm.submit()
                },
                _hideList: function() {
                    this.cache.disclosureList.classList.remove(e), this.cache.disclosureToggle.setAttribute("aria-expanded", !1)
                },
                _toggleList: function() {
                    var t = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                    this.cache.disclosureList.classList.toggle(e), this.cache.disclosureToggle.setAttribute("aria-expanded", !t)
                },
                destroy: function() {
                    this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList), this.cache.disclosureOptions.forEach(function(e) {
                        e.removeEventListener("click", this.eventHandlers.connectOptions)
                    }, this), this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.removeEventListener("click", this.eventHandlers.onBodyClick)
                }
            }), t
        }(), theme.Drawers = function() {
            function e(e, t) {
                this.config = {
                    id: e,
                    close: ".js-drawer-close",
                    open: ".js-drawer-open-" + t,
                    openClass: "js-drawer-open",
                    closingClass: "js-drawer-closing",
                    activeDrawer: "drawer--is-open",
                    namespace: ".drawer-" + t
                }, this.nodes = {
                    page: document.querySelector("#MainContent")
                }, this.drawer = document.querySelector("#" + e), this.isOpen = !1, this.drawer && this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    document.querySelectorAll(this.config.open).forEach(e => {
                        e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this))
                    }), this.drawer.querySelector(this.config.close).addEventListener("click", this.close.bind(this)), document.addEventListener("modalOpen", (function() {
                        this.close()
                    }).bind(this))
                },
                open: function(e, t) {
                    if (e && e.preventDefault(), !this.isOpen) {
                        e && e.stopPropagation ? (e.stopPropagation(), e.currentTarget.setAttribute("aria-expanded", "true"), this.activeSource = e.currentTarget) : t && (t.setAttribute("aria-expanded", "true"), this.activeSource = t), theme.utils.prepareTransition(this.drawer, (function() {
                            this.drawer.classList.add(this.config.activeDrawer);
                            var e = document.querySelector("[data-add-to-cart]");
                            e && window.screen.width <= 768 && e.classList.contains("sticky-bottom") && e.classList.remove("sticky-bottom")
                        }).bind(this)), document.documentElement.classList.add(this.config.openClass), this.isOpen = !0, theme.a11y.trapFocus({
                            container: this.drawer,
                            namespace: "drawer_focus"
                        }), document.dispatchEvent(new CustomEvent("drawerOpen")), document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)), this.bindEvents();
                        var i = document.querySelector(".flashsale-slider");
                        if (i) {
                            var s = i.querySelectorAll(".cart-flash-sale");
                            s.length > 0 && (s.length > 1 ? new Flickity(i, {
                                prevNextButtons: !1,
                                pageDots: !0,
                                fade: !0,
                                setGallerySize: !1,
                                initialIndex: 0,
                                lazyLoad: !0,
                                autoPlay: 3e3,
                                contain: !0,
                                freeScroll: !0,
                                wrapAround: !0,
                                imagesLoaded: !0
                            }) : s[0].classList.add("is-selected"))
                        }
                    }
                },
                close: function(e) {
                    if (this.isOpen) {
                        if (e) {
                            if (e.target.closest(".js-drawer-close"));
                            else if (e.target.closest(".drawer")) return
                        }
                        document.activeElement.blur(), theme.utils.prepareTransition(this.drawer, (function() {
                            this.drawer.classList.remove(this.config.activeDrawer)
                        }).bind(this)), document.documentElement.classList.remove(this.config.openClass), document.documentElement.classList.add(this.config.closingClass), window.setTimeout((function() {
                            document.documentElement.classList.remove(this.config.closingClass), this.activeSource && this.activeSource.getAttribute("aria-expanded") && (this.activeSource.setAttribute("aria-expanded", "false"), this.activeSource.focus())
                        }).bind(this), 500), this.isOpen = !1, theme.a11y.removeTrapFocus({
                            container: this.drawer,
                            namespace: "drawer_focus"
                        }), this.unbindEvents()
                    }
                },
                bindEvents: function() {
                    window.on("click" + this.config.namespace, (function(e) {
                        this.close(e)
                    }).bind(this)), window.on("keyup" + this.config.namespace, (function(e) {
                        27 === e.keyCode && this.close()
                    }).bind(this)), theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page)
                },
                unbindEvents: function() {
                    window.off("click" + this.config.namespace), window.off("keyup" + this.config.namespace), theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page)
                }
            }), e
        }(), theme.Modals = function() {
            function e(e, t, i) {
                if (this.id = e, this.modal = document.getElementById(e), !this.modal) return !1;
                this.modalContent = this.modal.querySelector(".modal__inner"), this.config = Object.assign({
                    close: ".js-modal-close",
                    open: ".js-modal-open-" + t,
                    openClass: "modal--is-active",
                    closingClass: "modal--is-closing",
                    bodyOpenClass: ["modal-open"],
                    bodyOpenSolidClass: "modal-open--solid",
                    bodyClosingClass: "modal-closing",
                    closeOffContentClick: !0
                }, i), this.modalIsOpen = !1, this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal, this.isSolid = this.config.solid, this.init()
            }
            return e.prototype.init = function() {
                document.querySelectorAll(this.config.open).forEach(e => {
                    e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this))
                }), this.modal.querySelectorAll(this.config.close).forEach(e => {
                    e.addEventListener("click", this.close.bind(this))
                }), document.addEventListener("drawerOpen", (function() {
                    this.close()
                }).bind(this))
            }, e.prototype.open = function(e) {
                var t = !1;
                this.modalIsOpen || (e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.activeSource = e.currentTarget.setAttribute("aria-expanded", "true")), this.modalIsOpen && !t && this.close(), this.modal.classList.add(this.config.openClass), document.documentElement.classList.add(...this.config.bodyOpenClass), this.isSolid && document.documentElement.classList.add(this.config.bodyOpenSolidClass), this.modalIsOpen = !0, setTimeout(() => {
                    theme.a11y.trapFocus({
                        container: this.modal,
                        elementToFocus: this.focusOnOpen,
                        namespace: "modal_focus"
                    })
                }, 100), document.dispatchEvent(new CustomEvent("modalOpen")), document.dispatchEvent(new CustomEvent("modalOpen." + this.id)), this.bindEvents())
            }, e.prototype.close = function(e) {
                if (this.modalIsOpen) {
                    if (e) {
                        if (e.target.closest(".js-modal-close"));
                        else if (e.target.closest(".modal__inner")) return
                    }
                    document.activeElement.blur(), this.modal.classList.remove(this.config.openClass), this.modal.classList.add(this.config.closingClass), document.documentElement.classList.remove(...this.config.bodyOpenClass), document.documentElement.classList.add(this.config.bodyClosingClass), window.setTimeout((function() {
                        document.documentElement.classList.remove(this.config.bodyClosingClass), this.modal.classList.remove(this.config.closingClass), this.activeSource && this.activeSource.getAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "false").focus()
                    }).bind(this), 500), this.isSolid && document.documentElement.classList.remove(this.config.bodyOpenSolidClass), this.modalIsOpen = !1, theme.a11y.removeTrapFocus({
                        container: this.modal,
                        namespace: "modal_focus"
                    }), document.dispatchEvent(new CustomEvent("modalClose." + this.id)), this.unbindEvents()
                }
            }, e.prototype.bindEvents = function() {
                window.on("keyup.modal", (function(e) {
                    27 === e.keyCode && this.close()
                }).bind(this)), this.config.closeOffContentClick && this.modal.on("click.modal", this.close.bind(this))
            }, e.prototype.unbindEvents = function() {
                document.documentElement.off(".modal"), this.config.closeOffContentClick && this.modal.off(".modal")
            }, e
        }();
        class l extends HTMLElement {
            constructor() {
                super(), this.parallaxImage = this.querySelector("[data-parallax-image]"), this.windowInnerHeight = window.innerHeight, this.isActive = !1, this.timeout = null, this.directionMap = {
                    right: 0,
                    top: 90,
                    left: 180,
                    bottom: 270
                }, this.directionMultipliers = {
                    0: [1, 0],
                    90: [0, -1],
                    180: [-1, 0],
                    270: [0, 1]
                }, this.init(), window.addEventListener("scroll", () => this.scrollHandler())
            }
            getParallaxInfo() {
                let {
                    width: e,
                    height: t,
                    top: i
                } = this.parallaxImage.getBoundingClientRect(), s, n = this.parallaxImage, {
                    angle: a,
                    movement: r
                } = n.dataset, o = "top" === a ? Math.ceil(t * (parseFloat(r) / 100)) : Math.ceil(e * (parseFloat(r) / 100));
                (a = this.directionMap[a] ?? parseFloat(a)) != a && (a = 270), o != o && (o = 100), (a %= 360) < 0 && (a += 360);
                let c = a > 90 && a < 270,
                    l = a < 180;
                if (n.style[c ? "left" : "right"] = 0, n.style[l ? "top" : "bottom"] = 0, a % 90) {
                    let d = a * Math.PI / 180;
                    s = [Math.cos(d), -1 * Math.sin(d)]
                } else s = this.directionMultipliers[a];
                return s[0] && (n.style.width = `calc(100% + ${o*Math.abs(s[0])}px)`), s[1] && (n.style.height = `calc(100% + ${o*Math.abs(s[1])}px)`), {
                    element: n,
                    movementPixels: o,
                    multipliers: s,
                    top: i,
                    height: t
                }
            }
            init() {
                let {
                    element: e,
                    movementPixels: t,
                    multipliers: i,
                    top: s,
                    height: n
                } = this.getParallaxInfo(), a = (this.windowInnerHeight - s) / (this.windowInnerHeight + n);
                if (a > -.1 && a < 1.1) {
                    let r = Math.min(Math.max(a, 0), 1) * t;
                    e.style.transform = `translate3d(${r*i[0]}px, ${r*i[1]}px, 0)`
                }
                this.isActive && requestAnimationFrame(this.init.bind(this))
            }
            scrollHandler() {
                this.isActive ? clearTimeout(this.timeout) : (this.isActive = !0, requestAnimationFrame(this.init.bind(this))), this.timeout = setTimeout(() => this.isActive = !1, 20)
            }
        }
        if (customElements.define("parallax-image", l), void 0 === window.noUiSlider) throw Error("theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js");
        theme.PriceRange = function() {
            function e(e, {
                onChange: t,
                onUpdate: i,
                ...s
            } = {}) {
                return this.container = e, this.onChange = t, this.onUpdate = i, this.sliderOptions = s || {}, this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    if (!this.container.classList.contains("price-range")) throw Error("You must instantiate PriceRange with a valid container");
                    return this.formEl = this.container.closest("form"), this.sliderEl = this.container.querySelector(".price-range__slider"), this.inputMinEl = this.container.querySelector(".price-range__input-min"), this.inputMaxEl = this.container.querySelector(".price-range__input-max"), this.displayMinEl = this.container.querySelector(".price-range__display-min"), this.displayMaxEl = this.container.querySelector(".price-range__display-max"), this.minRange = parseFloat(this.container.dataset.min) || 0, this.minValue = parseFloat(this.container.dataset.minValue) || 0, this.maxRange = parseFloat(this.container.dataset.max) || 100, this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange, this.createPriceRange()
                },
                createPriceRange: function() {
                    this.sliderEl && this.sliderEl.noUiSlider && "function" == typeof this.sliderEl.noUiSlider.destroy && this.sliderEl.noUiSlider.destroy();
                    let e = noUiSlider.create(this.sliderEl, {
                        connect: !0,
                        step: 10,
                        ...this.sliderOptions,
                        start: [this.minValue, this.maxValue],
                        range: {
                            min: this.minRange,
                            max: this.maxRange
                        }
                    });
                    e.on("update", e => {
                        this.inputMinEl.value = theme.Currency.formatMoney(e[0], theme.settings.moneyFormat).split(".")[0], this.inputMaxEl.value = theme.Currency.formatMoney(e[1], theme.settings.moneyFormat).split(".")[0], this.onUpdate && this.onUpdate(e)
                    });
                    let t = this;

                    function i(e = null) {
                        let i = new FormData(t.formEl),
                            s = document.getElementById("diamond-feed-table_processing");
                        s && (s.style.display = "flex"), window.formChangeTriggered || (t.onChange(i), window.formChangeTriggered = !0, setTimeout(() => {
                            s && (s.style.display = "none")
                        }, 2500))
                    }

                    function s(e) {
                        ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Enter"].includes(e.key) ? "Enter" === e.key && i() : e.preventDefault()
                    }

                    function n(e) {
                        e.target.value = e.target.value.replace("$", "").replaceAll(",", "")
                    }
                    return window.formChangeTriggered = !1, e.on("change", e => {
                        this.inputMinEl.value = theme.Currency.formatMoney(e[0], theme.settings.moneyFormat).split(".")[0], this.inputMaxEl.value = theme.Currency.formatMoney(e[1], theme.settings.moneyFormat).split(".")[0];
                        let t = document.getElementById("diamond-feed-table_processing");
                        t && (t.style.display = "flex"), this.onChange && i(), setTimeout(() => {
                            t && (t.style.display = "none")
                        }, 2500)
                    }), this.inputMinEl.addEventListener("focusout", i), this.inputMaxEl.addEventListener("focusout", i), this.inputMinEl.addEventListener("keypress", s), this.inputMaxEl.addEventListener("keypress", s), this.inputMinEl.addEventListener("focusin", n), this.inputMaxEl.addEventListener("focusin", n), e
                }
            }), e
        }(), theme.AjaxProduct = function() {
            var e = {
                loading: !1
            };

            function t(e, t, i) {
                this.form = e, this.args = i, this.form && (this.addToCart = e.querySelector(t || ".add-to-cart"), this.form.addEventListener("submit", this.addItemFromForm.bind(this)))
            }
            return t.prototype = Object.assign({}, t.prototype, {
                addItemFromForm: function(t, i) {
                    if (t.preventDefault(), e.loading) return;
                     const input = document.querySelector('.ring_size_dropdown-js');
                    if (input && ShopifyAnalytics.meta.product.type !== 'Loose Diamonds') {
                      var selectvValue = input.value;
                      if(selectvValue==''){
                        input.setCustomValidity('Please select a size');
                        input.reportValidity(); // 👈 forces browser error
                        return;
                      }
                    }
                    this.addToCart.classList.add("btn--loading"), e.loading = !0;
                    var s = theme.utils.serialize(this.form);
                    let n = decodeURIComponent(s),
                        a = {};
                    n.split("&").forEach(e => {
                        let [t, i] = e.split("=");
                        a[t] = i
                    });
                    let r = [];
                    for (let o in a) o.startsWith("items[0]") && r.push(`${encodeURIComponent(o)}=${encodeURIComponent(a[o])}`);
                    for (let c in a) c.startsWith("items[0]") || r.push(`${encodeURIComponent(c)}=${encodeURIComponent(a[c])}`);
                    s = r.join("&"), fetch(theme.routes.cartAdd, {
                        method: "POST",
                        body: s,
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(e => e.json()).then((function(t) {
                        if (422 === t.status) this.error(t);
                        else {
                            rdt("track", "AddToCart", {
                                url: window.location.href,
                                value: (t.items[0].price / 100).toFixed(2),
                                currency: Shopify.currency.active,
                                products: [{
                                    id: t.items[0].product_id,
                                    name: t.items[0].product_title,
                                    category: t.items[0].product_type,
                                    quantity: t.items[0].quantity
                                }]
                            });
                            var i = t.items[0].product_id;
                            document.querySelector(".cart-flash-prd-" + i) && document.querySelector(".cart-flash-prd-" + i).remove();
                            var s = parseInt(document.querySelector(".cart-header-right-count").innerHTML) + 1;
                            document.querySelector(".cart-header-right-count").innerHTML = s;
                            document.querySelector(".qty-cart.cart-header-right-count").innerHTML = s, this.success(t)
                        }
                        e.loading = !1, this.addToCart.classList.remove("btn--loading"), document.body.classList.contains("template-cart") && (window.scrollTo(0, 0), location.reload())
                    }).bind(this))
                },
                success: function(e) {
                    var t = this.form.querySelector(".errors");
                    t && t.remove(), this.form.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                        detail: {
                            product: e,
                            addToCartBtn: this.addToCart
                        },
                        bubbles: !0
                    })), this.args && this.args.scopedEventId && document.dispatchEvent(new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
                        detail: {
                            product: e,
                            addToCartBtn: this.addToCart
                        }
                    }))
                },
                error: function(e) {
                    if (e.description) {
                        var t = this.form.querySelector(".errors");
                        t && t.remove();
                        var i = document.createElement("div");
                        i.classList.add("errors", "text-center"), "object" == typeof e.description ? i.textContent = e.message : i.textContent = e.description, this.form.append(i), this.form.dispatchEvent(new CustomEvent("ajaxProduct:error", {
                            detail: {
                                errorMessage: e.description
                            },
                            bubbles: !0
                        })), this.args && this.args.scopedEventId && document.dispatchEvent(new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
                            detail: {
                                errorMessage: e.description
                            }
                        }))
                    } else console.warn(e)
                }
            }), t
        }(), theme.ProductMedia = function() {
            var e = {},
                t = {},
                i = {};

            function s(e) {
                if (!e) {
                    for (var i in t)
                        if (t.hasOwnProperty(i)) {
                            var s = t[i];
                            !s.modelViewerUi && Shopify && (s.modelViewerUi = new Shopify.ModelViewerUI(s.element)), n(s)
                        }
                }
            }

            function n(e) {
                var t = i[e.sectionId];
                e.container.addEventListener("mediaVisible", function(i) {
                    t.element.setAttribute("data-shopify-model3d-id", e.modelId), theme.config.isTouch || i.detail.autoplayMedia && e.modelViewerUi.play()
                }), e.container.addEventListener("mediaHidden", function() {
                    t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause()
                }), e.container.addEventListener("xrLaunch", function() {
                    e.modelViewerUi.pause()
                })
            }
            return {
                init: function(n, a) {
                    e[a] = {
                        loaded: !1
                    }, n.forEach(function(e, s) {
                        var n = e.dataset.mediaId,
                            r = e.querySelector("model-viewer"),
                            o = r.dataset.modelId;
                        if (0 === s) {
                            var c = e.closest("[data-product-single-media-group]").querySelector("[data-shopify-xr]");
                            i[a] = {
                                element: c,
                                defaultId: o
                            }
                        }
                        t[n] = {
                            modelId: o,
                            sectionId: a,
                            container: e,
                            element: r
                        }
                    }), window.Shopify.loadFeatures([{
                        name: "shopify-xr",
                        version: "1.0",
                        onLoad: function t(i) {
                            if (!i) {
                                if (window.ShopifyXR) {
                                    for (var s in e)
                                        if (e.hasOwnProperty(s)) {
                                            var n = e[s];
                                            if (n.loaded) continue;
                                            var a = document.querySelector("#ModelJson-" + s);
                                            window.ShopifyXR.addModels(JSON.parse(a.innerHTML)), n.loaded = !0
                                        } window.ShopifyXR.setupXRElements()
                                } else document.addEventListener("shopify_xr_initialized", function() {
                                    t()
                                })
                            }
                        }
                    }, {
                        name: "model-viewer-ui",
                        version: "1.0",
                        onLoad: s
                    }]), theme.LibraryLoader.load("modelViewerUiStyles")
                },
                removeSectionModels: function(i) {
                    for (var s in t) t.hasOwnProperty(s) && t[s].sectionId === i && delete t[s];
                    delete e[i]
                }
            }
        }(), theme.QtySelector = function() {
            function e(e, t) {
                this.wrapper = e, this.plus = e.querySelector(".js-qty__adjust--plus"), this.minus = e.querySelector(".js-qty__adjust--minus"), this.input = e.querySelector(".js-qty__num"), this.minValue = this.input.getAttribute("min") || 1;
                var i = {
                    namespace: null,
                    isCart: !1,
                    key: this.input.dataset.id
                };
                this.options = Object.assign({}, i, t), this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    this.plus.addEventListener("click", (function() {
                        var e = this._getQty();
                        this._change(e + 1)
                    }).bind(this)), this.minus.addEventListener("click", (function(e) {
                        var t = this._getQty();
                        this._change(t - 1);
                        var i = document.querySelector(".cart-page-loader"),
                            s = document.querySelector(".cart-drawer-loader");
                        i && i.classList.remove("hidden"), s && s.classList.remove("hidden"), this.input.getAttribute("data-webid");
                        var n = this.input.getAttribute("data-new-id"),
                            a = this.input.getAttribute("data-per");
                        setTimeout(function() {
                            i && i.classList.add("hidden"), s && s.classList.add("hidden")
                        }, 1600), document.querySelector(".qty-input-" + n) ? setTimeout(function() {
                            var e = document.querySelector(".minus--qty_" + n);
                            e && e.click(), i && i.classList.add("hidden"), s && s.classList.add("hidden")
                        }, 800) : setTimeout(function() {
                            var e = document.querySelector(".minus--" + a);
                            e && e.click(), i && i.classList.add("hidden"), s && s.classList.add("hidden")
                        }, 800)
                    }).bind(this)), this.input.addEventListener("change", (function(e) {
                        this._change(this._getQty())
                    }).bind(this))
                },
                _getQty: function() {
                    var e = this.input.value;
                    return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e)
                },
                _change: function(e) {
                    e <= this.minValue && (e = this.minValue), this.input.value = e, this.options.isCart && document.dispatchEvent(new CustomEvent("cart:quantity" + this.options.namespace, {
                        detail: [this.options.key, e, this.wrapper]
                    }))
                }
            }), e
        }(), theme.initQuickShop = function() {
            var e = document.querySelectorAll(".grid-product");

            function t(e) {
                var i = e.currentTarget;
                if (!theme.config.bpSmall) {
                    if (i.removeEventListener("mouseover", t), i.removeEventListener("focusin", t), !i || !i.dataset.productId) return;
                    var s = i.dataset.productId,
                        n = i.dataset.productHandle,
                        a = i.querySelector(".quick-product__btn");
                    theme.preloadProductModal(n, s, a)
                }
            }
            e.length && theme.settings.quickView && e.forEach(e => {
                e.addEventListener("mouseover", t), e.addEventListener("focusin", t)
            })
        }, theme.preloadProductModal = function(e, t, i) {
            var s = document.getElementById("QuickShopHolder-" + e),
                n = theme.routes.home + "/products/" + e + "?view=modal";
            fetch(n = n.replace("//", "/")).then(e => e.text()).then(n => {
                let a = document.createElement("div");
                a.innerHTML = n;
                let r = a.querySelector('.product-section[data-product-handle="' + e + '"]');
                s && (s.innerHTML = "", s.append(r), new theme.Modals("QuickShopModal-" + t, "quick-modal-" + t), theme.sections.register("product", theme.Product, s), theme.collapsibles.init(), theme.videoModal(), i && i.classList.remove("quick-product__btn--not-ready"))
            })
        }, theme.Slideshow = function() {
            var e = "animate-out",
                t = "is-paused",
                i = "is-active",
                s = ".is-selected",
                n = {
                    adaptiveHeight: !1,
                    autoPlay: !1,
                    avoidReflow: !1,
                    childNav: null,
                    childNavScroller: null,
                    childVertical: !1,
                    dragThreshold: 7,
                    fade: !1,
                    friction: .8,
                    initialIndex: 0,
                    pageDots: !1,
                    pauseAutoPlayOnHover: !1,
                    prevNextButtons: !1,
                    rightToLeft: theme.config.rtl,
                    selectedAttraction: .14,
                    setGallerySize: !0,
                    wrapAround: !0
                };

            function a(e, t) {
                if (this.el = e, this.args = Object.assign({}, n, t), this.args.on = {
                        ready: this.init.bind(this),
                        change: this.slideChange.bind(this),
                        settle: this.afterChange.bind(this)
                    }, this.args.childNav && (this.childNavEls = this.args.childNav.querySelectorAll(".product__thumb-item:not(.hide)"), this.childNavLinks = this.args.childNav.querySelectorAll(".product__thumb-item:not(.hide) a"), this.arrows = this.args.childNav.querySelectorAll(".product__thumb-arrow"), this.childNavLinks.length && this.initChildNav()), this.args.avoidReflow && function(e) {
                        if (e.id) {
                            for (var t = e.firstChild; null != t && 3 == t.nodeType;) t = t.nextSibling;
                            var i = document.createElement("style");
                            t ? i.innerHTML = `#${e.id} .flickity-viewport{height:${t.offsetHeight}px}` : i.innerHTML = '', document.head.appendChild(i)
                        }
                    }(e), this.slideshow = new Flickity(e, this.args), e.dataset.zoom && "true" === e.dataset.zoom && (this.slideshow.on("dragStart", () => {
                        this.slideshow.slider.style.pointerEvents = "none", this.slideshow.options.fade && (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "none")
                    }), this.slideshow.on("dragEnd", () => {
                        this.slideshow.slider.style.pointerEvents = "auto", this.slideshow.options.fade && (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "auto")
                    })), this.args.autoPlay) {
                    var i = e.closest(".slideshow-wrapper");
                    this.pauseBtn = i.querySelector(".slideshow__pause"), this.pauseBtn && this.pauseBtn.addEventListener("click", this._togglePause.bind(this))
                }
                window.on("resize", theme.utils.debounce(300, (function() {
                    this.resize()
                }).bind(this)))
            }
            return a.prototype = Object.assign({}, a.prototype, {
                init: function(e) {
                    this.currentSlide = this.el.querySelector(s), this.args.callbacks && this.args.callbacks.onInit && "function" == typeof this.args.callbacks.onInit && this.args.callbacks.onInit(this.currentSlide), window.AOS && AOS.refresh()
                },
                slideChange: function(t) {
                    this.args.fade && this.currentSlide && (this.currentSlide.classList.add(e), this.currentSlide.addEventListener("transitionend", (function() {
                        this.currentSlide.classList.remove(e)
                    }).bind(this))), this.args.childNav && this.childNavGoTo(t), this.args.callbacks && this.args.callbacks.onChange && "function" == typeof this.args.callbacks.onChange && this.args.callbacks.onChange(t), this.arrows && this.arrows.length && (this.arrows[0].classList.toggle("hide", 0 === t), this.arrows[1].classList.toggle("hide", t === this.childNavLinks.length - 1))
                },
                afterChange: function(t) {
                    this.args.fade && this.el.querySelectorAll(".slideshow__slide").forEach(t => {
                        t.classList.remove(e)
                    }), this.currentSlide = this.el.querySelector(s), this.args.childNav && this.childNavGoTo(this.slideshow.selectedIndex)
                },
                destroy: function() {
                    this.args.childNav && this.childNavLinks.length && this.childNavLinks.forEach(e => {
                        e.classList.remove(i)
                    }), this.slideshow.destroy()
                },
                reposition: function() {
                    this.slideshow.reposition()
                },
                _togglePause: function() {
                    this.pauseBtn.classList.contains(t) ? (this.pauseBtn.classList.remove(t), this.slideshow.playPlayer()) : (this.pauseBtn.classList.add(t), this.slideshow.pausePlayer())
                },
                resize: function() {
                    this.slideshow.resize()
                },
                play: function() {
                    this.slideshow.playPlayer()
                },
                pause: function() {
                    this.slideshow.pausePlayer()
                },
                goToSlide: function(e) {
                    this.slideshow.select(e)
                },
                setDraggable: function(e) {
                    this.slideshow.options.draggable = e, this.slideshow.updateDraggable()
                },
                initChildNav: function() {
                    this.childNavLinks[this.args.initialIndex].classList.add("is-active"), this.childNavLinks.forEach((e, t) => {
                        e.setAttribute("data-index", t), e.addEventListener("click", (function(e) {
                            e.preventDefault(), this.goToSlide(this.getChildIndex(e.currentTarget))
                        }).bind(this)), e.addEventListener("focus", (function(e) {
                            this.goToSlide(this.getChildIndex(e.currentTarget))
                        }).bind(this)), e.addEventListener("keydown", (function(e) {
                            13 === e.keyCode && this.goToSlide(this.getChildIndex(e.currentTarget))
                        }).bind(this))
                    }), this.arrows.length && this.arrows.forEach(e => {
                        e.addEventListener("click", this.arrowClick.bind(this))
                    })
                },
                getChildIndex: function(e) {
                    return parseInt(e.dataset.index)
                },
                childNavGoTo: function(e) {
                    this.childNavLinks.forEach(e => {
                        e.blur(), e.classList.remove(i)
                    });
                    var t = this.childNavLinks[e];
                    if (t.classList.add(i), this.args.childNavScroller) {
                        if (this.args.childVertical) {
                            var s = t.offsetTop;
                            this.args.childNavScroller.scrollTop = s - 100
                        } else {
                            var n = t.offsetLeft;
                            this.args.childNavScroller.scrollLeft = n - 100
                        }
                    }
                },
                arrowClick: function(e) {
                    e.currentTarget.classList.contains("product__thumb-arrow--prev") ? this.slideshow.previous() : this.slideshow.next()
                }
            }), a
        }(), theme.VariantAvailability = function() {
            var e = "disabled";

            function t(e) {
                this.type = e.type, this.variantsObject = e.variantsObject, this.currentVariantObject = e.currentVariantObject, this.container = e.container, this.namespace = e.namespace, this.init()
            }
            return t.prototype = Object.assign({}, t.prototype, {
                init: function() {
                    this.container.on("variantChange" + this.namespace, this.setAvailability.bind(this)), this.setInitialAvailability()
                },
                createAvailableOptionsTree: (e, t) => e.reduce((e, i) => (Object.keys(e).forEach(s => {
                    if (null === i[s]) return;
                    let n = e[s].find(e => e.value === i[s]);
                    void 0 === n && (n = {
                        value: i[s],
                        soldOut: !0
                    }, e[s].push(n));
                    let a = t.find(({
                            value: e,
                            index: t
                        }) => "option1" === t),
                        r = t.find(({
                            value: e,
                            index: t
                        }) => "option2" === t);
                    switch (s) {
                        case "option1":
                            n.soldOut = (!n.soldOut || !i.available) && n.soldOut;
                            break;
                        case "option2":
                            a && i.option1 === a.value && (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                        case "option3":
                            a && i.option1 === a.value && r && i.option2 === r.value && (n.soldOut = (!n.soldOut || !i.available) && n.soldOut)
                    }
                }), e), {
                    option1: [],
                    option2: [],
                    option3: []
                }),
                setInitialAvailability: function() {
                    this.container.querySelectorAll(".variant-input-wrap").forEach(e => {
                        this.disableVariantGroup(e)
                    });
                    let e = this.currentVariantObject.options.map((e, t) => ({
                            value: e,
                            index: `option${t+1}`
                        })),
                        t = this.createAvailableOptionsTree(this.variantsObject, e, this.currentVariantObject);
                    for (var [i, s] of Object.entries(t)) this.manageOptionState(i, s)
                },
                setAvailability: function(e) {
                    let {
                        value: t,
                        index: i,
                        currentlySelectedValues: s,
                        variant: n
                    } = e.detail, a = this.createAvailableOptionsTree(this.variantsObject, s, n, i, t);
                    for (var [r, o] of Object.entries(a)) this.manageOptionState(r, o, t)
                },
                manageOptionState: function(e, t) {
                    var i = this.container.querySelector('.variant-input-wrap[data-index="' + e + '"]');
                    t.forEach(e => {
                        this.enableVariantOption(i, e)
                    })
                },
                enableVariantOption: function(t, i) {
                    var s = i.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
                    if ("dropdown" === this.type) i.soldOut ? t.querySelector('option[value="' + s + '"]').disabled = !0 : t.querySelector('option[value="' + s + '"]').disabled = !1;
                    else {
                        var n = t.querySelector('.variant-input[data-value="' + s + '"]');
                        n && (a = n.querySelector("input"), r = n.querySelector("label"), a.classList.remove(e), r.classList.remove(e), i.soldOut && (a.classList.add(e), r.classList.add(e)))
                    }
                },
                disableVariantGroup: function(t) {
                    "dropdown" === this.type ? t.querySelectorAll("option").forEach(e => {
                        e.disabled = !0
                    }) : (t.querySelectorAll("input").forEach(t => {
                        t.classList.add(e)
                    }), t.querySelectorAll("label").forEach(t => {
                        t.classList.add(e)
                    }))
                }
            }), t
        }(), theme.videoModal = function() {
            var e, t, i = "VideoHolder",
                s = document.querySelectorAll('a[href*="youtube.com/watch"], a[href*="youtu.be/"]'),
                n = document.querySelectorAll('a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]'),
                a = document.querySelectorAll(".product-video-trigger--mp4");
            if (s.length || n.length || a.length) {
                var r = document.getElementById(i);
                s.length && theme.LibraryLoader.load("youtubeSdk"), n.length && theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
                var o = new theme.Modals("VideoModal", "video-modal", {
                    closeOffContentClick: !0,
                    bodyOpenClass: ["modal-open", "video-modal-open"],
                    solid: !0
                });
                s.forEach(e => {
                    e.addEventListener("click", c)
                }), n.forEach(e => {
                    e.addEventListener("click", l)
                }), a.forEach(e => {
                    e.addEventListener("click", d)
                }), document.addEventListener("modalClose.VideoModal", function() {
                    e && "function" == typeof e.destroy ? e.destroy() : t && "function" == typeof t.destroy ? t.destroy() : h()
                })
            }

            function c(t) {
                if (theme.config.youTubeReady) {
                    t.preventDefault(), h(), o.open(t);
                    var s, n, a = (s = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/, !(!(n = t.currentTarget.getAttribute("href").match(s)) || 11 != n[7].length) && n[7]);
                    e = new theme.YouTube(i, {
                        videoId: a,
                        style: "sound",
                        events: {
                            onReady: u
                        }
                    })
                }
            }

            function l(e) {
                if (theme.config.vimeoReady) {
                    e.preventDefault(), h(), o.open(e);
                    var s = e.currentTarget.dataset.videoId,
                        n = e.currentTarget.dataset.videoLoop;
                    t = new theme.VimeoPlayer(i, s, {
                        style: "sound",
                        loop: n
                    })
                }
            }

            function d(e) {
                h();
                var t = e.currentTarget.parentNode.querySelector(".product-video-mp4-sound").cloneNode(!0);
                t.classList.remove("hide"), r.append(t), o.open(e), r.querySelector("video").play()
            }

            function u(e) {
                e.target.unMute(), e.target.playVideo()
            }

            function h() {
                r.innerHTML = ""
            }
        };
        class d extends HTMLElement {
            constructor() {
                super(), this.el = this, this.inner = this.querySelector("[data-tool-tip-inner]"), this.closeButton = this.querySelector("[data-tool-tip-close]"), this.toolTipContent = this.querySelector("[data-tool-tip-content]"), this.toolTipTitle = this.querySelector("[data-tool-tip-title]"), this.triggers = document.querySelectorAll("[data-tool-tip-trigger]"), document.addEventListener("tooltip:open", e => {
                    this._open(e.detail.context, e.detail.content)
                })
            }
            _open(e, t) {
                this.toolTipContent.innerHTML = t, "store-availability" != e && this.toolTipTitle.remove(), this._lockScrolling(), this.closeButton && this.closeButton.on("click.tooltip-close", () => {
                    this._close()
                }), document.documentElement.on("click.tooltip-outerclick", e => {
                    "true" !== this.el.dataset.toolTipOpen || this.inner.contains(e.target) || this._close()
                }), document.documentElement.on("keydown.tooltip-esc", e => {
                    "Escape" === e.code && this._close()
                }), this.el.dataset.toolTipOpen = !0, this.el.dataset.toolTip = e
            }
            _close() {
                this.toolTipContent.innerHTML = "", this.el.dataset.toolTipOpen = "false", this.el.dataset.toolTip = "", this._unlockScrolling(), this.closeButton.off("click.tooltip-close"), document.documentElement.off("click.tooltip-outerclick"), document.documentElement.off("keydown.tooltip-esc")
            }
            _lockScrolling() {
                theme.a11y.trapFocus({
                    container: this.el,
                    namespace: "tooltip_focus"
                }), theme.a11y.lockMobileScrolling(), document.documentElement.classList.add("modal-open")
            }
            _unlockScrolling() {
                theme.a11y.removeTrapFocus({
                    container: this.el,
                    namespace: "tooltip_focus"
                }), theme.a11y.unlockMobileScrolling(), document.documentElement.classList.remove("modal-open")
            }
        }
        customElements.define("tool-tip", d);
        class u extends HTMLElement {
            constructor() {
                super(), this.el = this, this.toolTipContent = this.querySelector("[data-tool-tip-content]"), this.init()
            }
            init() {
                let e = new CustomEvent("tooltip:open", {
                    detail: {
                        context: this.dataset.toolTip,
                        content: this.toolTipContent.innerHTML
                    },
                    bubbles: !0
                });
                this.el.addEventListener("click", t => {
                    t.stopPropagation(), this.dispatchEvent(e)
                })
            }
        }
        customElements.define("tool-tip-trigger", u);
        class h extends HTMLElement {
            constructor() {
                super(), this.closeBtn = this.querySelector("[data-close-button]"), this.popupTrigger = this.querySelector("[data-message]"), this.id = this.dataset.sectionId, this.newsletterId = `NewsletterPopup-${this.id}`, this.cookie = Cookies.get(`newsletter-${this.id}`), this.cookieName = `newsletter-${this.id}`, this.secondsBeforeShow = this.dataset.delaySeconds, this.expiry = parseInt(this.dataset.delayDays), this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, "newsletter-popup-modal"), this.init()
            }
            init() {
                document.addEventListener("shopify:block:select", e => {
                    e.detail.sectionId === this.id && this.show(0, !0)
                }), document.addEventListener("shopify:block:deselect", e => {
                    e.detail.sectionId === this.id && this.hide()
                }), document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide()), document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show()), document.addEventListener("newsletter:openReminder", () => this.show(0)), this.closeBtn.addEventListener("click", () => {
                    this.hide(), Cookies.set(this.cookieName, "opened", {
                        path: "/",
                        expires: this.expiry
                    })
                }), this.popupTrigger.addEventListener("click", () => {
                    let e = new CustomEvent("reminder:openNewsletter", {
                        bubbles: !0
                    });
                    this.dispatchEvent(e), this.hide()
                })
            }
            show(e = this.secondsBeforeShow, t = !1) {
                "true" === sessionStorage.getItem("reminderAppeared") || setTimeout(() => {
                    this.dataset.enabled = "true", sessionStorage.setItem("reminderAppeared", !0)
                }, 1e3 * e)
            }
            hide() {
                this.dataset.enabled = "false"
            }
        }
        customElements.define("newsletter-reminder", h);
        class p extends HTMLElement {
            constructor() {
                super(), this.init()
            }
            init() {
                new IntersectionObserver(((e, t) => {
                    e[0].isIntersecting && (this.removeAnimations(), t.unobserve(this))
                }).bind(this), {
                    rootMargin: "0px 0px 400px 0px"
                }).observe(this)
            }
            removeAnimations() {
                let e = this.closest(".image-wrap"),
                    t = this.closest(".skrim__link");
                e && e.classList.add("loaded"), t && t.classList.add("loaded")
            }
        }
        customElements.define("image-element", p);
        class m extends HTMLElement {
            constructor() {
                super(), this.enabled = this.getAttribute("data-enabled"), this.context = this.getAttribute("data-context"), this.input = this.querySelector('input[type="search"]'), this.predictiveSearchResults = this.querySelector("#predictive-search"), this.closeBtn = this.querySelector(".btn--close-search"), this.screen = this.querySelector("[data-screen]"), this.SearchModal = this.closest("#SearchModal") || null, document.addEventListener("predictive-search:open", e => {
                    e.detail.context === this.context && (this.classList.add("is-active"), setTimeout(() => {
                        this.input.focus()
                    }, 100), document.body.classList.add("predictive-overflow-hidden"))
                }), this.SearchModal && new MutationObserver(e => {
                    e.forEach(e => {
                        "class" === e.attributeName && e.target.className.indexOf("modal--is-active") > -1 && setTimeout(() => {
                            this.input.focus()
                        }, 100)
                    })
                }).observe(this.SearchModal, {
                    attributes: !0
                }), "false" !== this.enabled && (this.input.addEventListener("keydown", () => {
                    this.classList.add("is-active")
                }), this.input.addEventListener("input", this.debounce(e => {
                    this.onChange(e)
                }, 300).bind(this)), document.addEventListener("predictive-search:close", () => {
                    this.close()
                }), document.addEventListener("keydown", e => {
                    27 === e.keyCode && this.close()
                }), this.closeBtn.addEventListener("click", e => {
                    e.preventDefault(), this.close()
                }), this.screen.addEventListener("click", () => {
                    this.close()
                }))
            }
            onChange() {
                let e = this.input.value.trim();
                e.length && this.getSearchResults(e)
            }
            getSearchResults(e) {
                let t = this.paramUrl({
                    q: e,
                    "resources[limit]": 3,
                    "resources[limit_scope]": "each",
                    "resources[options][unavailable_products]": "last"
                });
                fetch(`${theme.routes.predictiveSearch}?${t}&section_id=search-results`).then(e => {
                    if (!e.ok) {
                        let t = Error(e.status);
                        throw this.close(), t
                    }
                    return e.text()
                }).then(e => {
                    let t = (new DOMParser).parseFromString(e, "text/html").querySelector("#shopify-section-search-results").innerHTML;
                    this.predictiveSearchResults.innerHTML = t, this.open(), AOS.refreshHard()
                }).catch(e => {
                    throw this.close(), e
                })
            }
            open() {
                this.predictiveSearchResults.style.display = "block"
            }
            close() {
                this.predictiveSearchResults.style.display = "none", this.predictiveSearchResults.innerHTML = "", this.classList.remove("is-active"), document.body.classList.remove("predictive-overflow-hidden"), document.dispatchEvent(new CustomEvent("predictive-search:close-all"))
            }
            debounce(e, t) {
                let i;
                return (...s) => {
                    clearTimeout(i), i = setTimeout(() => e.apply(this, s), t)
                }
            }
            paramUrl(e) {
                return Object.keys(e).map(function(t) {
                    return t + "=" + encodeURIComponent(e[t])
                }).join("&")
            }
        }
        customElements.define("predictive-search", m);
        class g extends HTMLElement {
            constructor() {
                super(), this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`), this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`), this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`), this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`), this.addEventListener("change", () => this.onChange()), this.recipientFields = this.querySelector(".recipient-fields"), this.checkboxInput.addEventListener("change", () => {
                    this.recipientFields.style.display = this.checkboxInput.checked ? "block" : "none"
                })
            }
            connectedCallback() {
                document.addEventListener("ajaxProduct:error", e => {
                    e.target.querySelector('[name="id"]').value === this.dataset.productVariantId && this.displayErrorMessage(e.detail.errorMessage)
                }), document.addEventListener("ajaxProduct:added", e => {
                    e.target.querySelector('[name="id"]').value === this.dataset.productVariantId && (this.clearInputFields(), this.clearErrorMessage())
                })
            }
            onChange() {
                this.checkboxInput.checked || (this.clearInputFields(), this.clearErrorMessage())
            }
            clearInputFields() {
                this.querySelectorAll(".field__input").forEach(e => e.value = "")
            }
            displayErrorMessage(e) {
                if (this.clearErrorMessage(), e) return Object.entries(e).forEach(([e, t]) => {
                    let i = this[`${e}Input`];
                    i && (i.setAttribute("aria-invalid", !0), i.classList.add("field__input--error"))
                })
            }
            clearErrorMessage() {
                this.querySelectorAll(".field__input").forEach(e => {
                    e.setAttribute("aria-invalid", !1), e.removeAttribute("aria-describedby"), e.classList.remove("field__input--error")
                })
            }
        }
        customElements.define("recipient-form", g), theme.announcementBar = function() {
            var e, t, i = {
                autoPlay: 5e3,
                avoidReflow: !0,
                cellAlign: theme.config.rtl ? "right" : "left"
            };

            function s() {
                t = new theme.Slideshow(e, i)
            }

            function n() {
                t && "function" == typeof t.destroy && t.destroy()
            }
            return {
                init: function() {
                    (e = document.getElementById("AnnouncementSlider")) && (n(), 1 !== e.dataset.blockCount && ((theme.config.bpSmall || "true" === e.dataset.compact) && s(), document.addEventListener("matchSmall", function() {
                        n(), s()
                    }), document.addEventListener("unmatchSmall", function() {
                        n(), "true" === e.dataset.compact && s()
                    })))
                },
                onBlockSelect: function(i) {
                    var s = parseInt(e.querySelector("#AnnouncementSlide-" + i).dataset.index);
                    t && "function" == typeof t.pause && (t.goToSlide(s), t.pause())
                },
                onBlockDeselect: function() {
                    t && "function" == typeof t.play && t.play()
                },
                unload: n
            }
        }(), theme.customerTemplates = function() {
            var e, t, i, s;

            function n() {
                document.getElementById("RecoverPasswordForm").classList.toggle("hide"), document.getElementById("CustomerLoginForm").classList.toggle("hide")
            }
            "#recover" === window.location.hash && n(), (e = document.getElementById("RecoverPassword")) && e.addEventListener("click", function(e) {
                e.preventDefault(), n()
            }), (t = document.getElementById("HideRecoverPasswordLink")) && t.addEventListener("click", function(e) {
                e.preventDefault(), n()
            }), document.querySelector(".reset-password-success") && document.getElementById("ResetSuccess").classList.remove("hide"), i = document.getElementById("AddressNewForm"), s = document.querySelectorAll(".js-address-form"), i && s.length && (setTimeout(function() {
                document.querySelectorAll(".js-address-country").forEach(e => {
                    var t = e.dataset.countryId,
                        i = e.dataset.provinceId,
                        s = e.dataset.provinceContainerId;
                    new Shopify.CountryProvinceSelector(t, i, {
                        hideElement: s
                    })
                })
            }, 1e3), document.querySelectorAll(".address-new-toggle").forEach(e => {
                e.addEventListener("click", function() {
                    i.classList.toggle("hide")
                })
            }), document.querySelectorAll(".address-edit-toggle").forEach(e => {
                e.addEventListener("click", function(e) {
                    var t = e.currentTarget.dataset.formId;
                    document.getElementById("EditAddress_" + t).classList.toggle("hide")
                })
            }), document.querySelectorAll(".address-delete").forEach(e => {
                e.addEventListener("click", function(e) {
                    var t = e.currentTarget.dataset.formId;
                    confirm(e.currentTarget.dataset.confirmMessage || "Are you sure you wish to delete this address?") && Shopify && Shopify.postLink("/account/addresses/" + t, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                })
            }))
        }, theme.CartDrawer = function() {
            function e() {
                this.form = document.querySelector("#CartDrawerForm"), this.drawer = new theme.Drawers("CartDrawer", "cart"), this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    this.cartForm = new theme.CartForm(this.form), this.cartForm.buildCart(), this.cartForm.initEngravingRemove(), this.cartForm.initEngravingAdd(), document.addEventListener("ajaxProduct:added", (function(e) {
                        this.cartForm.buildCart(), this.open()
                    }).bind(this)), document.addEventListener("cart:open", this.open.bind(this)), document.addEventListener("cart:close", this.close.bind(this))
                },
                open: function() {
                    this.drawer.open(), theme.a11y.trapFocus({
                        container: this.form,
                        elementToFocus: this.form,
                        namespace: "cartdrawer_focus"
                    })
                },
                close: function() {
                    this.drawer.close(), theme.a11y.removeTrapFocus({
                        container: this.form,
                        namespace: "cartdrawer_focus"
                    })
                }
            }), e
        }(), theme.headerNav = function() {
            var e, t, i = "#HeaderWrapper",
                s = ".site-header__search-container",
                n = {
                    namespace: ".siteNav",
                    wrapperOverlayed: !1,
                    overlayedClass: "is-light",
                    overlayEnabledClass: "header-wrapper--sticky",
                    stickyEnabled: !1,
                    stickyActive: !1,
                    stickyClass: "site-header--stuck",
                    stickyHeaderWrapper: "StickyHeaderWrap",
                    openTransitionClass: "site-header--opening",
                    lastScroll: 0
                };

            function a() {
                if (n.stickyEnabled) {
                    var e = t.offsetHeight;
                    t.classList.contains("site-header--stuck") && !theme.config.bpSmall && (e += 2 * parseFloat(window.getComputedStyle(t, null).getPropertyValue("padding-top"))), document.querySelector("#" + n.stickyHeaderWrapper).style.height = e + "px"
                }
            }

            function r() {
                n.stickyEnabled && (n.forceStopSticky || (requestAnimationFrame(o), n.lastScroll = window.scrollY))
            }

            function o() {
                if (window.scrollY > 250) n.stickyActive || (n.stickyActive = !0, t.classList.add(n.stickyClass), n.wrapperOverlayed && e.classList.remove(n.overlayedClass), setTimeout(function() {
                    t.classList.add(n.openTransitionClass)
                }, 100));
                else {
                    if (!n.stickyActive) return;
                    n.stickyActive = !1, t.classList.remove(n.openTransitionClass), t.classList.remove(n.stickyClass), n.wrapperOverlayed && e.classList.add(n.overlayedClass)
                }
            }
            return {
                init: function() {
                    var o, c;
                    e = document.querySelector(i), t = document.querySelector("#SiteHeader"), n.stickyEnabled = "true" === t.dataset.sticky, n.stickyEnabled && (n.wrapperOverlayed = e.classList.contains(n.overlayedClass), theme.config.stickyHeader = (o = 0, t.querySelectorAll(".megamenu").forEach(e => {
                        var t = e.offsetHeight;
                        t > o && (o = t)
                    }), !(window.innerHeight < o + 120)), theme.config.stickyHeader ? (n.forceStopSticky = !1, n.lastScroll = 0, (c = document.createElement("div")).id = n.stickyHeaderWrapper, theme.utils.wrap(t, c), function(e) {
                        let t = e.closest(".shopify-section-group-header-group").nextElementSibling;
                        if (t && t.classList.contains("shopify-section-group-header-group")) {
                            let s = t.offsetHeight;
                            document.querySelector(i).style.top = s + "px"
                        }
                    }(t), a(), window.on("resize" + n.namespace, theme.utils.debounce(50, a)), window.on("scroll" + n.namespace, theme.utils.throttle(20, r)), Shopify && Shopify.designMode && setTimeout(function() {
                        a()
                    }, 250)) : n.forceStopSticky = !0), theme.settings.overlayHeader = "true" === t.dataset.overlay, theme.settings.overlayHeader && Shopify && Shopify.designMode && document.body.classList.contains("template-collection") && !document.querySelector(".collection-hero") && this.disableOverlayHeader(), document.querySelectorAll(".site-nav__details").forEach(e => {
                        let t = e.querySelector("summary");
                        document.addEventListener("click", i => {
                            e.hasAttribute("open") && !e.contains(i.target) ? (e.removeAttribute("open"), t.setAttribute("aria-expanded", "false")) : e.hasAttribute("open") ? t.setAttribute("aria-expanded", "false") : t.setAttribute("aria-expanded", "true")
                        })
                    }), document.querySelectorAll(".js-search-header").forEach(e => {
                        e.addEventListener("click", function(e) {
                            e.preventDefault(), e.stopPropagation(), document.dispatchEvent(new CustomEvent("predictive-search:open", {
                                detail: {
                                    context: "header"
                                },
                                bubbles: !0
                            })), document.querySelector(s).classList.add("is-active")
                        })
                    }), document.addEventListener("predictive-search:close-all", function() {
                        ! function(e) {
                            document.activeElement.blur(), document.documentElement.classList.add("js-drawer-closing"), document.documentElement.classList.remove("js-drawer-open", "js-drawer-open--search"), window.setTimeout((function() {
                                document.documentElement.classList.remove("js-drawer-closing")
                            }).bind(this), 500);
                            var t = document.querySelector(s);
                            theme.utils.prepareTransition(t, (function() {
                                t.classList.remove("is-active")
                            }).bind(this))
                        }()
                    })
                },
                disableOverlayHeader: function() {
                    e.classList.remove(n.overlayEnabledClass, n.overlayedClass), n.wrapperOverlayed = !1, theme.settings.overlayHeader = !1
                }
            }
        }(), window.onpageshow = function(e) {
            e.persisted && (document.body.classList.remove("unloading"), document.querySelectorAll(".cart__checkout").forEach(e => {
                e.classList.remove("btn--loading")
            }))
        }, theme.buildProductGridItem = function(e, t, i, s) {
            var n = "";
            return e.forEach(e => {
                var a = theme.buildProductImage(e, s),
                    r = theme.buildVariantImageEl(e),
                    o = theme.buildProductSwatches(e);
                let c = "",
                    l = "",
                    d = "";
                var u, h = "",
                    p = "";
                u = theme.Currency.formatMoney(e.price_min, theme.moneyFormat).split(".")[0], "" != e.compare_at_price_min && e.compare_at_price_min > 0 && "" != e.compare_at_price_max && e.compare_at_price_min > e.price_min && (h = theme.Currency.formatMoney(e.compare_at_price_min, theme.moneyFormat).split(".")[0], p = Math.round((e.compare_at_price_min - e.price_min) / e.compare_at_price_min * 100)), theme.settings.predictiveSearchPrice && (c = "" != h ? `<div class="grid-product__price"><div class="list-price-inner">${u}<div class="product__compare-at-price">${h}</div></div><span class="grid-product__price--savings">-${p}%</span></div>` : `<div class="grid-product__price"><div class="list-price-inner">${u}</div></div>`), theme.settings.predictiveSearchVendor && (l = `<div class="grid-product__vendor">${e.vendor}</div>`);
                var m = "Metal";
                "Remi Rhode" == e.vendor && (m = "Color"), "" != o && (d = `<div class="grid-product__colors grid-product__colors--${e.id}"><a href="${e.url}" class="grid-product__link"><div class="swatch-label"><span>${m}</span></div></a>${o}</div>`);
                var g = e.tags,
                    f = "",
                    v = "";
                e.compare_at_price > e.price && (v = '<div class="grid-product__tag grid-product__tag--sale">Sale</div>'), "Remi Rhode" != e.vendor && -1 === g.indexOf("_label_FLASH SALE") && (f = '<span class="card-product-metal-var">More Carat & Shape available</span>'), n += `<div class="grid__item grid-product ${t} aos-animate" data-aos="row-of-${i}"><div class="grid-product__content">${v}<div class="grid__item-image-wrapper"><div class="grid-product__image-mask">${a} ${r}</div>${f}<a href="${e.url}" class="grid-product__link"></a><div class="grid-product__meta"><a href="${e.url}" class="grid-product__link"><div class="grid-product__title grid-product__title--heading">${e.title}</div></a>${d} ${l}</div></div></div>${c}<div class="yotpo bottomLine" data-product-id="${e.id}">&nbsp;</div></div>`
            }), n
        }, theme.buildProductImage = function(e, t) {
            var i = theme.settings.productImageSize,
                s = "";
            if ("natural" === i) {
                let n = document.getElementById("naturalImageMarkup").content.cloneNode(!0),
                    a = n.querySelector("img");
                n.querySelector(".image-wrap").style.paddingBottom = `${e.image_aspect_ratio}%`, u(a, t);
                let o = document.createElement("div");
                o.appendChild(n), s = o.innerHTML
            } else {
                let c = document.getElementById("fixedRatioImageMarkup").content.cloneNode(!0),
                    l = c.querySelector("img");
                c.querySelector(".grid__image-ratio").classList.add(`grid__image-ratio--${i}`), theme.settings.productImageCover || l.classList.add("grid__image-contain"), u(l, t);
                let d = document.createElement("div");
                d.appendChild(c), s = d.innerHTML
            }

            function u(t, i) {
                t.src = e.image_responsive_url, t.srcset = e.image_responsive_urls.toString(), t.alt = e.title, t.sizes = i
            }
            return theme.buildVariantImageEl = function(e) {
                var t = e.options,
                    i = e.variants,
                    s = "",
                    n = "",
                    a = "";
                return t.forEach((e, t) => {
                    "Metal" == e.name && (n = t)
                }), i.forEach(e => {
                    var t = e.option1;
                    (1 == n || 2 == n) && (t = e.option2), -1 === a.indexOf(t) && (a = a + t + ",", e.featured_image) && "" != e.featured_image.src && (s += `<div class="grid-product__color-image grid-product__color-image--${r.id} small--hide"></div>`)
                }), s
            }, theme.buildProductSwatches = function(e) {
                var t = e.options,
                    i = e.variants,
                    s = "",
                    n = "",
                    a = "";
                t.forEach((e, t) => {
                    "Metal" == e.name && (s = t)
                });
                var r = 1;
                return "" !== s && i.forEach(t => {
                    var i = t.option1;
                    if ((1 == s || 2 == s) && (i = t.option2), -1 === a.indexOf(i)) {
                        a = a + i + ",";
                        var o = i.toLowerCase() + "-hover",
                            c = `https://cdn.shopify.com/s/files/1/0802/6469/2030/files/${o=o.replaceAll(" ","-")}.svg`;
                        if ("yellow" == o) var l = "#E9D590";
                        else l = "white" == o ? "#F0F0F0" : o;
                        var d = "";
                        1 == r && (d = "swatch-active");
                        var u = "";
                        t.featured_image && (u = (u = (u = t.featured_image.src).replace(".png", "_400x.png")).replace(".jpg", "_400x.jpg")) && (h = "color-swatch--with-image"), n += `<a href="${e.url}?variant=${t.id}" data-variant-url="${e.url}?variant=${t.id}" data-product-id="${e.id}" class="color-swatch prd-color-swatch-${e.id} color-swatch--small color-swatch--${o} ${d} ${h}" data-variant-id="${t.id}" data-variant-image="${u}" title="${i}" aria-label="${e.title} - ${i}" style="background-color: ${l}; background-image: url(${c});"><span class="visually-hidden">${i}</span></a>`, r++
                    }
                }), n
            }, s
        };
        class f extends HTMLElement {
            constructor() {
                super(), this.cookieName = this.id, this.cookie = Cookies.get(this.cookieName), this.classes = {
                    activeContent: "age-verification-popup__content--active",
                    inactiveContent: "age-verification-popup__content--inactive",
                    inactiveDeclineContent: "age-verification-popup__decline-content--inactive",
                    activeDeclineContent: "age-verification-popup__decline-content--active"
                }, this.declineButton = this.querySelector("[data-age-verification-popup-decline-button]"), this.declineContent = this.querySelector("[data-age-verification-popup-decline-content]"), this.content = this.querySelector("[data-age-verification-popup-content]"), this.returnButton = this.querySelector("[data-age-verification-popup-return-button]"), this.exitButton = this.querySelector("[data-age-verification-popup-exit-button]"), this.backgroundImage = this.querySelector("[data-background-image]"), this.mobileBackgroundImage = this.querySelector("[data-mobile-background-image]"), Shopify.designMode && (document.addEventListener("shopify:section:select", e => {
                    e.detail.sectionId === this.dataset.sectionId && this.init()
                }), document.addEventListener("shopify:section:load", e => {
                    e.detail.sectionId === this.dataset.sectionId && (this.init(), "true" === this.dataset.testMode && this.cookie && Cookies.remove(this.cookieName), sessionStorage.getItem(this.id) && this.showDeclineContent())
                }), document.addEventListener("shopify:section:unload", e => {
                    e.detail.sectionId === this.dataset.sectionId && this.modal.close()
                })), this.cookie && "false" === this.dataset.testMode || this.init()
            }
            init() {
                this.modal = new theme.Modals(this.id, "age-verification-popup-modal", {
                    closeOffContentClick: !1
                }), this.backgroundImage && (this.backgroundImage.style.display = "block"), theme.config.bpSmall && this.mobileBackgroundImage && (this.mobileBackgroundImage.style.display = "block"), this.modal.open(), theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent")), this.declineButton && this.declineButton.addEventListener("click", e => {
                    e.preventDefault(), this.showDeclineContent(), Shopify.designMode && sessionStorage.setItem(this.id, "second-view")
                }), this.returnButton && this.returnButton.addEventListener("click", e => {
                    e.preventDefault(), this.hideDeclineContent();
                    let t = sessionStorage.getItem(this.id);
                    Shopify.designMode && t && sessionStorage.removeItem(this.id)
                }), this.exitButton && this.exitButton.addEventListener("click", e => {
                    e.preventDefault(), "false" === this.dataset.testMode && Cookies.set(this.cookieName, "entered", {
                        expires: 30,
                        sameSite: "none",
                        secure: !0
                    }), this.backgroundImage && (this.backgroundImage.style.display = "none"), theme.config.bpSmall && this.mobileBackgroundImage && (this.mobileBackgroundImage.style.display = "none"), this.modal.close(), theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent"))
                })
            }
            showDeclineContent() {
                this.declineContent.classList.remove(this.classes.inactiveDeclineContent), this.declineContent.classList.add(this.classes.activeDeclineContent), this.content.classList.add(this.classes.inactiveContent), this.content.classList.remove(this.classes.activeContent)
            }
            hideDeclineContent() {
                this.declineContent.classList.add(this.classes.inactiveDeclineContent), this.declineContent.classList.remove(this.classes.activeDeclineContent), this.content.classList.remove(this.classes.inactiveContent), this.content.classList.add(this.classes.activeContent)
            }
        }
        customElements.define("age-verification-popup", f), theme.Maps = function() {
            var e = null,
                t = [],
                i = {},
                s = "[data-map]";

            function n(e) {
                this.container = e, this.sectionId = this.container.getAttribute("data-section-id"), this.namespace = ".map-" + this.sectionId, this.map = e.querySelector(s), this.key = this.map.dataset.apiKey, i = {
                    addressNoResults: theme.strings.addressNoResults,
                    addressQueryLimit: theme.strings.addressQueryLimit,
                    addressError: theme.strings.addressError,
                    authError: theme.strings.authError
                }, this.key && theme.initWhenVisible({
                    element: this.container,
                    callback: this.prepMapApi.bind(this),
                    threshold: 20
                })
            }
            return window.gm_authFailure = function() {
                Shopify.designMode && (document.querySelectorAll('[data-section-type="map"]').forEach(e => {
                    e.classList.add("map-section--load-error")
                }), document.querySelectorAll(s).forEach(e => {
                    e.parentNode.removeChild(e)
                }), window.mapError(theme.strings.authError))
            }, window.mapError = function(e) {
                var t = document.createElement("div");
                t.classList.add("map-section__error", "errors", "text-center"), t.innerHTML = e, document.querySelectorAll(".map-section__overlay").forEach(e => {
                    e.parentNode.prepend(t)
                }), document.querySelectorAll(".map-section__link").forEach(e => {
                    e.classList.add("hide")
                })
            }, n.prototype = Object.assign({}, n.prototype, {
                prepMapApi: function() {
                    if ("loaded" === e) this.createMap();
                    else if (t.push(this), "loading" !== e && (e = "loading", void 0 === window.google || void 0 === window.google.maps)) {
                        var i = document.createElement("script");
                        i.onload = function() {
                            e = "loaded", t.forEach(e => {
                                e.createMap()
                            })
                        }, i.src = "https://maps.googleapis.com/maps/api/js?key=" + this.key, document.head.appendChild(i)
                    }
                },
                createMap: function() {
                    var e = this.map;
                    return (function(e) {
                        var t = new google.maps.Geocoder;
                        if (e) {
                            var i = e.dataset.addressSetting;
                            return new Promise((e, s) => {
                                t.geocode({
                                    address: i
                                }, function(t, i) {
                                    i !== google.maps.GeocoderStatus.OK && s(i), e(t)
                                })
                            })
                        }
                    })(e).then((function(t) {
                        var i = {
                                zoom: 14,
                                backgroundColor: "none",
                                center: t[0].geometry.location,
                                draggable: !1,
                                clickableIcons: !1,
                                scrollwheel: !1,
                                disableDoubleClickZoom: !0,
                                disableDefaultUI: !0
                            },
                            s = this.map = new google.maps.Map(e, i),
                            n = this.center = s.getCenter();
                        new google.maps.Marker({
                            map: s,
                            position: s.getCenter()
                        }), google.maps.event.addDomListener(window, "resize", theme.utils.debounce(250, function() {
                            google.maps.event.trigger(s, "resize"), s.setCenter(n), e.removeAttribute("style")
                        })), Shopify.designMode && window.AOS && AOS.refreshHard()
                    }).bind(this)).catch(function(e) {
                        var t;
                        switch (e) {
                            case "ZERO_RESULTS":
                                t = i.addressNoResults;
                                break;
                            case "OVER_QUERY_LIMIT":
                                t = i.addressQueryLimit;
                                break;
                            case "REQUEST_DENIED":
                                t = i.authError;
                                break;
                            default:
                                t = i.addressError
                        }
                        Shopify.designMode && window.mapError(t)
                    })
                },
                onUnload: function() {
                    0 !== this.map.length && google && google.maps && google.maps.event && google.maps.event.clearListeners(this.map, "resize")
                }
            }), n
        }(), theme.NewsletterPopup = function() {
            function e(e) {
                this.container = e;
                var t = this.container.getAttribute("data-section-id");
                if (this.cookieName = "newsletter-" + t, this.cookie = Cookies.get(this.cookieName), e && "/challenge" !== window.location.pathname && "/password" !== window.location.pathname) {
                    this.data = {
                        secondsBeforeShow: e.dataset.delaySeconds,
                        daysBeforeReappear: e.dataset.delayDays,
                        hasReminder: e.dataset.hasReminder,
                        testMode: e.dataset.testMode
                    }, this.modal = new theme.Modals("NewsletterPopup-" + t, "newsletter-popup-modal");
                    var i = e.querySelector(".popup-cta a");
                    i && i.addEventListener("click", (function() {
                        this.closePopup(!0)
                    }).bind(this)), (e.querySelector(".errors") || e.querySelector(".note--success")) && this.modal.open(), e.querySelector(".note--success") ? this.closePopup(!0) : (document.addEventListener("modalClose." + e.id, this.closePopup.bind(this)), this.cookie || this.initPopupDelay(), document.addEventListener("reminder:openNewsletter", () => {
                        this.modal.open()
                    }))
                }
            }
            return e.prototype = Object.assign({}, e.prototype, {
                initPopupDelay: function() {
                    "true" !== this.data.testMode && setTimeout((function() {
                        if ("true" === sessionStorage.getItem("newsletterAppeared")) {
                            let e = new CustomEvent("newsletter:openReminder", {
                                bubbles: !0
                            });
                            this.container.dispatchEvent(e)
                        } else this.modal.open(), sessionStorage.setItem("newsletterAppeared", !0)
                    }).bind(this), 1e3 * this.data.secondsBeforeShow)
                },
                closePopup: function(e) {
                    if ("true" !== this.data.testMode) {
                        var t = e ? 200 : this.data.daysBeforeReappear,
                            i = "true" === this.data.hasReminder,
                            s = "true" === sessionStorage.getItem("reminderAppeared");
                        i && s ? Cookies.set(this.cookieName, "opened", {
                            path: "/",
                            expires: t
                        }) : i || Cookies.set(this.cookieName, "opened", {
                            path: "/",
                            expires: t
                        })
                    } else Cookies.remove(this.cookieName, {
                        path: "/"
                    })
                },
                onLoad: function() {
                    this.modal.open()
                },
                onSelect: function() {
                    this.modal.open()
                },
                onDeselect: function() {
                    this.modal.close()
                },
                onBlockSelect: function() {
                    this.modal.close()
                },
                onBlockDeselect: function() {
                    this.modal.open()
                },
                onUnload: function() {
                    this.modal.close()
                }
            }), e
        }(), theme.PasswordHeader = function() {
            function e() {
                this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    if (document.querySelector("#LoginModal")) {
                        var e = new theme.Modals("LoginModal", "login-modal", {
                            focusIdOnOpen: "password",
                            solid: !0
                        });
                        document.querySelectorAll(".errors").length && e.open()
                    }
                }
            }), e
        }(), theme.Photoswipe = function() {
            var e = ".photoswipe__image";

            function t(e, t) {
                this.container = e, this.sectionId = t, this.namespace = ".photoswipe-" + this.sectionId, this.gallery, this.images, this.items, this.inSlideshow = !1, e && "false" !== e.dataset.zoom && this.init()
            }
            return t.prototype = Object.assign({}, t.prototype, {
                init: function() {
                    this.container.querySelectorAll(".js-photoswipe__zoom").forEach(e => {
                        e.on("click" + this.namespace, this.triggerClick.bind(this))
                    })
                },
                triggerClick: function(e) {
                    this.container.dataset && "true" === this.container.dataset.hasSlideshow ? this.inSlideshow = !0 : this.inSlideshow = !1, this.items = this.getImageData();
                    var t = this.inSlideshow ? this.container.querySelector(".slick-active") : e.currentTarget,
                        i = this.inSlideshow ? this.getChildIndex(t) : t.dataset.index;
                    this.initGallery(this.items, i)
                },
                getChildIndex: function(e) {
                    for (var t = 0; null != (e = e.previousSibling);) t++;
                    return t + 1
                },
                getImageData: function() {
                    this.images = this.inSlideshow ? this.container.querySelectorAll(".product__main-photos " + e) : this.container.querySelectorAll(e);
                    var t = [];
                    return this.images.forEach(e => {
                        var i = {
                            msrc: e.currentSrc || e.src,
                            src: e.getAttribute("data-photoswipe-src"),
                            w: e.getAttribute("data-photoswipe-width"),
                            h: e.getAttribute("data-photoswipe-height"),
                            el: e,
                            initialZoomLevel: .5
                        };
                        t.push(i)
                    }), t
                },
                initGallery: function(e, t) {
                    var i = document.querySelectorAll(".pswp")[0];
                    this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, {
                        allowPanToNext: !1,
                        captionEl: !1,
                        closeOnScroll: !1,
                        counterEl: !1,
                        history: !1,
                        index: t - 1,
                        pinchToClose: !1,
                        preloaderEl: !1,
                        scaleMode: "zoom",
                        shareEl: !1,
                        tapToToggleControls: !1,
                        getThumbBoundsFn: function(t) {
                            var i = window.pageYOffset || document.documentElement.scrollTop,
                                s = e[t].el.getBoundingClientRect();
                            return {
                                x: s.left,
                                y: s.top + i,
                                w: s.width
                            }
                        }
                    }), this.gallery.listen("afterChange", this.afterChange.bind(this)), this.gallery.init(), this.preventiOS15Scrolling()
                },
                afterChange: function() {
                    var e = this.gallery.getCurrentIndex();
                    this.container.dispatchEvent(new CustomEvent("photoswipe:afterChange", {
                        detail: {
                            index: e
                        }
                    }))
                },
                syncHeight: function() {
                    document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`)
                },
                preventiOS15Scrolling: function() {
                    let e;
                    /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && (this.syncHeight(), e = window.scrollY, document.documentElement.classList.add("pswp-open-in-ios"), window.addEventListener("resize", this.syncHeight), this.gallery.listen("destroy", () => {
                        document.documentElement.classList.remove("pswp-open-in-ios"), window.scrollTo(0, e)
                    }))
                }
            }), t
        }();
        class v extends HTMLElement {
            constructor() {
                super(), this.el = this, this.url = this.dataset.url, this.intent = this.dataset.intent, this.placeholder = this.querySelector(".product-recommendations-placeholder"), this.productResults = this.querySelector(".grid-product"), this.sectionId = this.dataset.sectionId, this.blockId = this.dataset.blockId, document.addEventListener("recommendations:loaded", e => {
                    this.colorImages = this.el.querySelectorAll(".grid-product__color-image"), this.colorImages.length && (this.swatches = this.el.querySelectorAll(".color-swatch--with-image"), this.colorSwatchHovering())
                })
            }
            connectedCallback() {
                fetch(this.url).then(e => e.text()).then(e => {
                    let t = document.createElement("div");
                    t.innerHTML = e;
                    let i = t.querySelector(".product-recommendations");
                    /*if (!i) return this.el.classList.add("hide"), void(AOS && AOS.refreshHard());*/
                    if (!i || i.children[0].children.length < 1) {
                        this.el.classList.add("hide"), AOS && AOS.refreshHard(), document.getElementById("rel-rec-heading-recommended") && (document.getElementById("rel-rec-heading-recommended").classList.add("hide"), document.getElementById("rel-rec-heading-recent").click(), document.querySelector('.recent-tab').classList.add('do_not_hide'),document.querySelector('.recent-tab').classList.remove('hidden'));
                        return
                    }
                    this.placeholder && (this.placeholder.innerHTML = "", this.placeholder.innerHTML = i.innerHTML), theme.reinitProductGridItem(this.el), this.slideshow = this.querySelector("[data-slideshow]"), this.setupSlider(), document.dispatchEvent(new CustomEvent("recommendations:loaded", {
                        detail: {
                            section: this.el,
                            intent: this.intent
                        }
                    }))
                }).catch(e => {
                    console.error(e)
                })
            }
            setupSlider() {
                let e = this.slideshow.dataset.controls;
                parseFloat(this.slideshow.dataset.perSlide), parseFloat(this.slideshow.dataset.count);
                let t = !0,
                    i = !1;
                "arrows" === e && (i = !1, t = !0), this.flickity = new theme.Slideshow(this.slideshow, {
                    prevNextButtons: t,
                    pageDots: i,
                    adaptiveHeight: !0,
                    wrapAround: !1,
                    contain: !0,
                    groupCells: !0
                })
            }
            colorSwatchHovering() {
                this.swatches.forEach(e => {
                    e.classList.contains("custom-recommended") || (e.addEventListener("mouseenter", (function() {
                        this.setActiveColorImage(e)
                    }).bind(this)), e.addEventListener("touchstart", (function(t) {
                        t.preventDefault(), this.setActiveColorImage(e)
                    }).bind(this), {
                        passive: !0
                    }), e.addEventListener("mouseleave", (function() {
                        this.removeActiveColorImage(e)
                    }).bind(this)))
                })
            }
            setActiveColorImage(e) {
                let t = e.dataset.variantId,
                    i = e.dataset.variantImage;
                this.colorImages.forEach(e => {
                    e.classList.remove("is-active")
                }), this.swatches.forEach(e => {
                    e.classList.remove("is-active")
                });
                let s = this.el.querySelector(`.grid-product__color-image--${t}`);
                s.style.backgroundImage = "url(" + i + ")", s.classList.add("is-active"), e.classList.add("is-active");
                let n = e.dataset.variantUrl;
                e.closest(".grid-product").querySelectorAll(".grid-product__link").forEach(e => {
                    e.setAttribute("href", n)
                })
            }
            removeActiveColorImage(e) {
                let t = e.dataset.variantId;
                this.el.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active")
            }
        }
        customElements.define("product-recommendations", v), theme.SlideshowSection = function() {
            function e(e) {
                this.container = e;
                var t = e.getAttribute("data-section-id");
                if (this.slideshow = e.querySelector("#Slideshow-" + t), this.namespace = "." + t, this.initialIndex = 0, this.slideshow) {
                    var i = e.parentElement;
                    0 === [].indexOf.call(i.parentElement.children, i) ? this.init() : theme.initWhenVisible({
                        element: this.container,
                        callback: this.init.bind(this)
                    })
                }
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    var e = this.slideshow.querySelectorAll(".slideshow__slide");
                    if (this.slideshow.classList.remove("loading", "loading--delayed"), this.slideshow.classList.add("loaded"), e.length > 1) {
                        var t = {
                            prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                            pageDots: this.slideshow.hasAttribute("data-dots"),
                            fade: !0,
                            setGallerySize: !1,
                            initialIndex: this.initialIndex,
                            autoPlay: "true" === this.slideshow.dataset.autoplay && parseInt(this.slideshow.dataset.speed)
                        };
                        this.flickity = new theme.Slideshow(this.slideshow, t)
                    } else e[0].classList.add("is-selected")
                },
                forceReload: function() {
                    this.onUnload(), this.init()
                },
                onUnload: function() {
                    this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy()
                },
                onDeselect: function() {
                    this.flickity && "function" == typeof this.flickity.play && this.flickity.play()
                },
                onBlockSelect: function(e) {
                    var t = parseInt(this.slideshow.querySelector(".slideshow__slide--" + e.detail.blockId).dataset.index);
                    this.flickity && "function" == typeof this.flickity.pause ? (this.flickity.goToSlide(t), this.flickity.pause()) : (this.initialIndex = t, setTimeout((function() {
                        this.flickity && "function" == typeof this.flickity.pause && this.flickity.pause()
                    }).bind(this), 1e3))
                },
                onBlockDeselect: function() {
                    this.flickity && "function" == typeof this.flickity.play && this.flickity.args.autoPlay && this.flickity.play()
                }
            }), e
        }(), theme.StoreAvailability = function() {
            function e(e) {
                this.container = e, this.baseUrl = e.dataset.baseUrl, this.productTitle = e.dataset.productName
            }
            return e.prototype = Object.assign({}, e.prototype, {
                updateContent: function(e) {
                    var t = this.baseUrl + "/variants/" + e + "/?section_id=store-availability",
                        i = this;
                    fetch(t).then(function(e) {
                        return e.text()
                    }).then(function(e) {
                        if ("" !== e.trim()) {
                            i.container.innerHTML = e, i.container.innerHTML = i.container.firstElementChild.innerHTML, i.container.querySelector(".js-drawer-open-availability") && (i.drawer = new theme.Drawers("StoreAvailabilityDrawer", "availability")), i.container.querySelector(".js-modal-open-availability") && (i.modal = new theme.Modals("StoreAvailabilityModal", "availability"));
                            var t = i.container.querySelector("[data-availability-product-title]");
                            t && (t.textContent = i.productTitle)
                        } else this.container.innerHTML = ""
                    })
                }
            }), e
        }(), theme.VideoSection = function() {
            var e = ".video-parent-section";

            function t(e) {
                this.container = e, this.sectionId = e.getAttribute("data-section-id"), this.namespace = ".video-" + this.sectionId, this.videoObject, theme.initWhenVisible({
                    element: this.container,
                    callback: this.init.bind(this),
                    threshold: 500
                })
            }
            return t.prototype = Object.assign({}, t.prototype, {
                init: function() {
                    var e = this.container.querySelector(".video-div");
                    if (e) switch (e.dataset.type) {
                        case "youtube":
                            var t = e.dataset.videoId;
                            this.initYoutubeVideo(t);
                            break;
                        case "vimeo":
                            t = e.dataset.videoId, this.initVimeoVideo(t);
                            break;
                        case "mp4":
                            this.initMp4Video()
                    }
                },
                initYoutubeVideo: function(t) {
                    this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
                        videoId: t,
                        videoParent: e
                    })
                },
                initVimeoVideo: function(t) {
                    this.videoObject = new theme.VimeoPlayer("Vimeo-" + this.sectionId, t, {
                        videoParent: e
                    })
                },
                initMp4Video: function() {
                    var t = "Mp4Video-" + this.sectionId,
                        i = document.getElementById(t),
                        s = i.closest(e);
                    if (i) {
                        s.classList.add("loaded");
                        var n = document.querySelector("#" + t).play();
                        void 0 !== n && n.then(function() {}).catch(function() {
                            i.setAttribute("controls", ""), s.classList.add("video-interactable")
                        })
                    }
                },
                onUnload: function(e) {
                    e.target.id.replace("shopify-section-", ""), this.videoObject && "function" == typeof this.videoObject.destroy && this.videoObject.destroy()
                }
            }), t
        }();
        class y extends HTMLElement {
            constructor() {
                super(), this.el = this, this.display = this.querySelector("[data-time-display]"), this.block = this.closest(".countdown__block--timer"), this.year = this.el.dataset.year, this.month = this.el.dataset.month, this.day = this.el.dataset.day, this.hour = this.el.dataset.hour, this.minute = this.el.dataset.minute, this.daysPlaceholder = this.querySelector("[date-days-placeholder]"), this.hoursPlaceholder = this.querySelector("[date-hours-placeholder]"), this.minutesPlaceholder = this.querySelector("[date-minutes-placeholder]"), this.secondsPlaceholder = this.querySelector("[date-seconds-placeholder]"), this.messagePlaceholder = this.querySelector("[data-message-placeholder]"), this.hideTimerOnComplete = this.el.dataset.hideTimer, this.completeMessage = this.el.dataset.completeMessage, this.timerComplete = !1, this.init()
            }
            init() {
                setInterval(() => {
                    this.timerComplete || this._calculate()
                }, 1e3)
            }
            _calculate() {
                let e = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +(new Date).getTime();
                if (e > 0) {
                    let t = {
                        days: Math.floor(e / 864e5),
                        hours: Math.floor(e / 36e5 % 24),
                        minutes: Math.floor(e / 1e3 / 60 % 60),
                        seconds: Math.floor(e / 1e3 % 60)
                    };
                    this.daysPlaceholder.innerHTML = t.days, this.hoursPlaceholder.innerHTML = t.hours, this.minutesPlaceholder.innerHTML = t.minutes, this.secondsPlaceholder.innerHTML = t.seconds
                } else this.completeMessage && this.messagePlaceholder && this.messagePlaceholder.classList.add("countdown__timer-message--visible"), "true" === this.hideTimerOnComplete && (this.display.classList.remove("countdown__display--visible"), this.display.classList.add("countdown__display--hidden")), this.completeMessage || "true" !== this.hideTimerOnComplete || this.block.classList.add("countdown__block--hidden"), this.timerComplete = !0
            }
        }
        customElements.define("countdown-timer", y);
        class _ extends HTMLElement {
            constructor() {
                super(), this.el = this, this.buttons = this.querySelectorAll("[data-button]"), this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]"), this.blockContainer = this.querySelector("[data-block-container]"), this.colorImages = this.querySelectorAll(".grid-product__color-image"), this.colorSwatches = this.querySelectorAll(".color-swatch--with-image"), this._bindEvents(), this._setupQuickShop(), this.colorImages.length && this._colorSwatchHovering()
            }
            _colorSwatchHovering() {
                this.colorSwatches.forEach(e => {
                    e.addEventListener("mouseenter", (function() {
                        this._setActiveColorImage(e)
                    }).bind(this)), e.addEventListener("touchstart", (function(t) {
                        t.preventDefault(), this._setActiveColorImage(e)
                    }).bind(this), {
                        passive: !0
                    }), e.addEventListener("mouseleave", (function() {
                        this._removeActiveColorImage(e)
                    }).bind(this))
                })
            }
            _setActiveColorImage(e) {
                var t = e.dataset.variantId,
                    i = e.dataset.variantImage;
                this.colorImages.forEach(e => {
                    e.classList.remove("is-active")
                }), this.colorSwatches.forEach(e => {
                    e.classList.remove("is-active")
                });
                var s = this.el.querySelector(".grid-product__color-image--" + t);
                s.style.backgroundImage = "url(" + i + ")", s.classList.add("is-active"), e.classList.add("is-active");
                var n = e.dataset.url,
                    a = e.closest(".grid-item__link");
                a && a.setAttribute("href", n)
            }
            _removeActiveColorImage(e) {
                let t = e.dataset.variantId;
                this.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active")
            }
            _bindEvents() {
                this.buttons.forEach(e => {
                    let t = e.dataset.button;
                    e.on("click", e => {
                        e.preventDefault(), e.stopPropagation(), this._showContent(t)
                    })
                }), document.addEventListener("shopify:block:select", e => {
                    let t = e.detail.blockId;
                    this._showContent(`${t}`)
                })
            }
            _showContent(e) {
                this.hotspotBlocks.forEach(t => {
                    t.dataset.hotspotBlock === e ? t.classList.add("is-active") : t.classList.remove("is-active")
                })
            }
            _setupQuickShop() {
                this.querySelectorAll('[data-block-type="product"]').length > 0 && ("function" == typeof theme.QuickShop ? new theme.QuickShop(this.blockContainer) : "function" == typeof theme.initQuickShop && theme.initQuickShop(), "function" == typeof theme.QuickAdd && new theme.QuickAdd(this.blockContainer))
            }
        }
        customElements.define("hot-spots", _);
        class S extends HTMLElement {
            constructor() {
                super(), this.el = this, this.sectionId = this.dataset.sectionId, this.button = this.querySelector("[data-button]"), this.draggableContainer = this.querySelector("[data-draggable]"), this.primaryImage = this.querySelector("[data-primary-image]"), this.secondaryImage = this.querySelector("[data-secondary-image]"), this.calculateSizes(), this.active = !1, this.currentX = 0, this.initialX = 0, this.xOffset = 0, this.buttonOffset = this.button.offsetWidth / 2, this.el.addEventListener("touchstart", this.dragStart, !1), this.el.addEventListener("touchend", this.dragEnd, !1), this.el.addEventListener("touchmove", this.drag, !1), this.el.addEventListener("mousedown", this.dragStart, !1), this.el.addEventListener("mouseup", this.dragEnd, !1), this.el.addEventListener("mousemove", this.drag, !1), window.on("resize", theme.utils.debounce(250, () => {
                    this.calculateSizes(!0)
                })), document.addEventListener("shopify:section:load", e => {
                    e.detail.sectionId === this.sectionId && null !== this.primaryImage && this.calculateSizes()
                })
            }
            calculateSizes(e = !1) {
                this.active = !1, this.currentX = 0, this.initialX = 0, this.xOffset = 0, this.buttonOffset = this.button.offsetWidth / 2, this.elWidth = this.el.offsetWidth, this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`, this.primaryImage && (this.primaryImage.style.width = `${this.elWidth}px`), e && (this.draggableContainer.style.width = this.elWidth / 2 + "px")
            }
            dragStart(e) {
                "touchstart" === e.type ? this.initialX = e.touches[0].clientX - this.xOffset : this.initialX = e.clientX - this.xOffset, e.target === this.button && (this.active = !0)
            }
            dragEnd(e) {
                this.initialX = this.currentX, this.active = !1
            }
            drag(e) {
                this.active && (e.preventDefault(), "touchmove" === e.type ? this.currentX = e.touches[0].clientX - this.initialX : this.currentX = e.clientX - this.initialX, this.xOffset = this.currentX, this.setTranslate(this.currentX, this.button))
            }
            setTranslate(e, t) {
                let i = e - this.buttonOffset,
                    s = this.elWidth / 2 + e,
                    n = -1 * (this.elWidth / 2 + this.buttonOffset),
                    a = this.elWidth / 2 - this.buttonOffset;
                i < n + 50 ? (i = n + 50, s = 50) : i > a - 50 && (i = a - 50, s = this.elWidth - 50), t.style.transform = `translate(${i}px, -50%)`, this.draggableContainer.style.width = `${s}px`
            }
        }

        function b(e) {
            "loading" != document.readyState ? e() : document.addEventListener("DOMContentLoaded", e)
        }
        customElements.define("image-compare", S), theme.Blog = function() {
            function e(e) {
                this.tagFilters()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                tagFilters: function() {
                    var e = document.getElementById("BlogTagFilter");
                    e && e.addEventListener("change", function() {
                        location.href = e.value
                    })
                }
            }), e
        }(), theme.CollectionHeader = function() {
            var e = !1;

            function t(t) {
                this.namespace = ".collection-header";
                var i = t.querySelector(".collection-hero");
                i ? (e && this.checkIfNeedReload(), i.classList.remove("loading", "loading--delayed"), i.classList.add("loaded")) : theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader(), e = !0
            }
            return t.prototype = Object.assign({}, t.prototype, {
                checkIfNeedReload: function() {
                    Shopify.designMode && theme.settings.overlayHeader && (document.querySelector(".header-wrapper").classList.contains("header-wrapper--overlay") || location.reload())
                }
            }), t
        }(), theme.CollectionSidebar = function() {
            var e = !1;

            function t(e) {
                this.container = e.querySelector("#CollectionSidebar")
            }
            return t.prototype = Object.assign({}, t.prototype, {
                init: function() {
                    this.container && (this.onUnload(), e = "drawer" === this.container.dataset.style, theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0))
                },
                forceReload: function() {
                    this.init()
                },
                onSelect: function() {
                    if (theme.FilterDrawer) {
                        if (!e) return void theme.FilterDrawer.close();
                        (e || theme.config.bpSmall) && theme.FilterDrawer.open()
                    }
                },
                onDeselect: function() {
                    theme.FilterDrawer && theme.FilterDrawer.close()
                },
                onUnload: function() {
                    theme.FilterDrawer && theme.FilterDrawer.close()
                }
            }), t
        }(), theme.Collection = function() {
            var e = !1,
                t = "tag--active",
                i = "is-open";

            function s(e) {
                this.container = e, this.sectionId = e.getAttribute("data-section-id"), this.namespace = ".collection-" + this.sectionId, this.sidebar = new theme.CollectionSidebar(e), this.context = e.getAttribute("data-context"), this.ajaxRenderer = new theme.AjaxRenderer({
                    sections: [{
                        sectionId: this.sectionId,
                        nodeId: "CollectionAjaxContent"
                    }],
                    onReplace: this.onReplaceAjaxContent.bind(this)
                }), this.init()
            }
            return s.prototype = Object.assign({}, s.prototype, {
                init: function() {
                    this.context && "featured-collection" === this.context ? this.colorSwatchHovering() : (this.initSort(), this.colorSwatchHovering(), this.initFilters(), this.initPriceRange(), this.sidebar.init())
                },
                initSort: function() {
                    if (this.sortSelectSelectorAll = document.querySelectorAll("#SortBy"), this.sortSelectSelectorAll.length > 0) {
                        this.sortSelect = this.sortSelectSelectorAll, this.defaultSort = [];
                        for (let e = 0; e < this.sortSelectSelectorAll.length; e++) this.defaultSort[e] = this.getDefaultSortValue(e), this.sortSelectSelectorAll[e].on("change" + this.namespace, t => {
                            this.onSortChange(e)
                        })
                    }
                },
                getSortValue: function(e) {
                    return this.sortSelect[e].value || this.defaultSort[e]
                },
                getDefaultSortValue: function(e) {
                    return this.sortSelect[e].getAttribute("data-default-sortby")
                },
                onSortChange: function(e) {
                    this.queryParams = new URLSearchParams(window.location.search), this.queryParams.set("sort_by", this.getSortValue(e)), this.queryParams.delete("page"), window.location.search = this.queryParams.toString()
                },
                colorSwatchHovering: function() {
                    if (!this.container.querySelectorAll(".grid-product__color-image").length && !this.container.querySelector(".grid-product-siblings")) return;
                    let e = e => {
                            if (e.closest(".grid__item.grid-product") && !e.closest(".grid-product-siblings")) {
                                var t = e.closest(".grid-product"),
                                    i = e.dataset.variantId,
                                    s = e.dataset.productId,
                                    n = e.dataset.variantUrl,
                                    a = e.dataset.variantImage,
                                    p = e.dataset.variantPrice,
                                    r = this.container.querySelector(".grid-product__color-image--" + i);
                                return r.style.backgroundImage = "url(" + a + ")", r.classList.add("is-active"), this.container.querySelector(".prd-color-swatch-" + s + ".swatch-active").classList.remove("swatch-active"), t.querySelector('.list-price-inner').innerHTML=theme.Currency.formatMoney(p, theme.settings.moneyFormat).split(".")[0], e.classList.add("swatch-active"), void t.querySelectorAll(".grid-product__link").forEach(e => {
                                    e.setAttribute("href", n)
                                })
                            }
                        },
                        t = e => {
                            if (e.closest(".grid__item.grid-product") && e.matches(":hover") && !e.closest(".grid-product-siblings")) {
                                var h = e.closest(".grid-product"),
                                    t = e.dataset.variantId,
                                    i = e.dataset.variantImage,
                                    p = e.dataset.variantPrice,
                                    s = this.container.querySelector(".grid-product__color-image--" + t);
                                return s.style.backgroundImage = "url(" + i + ")",/* h.querySelector('.list-price-inner').innerHTML=theme.Currency.formatMoney(p, theme.settings.moneyFormat).split(".")[0],*/ void s.classList.add("is-active")
                            }
                        },
                        i = e => {
                            if (e.closest(".grid__item.grid-product") && !e.classList.contains("swatch-active")) {
                                if (e.closest(".grid-product-siblings"));
                                else {
                                    var t = e.dataset.variantId;
                                    this.container.querySelector(".grid-product__color-image--" + t).classList.remove("is-active")
                                }
                            }
                        };
                    this.container.querySelectorAll(".color-swatch").forEach(s => {
                        s.classList.contains("disabled") || (s.addEventListener("click", t => {
                            t.preventDefault(), setTimeout(() => {
                                e(s)
                            }, 100)
                        }), s.addEventListener("mouseenter", e => {
                            setTimeout(() => {
                                t(s)
                            }, 100)
                        }), s.addEventListener("mouseleave", e => {
                            setTimeout(() => {
                                i(s)
                            }, 100)
                        }))
                    })
                },
                initFilters: function() {
                    document.querySelectorAll(".tag-list input").length && (this.bindBackButton(), theme.config.stickyHeader && (this.setFilterStickyPosition(), window.on("resize", theme.utils.debounce(500, this.setFilterStickyPosition))), document.querySelectorAll(".tag-list a").forEach(e => {}), document.querySelectorAll(".filter-form").forEach(e => {}))
                },
                initPriceRange: function() {
                    document.querySelectorAll(".price-range").forEach(e => new theme.PriceRange(e, {
                        onChange: this.renderFromFormData.bind(this)
                    }))
                },
                tagClick: function(t) {
                    var i = t.currentTarget;
                    if (theme.FilterDrawer && theme.FilterDrawer.close(), i.classList.contains("no-ajax") || (t.preventDefault(), e)) return;
                    e = !0;
                    let s = i.parentNode,
                        n = new URL(i.href);
                    this.renderActiveTag(s, i), this.updateScroll(!0), this.startLoading(), this.renderCollectionPage(n.searchParams)
                },
                onFormSubmit: function(t) {
                    var i = t.target;
                    if ("text" == i.type || (theme.FilterDrawer && theme.FilterDrawer.close(), i.classList.contains("no-ajax")) || (t.preventDefault(), e)) return;
                    e = !0;
                    let s = i.closest("li"),
                        n = i.closest("form"),
                        a = new FormData(n);
                    this.renderActiveTag(s, i), this.updateScroll(!0), this.startLoading(), this.renderFromFormData(a)
                },
                fetchOpenCollasibleFilters: function() {
                    return Array.from(document.querySelectorAll(`#CollectionSidebar .collapsible-trigger.${i}`)).map(e => e.dataset.collapsibleId)
                },
                renderActiveTag: function(e, i) {
                    let s = e.querySelector(".tag__text");
                    e.classList.contains(t) ? e.classList.remove(t) : (e.classList.add(t), i.closest("li").classList.contains("tag--remove") ? e.remove() : document.querySelectorAll(".tag-list--active-tags").forEach(e => {
                        let t = document.createElement("li"),
                            i = document.createElement("a");
                        t.classList.add("tag", "tag--remove"), i.classList.add("btn", "btn--small"), i.innerText = s.innerText, t.appendChild(i), e.appendChild(t)
                    }))
                },
                renderFromFormData: function(e) {
                    let t = new URLSearchParams(e);
                    this.renderCollectionPage(t)
                },
                onReplaceAjaxContent: function(e, t) {
                    return window.location.reload(), !1
                },
                openCollapsible: function(e) {
                    e.classList.contains("collapsible-content--sidebar") && (e.style.height = "auto"), e.classList.add(i)
                },
                renderCollectionPage: function(t, i = !0) {
                    this.ajaxRenderer.renderPage(window.location.pathname, t, i).then(() => {
                        theme.sections.reinit("collection-grid"), this.updateScroll(!1), this.initPriceRange(), theme.reinitProductGridItem(), document.dispatchEvent(new CustomEvent("collection:reloaded")), e = !1
                    })
                },
                bindBackButton: function() {
                    window.off("popstate" + this.namespace), window.on("popstate" + this.namespace, (function(e) {
                        if (e) {
                            let t = new URL(window.location.href);
                            this.renderCollectionPage(t.searchParams, !1)
                        }
                    }).bind(this))
                },
                updateScroll: function(e) {
                    var t = document.querySelector("[data-scroll-to]"),
                        i = t && t.offsetTop;
                    theme.config.bpSmall || (i -= 15), theme.config.stickyHeader && (i -= document.querySelector(".site-header").offsetHeight), e ? window.scrollTo({
                        top: i,
                        behavior: "smooth"
                    }) : window.scrollTo({
                        top: i
                    })
                },
                setFilterStickyPosition: function() {
                    var e = document.querySelector(".site-header").offsetHeight;
                    document.querySelector(".collection-filter").style.top = e + 10 + "px";
                    var t = document.querySelector(".grid__item--sidebar");
                    t && (t.style.top = e + 10 + "px")
                },
                forceReload: function() {
                    this.init()
                },
                startLoading: function() {
                    document.querySelector(".collection-grid__wrapper").classList.add("unload")
                }
            }), s
        }(), theme.FooterSection = function() {
            function e(e) {
                this.container = e, this.localeDisclosure = null, this.currencyDisclosure = null, this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    var e = this.container.querySelector("[data-disclosure-locale]"),
                        t = this.container.querySelector("[data-disclosure-currency]");
                    e && (this.localeDisclosure = new theme.Disclosure(e)), t && (this.currencyDisclosure = new theme.Disclosure(t));
                    var i = document.querySelector(".footer__newsletter-input");
                    i && i.addEventListener("keyup", function() {
                        i.classList.add("footer__newsletter-input--active")
                    }), theme.collapsibles.init(this.container)
                },
                onUnload: function() {
                    this.localeDisclosure && this.localeDisclosure.destroy(), this.currencyDisclosure && this.currencyDisclosure.destroy()
                }
            }), e
        }(), theme.HeaderSection = function() {
            function e(e) {
                this.container = e, this.sectionId = this.container.getAttribute("data-section-id"), this.init()
            }
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    Shopify && Shopify.designMode && (theme.sections.reinit("slideshow-section"), setTimeout(function() {
                        window.dispatchEvent(new Event("resize"))
                    }, 500)), this.initDrawers(), this.initDisclosures(), theme.headerNav.init(), theme.announcementBar.init(), this.hoverMenu()
                },
                hoverMenu: function() {
                    document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]').forEach(e => {
                        let t = e.querySelector("summary"),
                            i = t.dataset.link;
                        t.addEventListener("click", e => {
                            e.preventDefault(), window.location.href = i
                        }), e.addEventListener("mouseover", () => {
                            e.hasAttribute("open") || (e.setAttribute("open", ""), e.setAttribute("aria-expanded", "true"))
                        }), e.addEventListener("mouseleave", () => {
                            e.hasAttribute("open") && (e.removeAttribute("open"), e.setAttribute("aria-expanded", "false"))
                        })
                    })
                },
                initDisclosures: function() {
                    var e = this.container.querySelector("[data-disclosure-locale]"),
                        t = this.container.querySelector("[data-disclosure-currency]");
                    e && (this.localeDisclosure = new theme.Disclosure(e)), t && (this.currencyDisclosure = new theme.Disclosure(t))
                },
                initDrawers: function() {
                    theme.NavDrawer = new theme.Drawers("NavDrawer", "nav"), "drawer" === theme.settings.cartType && (document.body.classList.contains("template-cart") || new theme.CartDrawer), theme.collapsibles.init(document.getElementById("NavDrawer"))
                },
                onUnload: function() {
                    theme.NavDrawer.close(), theme.announcementBar.unload(), this.localeDisclosure && this.localeDisclosure.destroy(), this.currencyDisclosure && this.currencyDisclosure.destroy()
                }
            }), e
        }(), theme.Product = function() {
            var e = {},
                t = "disabled",
                i = "hide",
                s = "inventory--low",
                n = ".product__video",
                a = ".product__video-wrapper",
                r = ".product-main-slide",
                o = ".starting-slide";

            function c(e) {
                this.container = e;
                var t = this.sectionId = e.getAttribute("data-section-id"),
                    i = this.productId = e.getAttribute("data-product-id");
                this.inModal = "true" === e.dataset.modal, this.modal, this.settings = {
                    enableHistoryState: e.dataset.history || !1,
                    namespace: ".product-" + t,
                    inventory: !1,
                    inventoryThreshold: 10,
                    modalInit: !1,
                    hasImages: !0,
                    imageSetName: null,
                    imageSetIndex: null,
                    currentImageSet: null,
                    imageSize: "620x",
                    currentSlideIndex: 0,
                    videoLooping: e.dataset.videoLooping
                }, this.inModal && (this.settings.enableHistoryState = !1, this.settings.namespace = ".product-" + t + "-modal", this.modal = document.getElementById("QuickShopModal-" + i)), this.selectors = {
                    variantsJson: "[data-variant-json]",
                    currentVariantJson: "[data-current-variant-json]",
                    form: ".product-single__form",
                    media: "[data-product-media-type-model]",
                    closeMedia: ".product-single__close-media",
                    photoThumbs: "[data-product-thumb]",
                    thumbSlider: "[data-product-thumbs]",
                    thumbScroller: ".product__thumbs--scroller",
                    mainSlider: "[data-product-photos]",
                    imageContainer: "[data-product-images]",
                    productImageMain: "[data-product-image-main]",
                    priceWrapper: "[data-product-price-wrap]",
                    price: "[data-product-price]",
                    comparePrice: "[data-compare-price]",
                    comparePriceEl: "[data-compare-price-el]",
                    savePrice: "[data-save-price]",
                    priceA11y: "[data-a11y-price]",
                    comparePriceA11y: "[data-compare-price-a11y]",
                    unitWrapper: "[data-unit-price-wrapper]",
                    unitPrice: "[data-unit-price]",
                    unitPriceBaseUnit: "[data-unit-base]",
                    sku: "[data-sku]",
                    inventory: "[data-product-inventory]",
                    incomingInventory: "[data-incoming-inventory]",
                    colorLabel: "[data-variant-color-label]",
                    addToCart: "[data-add-to-cart]",
                    addToCartText: "[data-add-to-cart-text]",
                    originalSelectorId: "[data-product-select]",
                    singleOptionSelector: "[data-variant-input]",
                    singleOptionLabel: "[data-variant-label]",
                    variantColorSwatch: ".variant__input--color-swatch",
                    dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
                    availabilityContainer: "[data-store-availability-holder]"
                }, this.cacheElements(), this.firstProductImage = this.cache.mainSlider.querySelector("img"), this.firstProductImage || (this.settings.hasImages = !1);
                var s = this.cache.mainSlider.querySelector("[data-set-name]");
                s && (this.settings.imageSetName = s.dataset.setName), this.init()
            }

            function updateBundleDescription(t) {
                document.querySelector(".product-main-description-tab").innerHTML = t;
                let a = document.querySelectorAll(".product-fields-col"),
                    e = Array.from(document.querySelectorAll(".product-fields-col")).filter(t => "none" !== window.getComputedStyle(t).display).length,
                    i = 100 / e;
                a.forEach(t => {
                    t.style.flexBasis = `calc(${i}% - 25px)`
                })
            }
            return c.prototype = Object.assign({}, c.prototype, {
                init: function() {
                    this.inModal && (this.container.classList.add("is-modal"), document.addEventListener("modalOpen.QuickShopModal-" + this.productId, this.openModalProduct.bind(this)), document.addEventListener("modalClose.QuickShopModal-" + this.productId, this.closeModalProduct.bind(this)));
                    var page_description_tab_content = "",
                        newTabContent = "";
                    document.querySelector(".product-main-description-tab") && (page_description_tab_content = document.querySelector(".product-main-description-tab").innerHTML), document.querySelectorAll(".pr-bundle-tab-heading") && document.querySelectorAll(".pr-bundle-tab-heading").forEach(e => {
                        e.addEventListener("click", function(t) {
                            if ("bundle-item-tab" == e.getAttribute("data-tab")) {
                                let n = document.querySelector('[data-section-type="product"] [data-product-price]').innerHTML,
                                    r = document.querySelector("#is_bundle_added");
                                if ("no" == r.value) {
                                    document.querySelector("#dynamic-content").classList.remove("hide");
                                    var i = "";
                                    document.getElementsByTagName("nav") && (i = document.querySelector("nav").innerHTML);
                                    let o = e.getAttribute("data-bundle-handle");
                                    fetch(`/products/${o}?view=bundles`).then(e => e.text()).then(e => {
                                        let t = new DOMParser,
                                            o = t.parseFromString(e, "text/html"),
                                            c = document.querySelector("#dynamic-content"),
                                            a = o.querySelector("#bundle-item-section-main");
                                        a.querySelectorAll(".product-main-description-tab").forEach(e => e.remove()), c.innerHTML = a.innerHTML;
                                        let bi = document.getElementById("product-bundle-main-img").innerHTML;
                                        document.querySelector("#bundle-current-item").innerHTML = bi, document.querySelector(".product-bundle-nav").innerHTML = i, document.querySelector(".bundle-pdp-single-item-price").innerHTML = n;
                                        let d = c.querySelector('[data-section-type="bundle-product"]');
                                        new theme.Product(d), requestAnimationFrame(() => {
                                            initPDPSlick(d);
                                            let e = d.querySelector(".product__thumb-item[data-group]:not(.product__thumb-item-360-view)")?.getAttribute("data-group");
                                            e && stableUpdateNavByGroup(e, d), setTimeout(() => {
                                                refreshVisibleSlick(d)
                                            }, 100)
                                        }), updateBundleDescription(newTabContent = o.querySelector(".product-main-description-tab").innerHTML), r.value = "yes"
                                    }).catch(e => {
                                        console.error(e)
                                    })
                                } else document.querySelector("#dynamic-content").classList.remove("hide"), setTimeout(() => {
                                    document.querySelector("#dynamic-content"), refreshVisibleSlick(document)
                                }, 100), "" != newTabContent && updateBundleDescription(newTabContent);
                                document.querySelector(".item-main-content-el").classList.add("hide")
                            } else document.querySelector("#dynamic-content").classList.add("hide"), document.querySelector(".item-main-content-el").classList.remove("hide"), setTimeout(() => {
                                refreshVisibleSlick(document)
                            }, 100), "" != page_description_tab_content && (document.querySelector(".product-main-description-tab").innerHTML = page_description_tab_content);
                            let c = "product-main-description-tab-parent";
                            document.querySelectorAll(`.${c}`) && document.querySelector(`.${c}`).classList.contains("is-open") && (document.querySelector(`.${c}`).style.height = "auto", setTimeout(() => {
                                var e = document.querySelector(`.${c}`).offsetHeight;
                                document.querySelector(`.${c}`).style.height = e + "px"
                            }, 2e3))
                        })
                    }), this.inModal || (this.formSetup(), this.productSetup(), this.videoSetup(), this.customMediaListners(), this.addIdToRecentlyViewed(), document.querySelector(".product-new-version-yotpo") && this.yotpoReviewManage())
                },
                cacheElements: function() {
                    this.cache = {
                        form: this.container.querySelector(this.selectors.form),
                        mainSlider: this.container.querySelector(this.selectors.mainSlider),
                        thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
                        thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
                        productImageMain: this.container.querySelector(this.selectors.productImageMain),
                        priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
                        comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
                        comparePrice: this.container.querySelector(this.selectors.comparePrice),
                        comparePriceEl: this.container.querySelector(this.selectors.comparePriceEl),
                        price: this.container.querySelector(this.selectors.price),
                        savePrice: this.container.querySelector(this.selectors.savePrice),
                        priceA11y: this.container.querySelector(this.selectors.priceA11y)
                    }
                },
                formSetup: function() {
                    this.initQtySelector(), this.initAjaxProductForm(), this.availabilitySetup(), this.initVariants(), this.settings.imageSetName && this.updateImageSet()
                },
                availabilitySetup: function() {
                    var e = this.container.querySelector(this.selectors.availabilityContainer);
                    e && (this.storeAvailability = new theme.StoreAvailability(e))
                },
                productSetup: function() {
                    this.setImageSizes(), this.initImageZoom(), this.initModelViewerLibraries(), this.initShopifyXrLaunch(), window.SPR && (SPR.initDomEls(), SPR.loadBadges())
                },
                setImageSizes: function() {
                    if (this.settings.hasImages) {
                        var e = this.firstProductImage.currentSrc;
                        e && (this.settings.imageSize = theme.Images.imageSize(e))
                    }
                },
                addIdToRecentlyViewed: function() {
                    var e = this.container.getAttribute("data-product-handle"),
                        t = this.container.getAttribute("data-product-url"),
                        i = this.container.getAttribute("data-aspect-ratio"),
                        s = this.container.getAttribute("data-img-url");
                    theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e], theme.recentlyViewed.recent[e] = {
                        url: t,
                        aspectRatio: i,
                        featuredImage: s
                    }, theme.config.hasLocalStorage && window.localStorage.setItem("theme-recent", JSON.stringify(theme.recentlyViewed.recent))
                },
                yotpoReviewManage: function() {
                    var e = window.jQuery,
                        t = setInterval(function() {
                            e(".yotpo-header-container").length ? (e(".product-new-version-yotpo").addClass("hidden"), clearInterval(t)) : e(".yotpo-empty-state").length && (e(".product-new-version-yotpo").removeClass("hidden"), e(".yotpo-widget-instance").addClass("hidden"), clearInterval(t))
                        }, 100)
                },
                initVariants: function() {
                    var e = this.container.querySelector(this.selectors.variantsJson);
                    if (e) {
                        this.variantsObject = JSON.parse(e.innerHTML);
                        var t = !!this.container.querySelector("[data-dynamic-variants-enabled]"),
                            i = {
                                container: this.container,
                                enableHistoryState: this.settings.enableHistoryState,
                                singleOptionSelector: this.selectors.singleOptionSelector,
                                singleOptionLabel: this.selectors.singleOptionLabel,
                                originalSelectorId: this.selectors.originalSelectorId,
                                variants: this.variantsObject,
                                dynamicVariantsEnabled: t
                            },
                            s = this.container.querySelectorAll(this.selectors.variantColorSwatch);
                        if (s.length && s.forEach(e => {
                                e.addEventListener("change", (function(t) {
                                    var i = e.dataset.colorName,
                                        s = e.dataset.colorIndex;
                                    this.updateColorName(i, s)
                                }).bind(this))
                            }), this.variants = new theme.Variants(i), this.storeAvailability) {
                            var n = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
                            this.storeAvailability.updateContent(n), this.container.on("variantChange" + this.settings.namespace, this.updateAvailability.bind(this))
                        }
                        this.container.on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this)), this.container.on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this)), this.container.on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this)), this.container.on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)), this.container.querySelector(this.selectors.sku) && this.container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this));
                        var a = this.container.querySelector(this.selectors.inventory);
                        if (a && (this.settings.inventory = !0, this.settings.inventoryThreshold = a.dataset.threshold, this.updateInventory({
                                detail: {
                                    variant: this.variants.currentVariant
                                }
                            }), this.container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this))), t) {
                            var r = this.container.querySelector(this.selectors.currentVariantJson);
                            if (r) {
                                var o = this.container.querySelector(".variant-wrapper");
                                o && new theme.VariantAvailability({
                                    container: this.container,
                                    namespace: this.settings.namespace,
                                    type: o.dataset.type,
                                    variantsObject: this.variantsObject,
                                    currentVariantObject: JSON.parse(r.innerHTML)
                                })
                            }
                        }
                        if (this.settings.imageSetName) {
                            var c = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]');
                            c ? (this.settings.imageSetIndex = c.dataset.index, this.container.on("variantChange" + this.settings.namespace, this.updateImageSet.bind(this))) : this.settings.imageSetName = null
                        }
                    }
                },
                initQtySelector: function() {
                    this.container.querySelectorAll(".js-qty__wrapper").forEach(e => {
                        new theme.QtySelector(e, {
                            namespace: ".product"
                        })
                    })
                },
                initAjaxProductForm: function() {
                    "drawer" === theme.settings.cartType && new theme.AjaxProduct(this.cache.form)
                },
                updateColorName: function(e, t) {
                    this.container.querySelector(this.selectors.colorLabel + `[data-index="${t}"`).textContent = e
                },
                updateCartButton: function(e) {
                    var i = e.detail.variant,
                        s = this.container.querySelector(this.selectors.addToCart),
                        n = this.container.querySelector(this.selectors.addToCartText);
                    if (s) {
                        if (i) {
                            if (i.available) {
                                s.classList.remove(t), s.disabled = !1;
                                var a = n.dataset.defaultText;
                                n.textContent = a
                            } else s.classList.add(t), s.disabled = !0, n.textContent = theme.strings.soldOut
                        } else s.classList.add(t), s.disabled = !0, n.textContent = theme.strings.unavailable
                    }
                },
                updatePrice: function(e) {
                    var t = e.detail.variant;
                    if (t) {
                        this.cache.price.innerHTML = theme.Currency.formatMoney(t.price, theme.settings.moneyFormat).split(".")[0];
                        var i = t.price;
                        if (document.querySelector(".sale-message-pdp") && "Remi Rhode" != document.querySelector("#item-vendor").value) {
                            var s = i / 100,
                                s = i / 100,
                                svg = '<svg viewBox="0 0 511 511.99978" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m235.792969 347.265625c3.902343-3.910156 3.902343-10.238281 0-14.148437-3.90625-3.898438-10.234375-3.898438-14.144531 0-3.898438 3.910156-3.898438 10.238281 0 14.148437 3.910156 3.898437 10.238281 3.898437 14.144531 0zm0 0"/><path d="m188.449219 109.96875c0 60.636719 49.332031 109.972656 109.96875 109.972656s109.96875-49.335937 109.96875-109.972656-49.332031-109.96875-109.96875-109.96875-109.96875 49.332031-109.96875 109.96875zm199.945312 0c0 49.613281-40.363281 89.976562-89.976562 89.976562s-89.976563-40.363281-89.976563-89.976562c0-49.609375 40.363282-89.972656 89.976563-89.972656s89.976562 40.363281 89.976562 89.972656zm0 0"/><path d="m115.652344 509.042969c3.875 3.90625 10.183594 3.949219 14.109375.082031l48.46875-47.75c8.234375-8.234375 10.738281-20.425781 7.117187-31.023438l10.425782-10.054687c5.613281-5.421875 13.003906-8.410156 20.816406-8.410156h132.902344c23.578124 0 45.863281-9.054688 62.757812-25.496094.695312-.675781-5.277344 6.359375 90.667969-108.3125 14.230469-16.835937 12.101562-42.117187-4.75-56.363281-16.746094-14.113282-41.832031-12.085938-56.101563 4.460937l-58.992187 60.632813c-7.449219-9.167969-18.808594-14.882813-31.082031-14.882813h-111.480469c-15.863281-6.636719-32.695313-9.996093-50.0625-9.996093-48.140625 0-90.175781 22.234374-112.734375 63.921874-9.503906-1.800781-19.527344 1.074219-26.738282 8.285157l-47.558593 47.699219c-3.882813 3.894531-3.890625 10.195312-.015625 14.101562zm74.792968-227.121094c15.3125 0 30.117188 3.082031 44.011719 9.160156 1.265625.554688 2.628907.839844 4.007813.839844h113.527344c10.839843 0 19.996093 8.839844 19.996093 19.992187 0 11.027344-8.96875 19.996094-19.996093 19.996094h-81.566407c-5.519531 0-9.996093 4.476563-9.996093 9.996094 0 5.523438 4.476562 9.996094 9.996093 9.996094h81.566407c22.050781 0 39.988281-17.9375 39.988281-39.988282 0-1.757812-.125-3.5-.351563-5.226562 57.066406-58.660156 65.113282-66.902344 65.457032-67.3125 7.125-8.410156 19.773437-9.476562 28.1875-2.382812 8.421874 7.121093 9.488281 19.761718 2.34375 28.21875l-89.667969 107.195312c-13.09375 12.570312-30.285157 19.488281-48.457031 19.488281h-132.902344c-13.023438 0-25.351563 4.980469-34.703125 14.015625l-8.496094 8.199219-78.320313-78.316406c18.304688-34.339844 52.652344-53.871094 95.375-53.871094zm-125.320312 66.34375c3.296875-3.296875 8.359375-3.890625 12.378906-1.40625 1.730469 1.054687-3.238281-3.46875 86.589844 86.234375 3.996094 3.996094 3.78125 10.363281.054688 14.089844l-41.320313 40.707031-98.230469-98.980469zm0 0"/><path d="m286.421875 49.988281v11.714844c-11.636719 4.125-19.996094 15.238281-19.996094 28.273437 0 16.535157 13.453125 29.992188 29.992188 29.992188 5.511719 0 9.996093 4.484375 9.996093 9.996094 0 5.511718-4.484374 9.996094-9.996093 9.996094-4.269531 0-8.882813-2.683594-12.980469-7.5625-3.554688-4.226563-9.859375-4.769532-14.085938-1.21875-4.226562 3.554687-4.773437 9.859374-1.21875 14.085937 5.34375 6.355469 11.628907 10.785156 18.289063 13.019531v11.667969c0 5.523437 4.476563 9.996094 9.996094 9.996094s9.996093-4.472657 9.996093-9.996094v-11.714844c11.636719-4.128906 19.996094-15.242187 19.996094-28.273437 0-16.539063-13.453125-29.992188-29.992187-29.992188-5.511719 0-9.996094-4.484375-9.996094-9.996094 0-5.511718 4.484375-10 9.996094-10 3.542969 0 7.28125 1.808594 10.8125 5.226563 3.96875 3.839844 10.296875 3.734375 14.136719-.230469 3.839843-3.96875 3.734374-10.296875-.230469-14.136718-5.074219-4.910157-10.152344-7.6875-14.722657-9.203126v-11.644531c0-5.523437-4.476562-10-9.996093-10s-9.996094 4.476563-9.996094 10zm0 0"/></svg>';
                            if (s < 500) var e, n = 5e4 - t.price,
                                a = 1e5 - t.price,
                                o = `<p><span>${svg} Spend <strong>${theme.Currency.formatMoney(n,theme.settings.moneyFormat).split(".")[0]}</strong> more to get</span><strong class="promo-percentage">10% off</strong></p><p><span>${svg} Spend <strong>${theme.Currency.formatMoney(a,theme.settings.moneyFormat).split(".")[0]}</strong> more to get</span><strong class="promo-percentage">20% off</strong></p><p><span>${svg} Spend <strong>${theme.Currency.formatMoney(2e5-t.price,theme.settings.moneyFormat).split(".")[0]}</strong> more to get</span><strong class="promo-percentage">30% off</strong></p>`;
                            else if (s > 500 && s <= 1000) var c = .9 * t.price,
                                n = 1e5 - t.price,
                                a = 2e5 - t.price,
                                o = `<p class="sale-message-top"><span>${svg}Your price <strong>${theme.Currency.formatMoney(c,theme.settings.moneyFormat).split(".")[0]}</strong></span><strong class="promo-percentage">(Save 10% now)</strong></p><p><span>${svg}Shop for <strong>${theme.Currency.formatMoney(n,theme.settings.moneyFormat).split(".")[0]}</strong> amount more to get</span> <strong class="promo-percentage">20% off</strong></p><p><span>${svg}Shop for <strong>${theme.Currency.formatMoney(a,theme.settings.moneyFormat).split(".")[0]}</strong> amount more to get</span> <strong class="promo-percentage">30% off</strong></p>`;
                            else if (s > 1000 && s <= 2000) var c = .8 * t.price,
                                l = 2e5 - t.price,
                                o = `<p class="sale-message-top"><span>${svg}Your price <strong>${theme.Currency.formatMoney(c,theme.settings.moneyFormat).split(".")[0]}</strong></span><strong class="promo-percentage">(Save 20% now)</strong></p><p><span>${svg}Shop for <strong>${theme.Currency.formatMoney(l,theme.settings.moneyFormat).split(".")[0]}</strong> amount more to get</span> <strong class="promo-percentage">30% off</strong></p>`;
                            else if (s > 2000) var c = .7 * t.price,
                                o = `<p class="sale-message-top"><span>${svg}Your price <strong>${theme.Currency.formatMoney(c,theme.settings.moneyFormat).split(".")[0]}</strong></span><strong class="promo-percentage">(Save 30% now)</strong></p>`;
                            o += "<span>Auto applied on cart*</span>", document.querySelector(".sale-message-pdp-content").innerHTML = o
                        }
                        t.compare_at_price > t.price ? (this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat).split(".")[0], this.cache.comparePriceEl.classList.remove("hide"), this.cache.priceWrapper && this.cache.priceWrapper.classList.remove(a), this.cache.price.classList.add(r), this.cache.comparePriceA11y.setAttribute("aria-hidden", "false"), this.cache.priceA11y.setAttribute("aria-hidden", "false"), s = t.compare_at_price - t.price, s = "percent" == theme.settings.saveType ? Math.round(100 * s / t.compare_at_price) + "%" : theme.Currency.formatMoney(s, theme.settings.moneyFormat), this.cache.savePrice.classList.remove(a), this.cache.savePrice.innerHTML = theme.strings.savePrice.replace("[saved_amount]", s).split(".")[0]) : (this.cache.priceWrapper && this.cache.priceWrapper.classList.add(a), this.cache.comparePriceEl.classList.add(a), this.cache.savePrice.classList.add(a), this.cache.price.classList.remove(r), this.cache.comparePriceA11y && this.cache.comparePriceA11y.setAttribute("aria-hidden", "true"), this.cache.priceA11y.setAttribute("aria-hidden", "true"))
                    }
                },
                updateUnitPrice: function(e) {
                    var t = e.detail.variant;
                    t && t.unit_price ? (this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(t.unit_price, theme.settings.moneyFormat), this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(t), this.container.querySelector(this.selectors.unitWrapper).classList.remove(i)) : this.container.querySelector(this.selectors.unitWrapper).classList.add(i)
                },
                imageSetArguments: function(e) {
                    if (e = e || (this.variants ? this.variants.currentVariant : null)) {
                        var t = this.settings.currentImageSet = this.getImageSetName(e[this.settings.imageSetIndex]),
                            i = this.settings.imageSetName + "_" + t;
                        return this.settings.currentSlideIndex = 0, {
                            cellSelector: '[data-group="' + i + '"]',
                            imageSet: i,
                            initialIndex: this.settings.currentSlideIndex
                        }
                    }
                },
                updateImageSet: function(e) {
                    var t = e ? e.detail.variant : this.variants ? this.variants.currentVariant : null;
                    t && (this.getImageSetName(t[this.settings.imageSetIndex]), this.settings.currentImageSet)
                },
                updateImageSetThumbs: function(e) {
                    this.cache.thumbSlider.querySelectorAll(".product__thumb-item").forEach(t => {
                        t.classList.toggle(i, t.dataset.group !== e)
                    })
                },
                getImageSetName: function(e) {
                    return e.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "")
                },
                updateSku: function(e) {
                    var t = e.detail.variant,
                        i = "";
                    t && (t.sku && (i = t.sku), this.container.querySelector(this.selectors.sku).textContent = i, document.querySelector(".sku_properties").value = i)
                },
                updateInventory: function(e) {
                    var t = e.detail.variant;
                    if (!t || !t.inventory_management || "continue" === t.inventory_policy) return this.toggleInventoryQuantity(!1), void this.toggleIncomingInventory(!0, !1);
                    if ("shopify" === t.inventory_management && window.inventories && window.inventories[this.productId]) {
                        let i = window.inventories[this.productId][t.id],
                            {
                                quantity: s,
                                policy: n,
                                incoming: a,
                                next_incoming_date: r
                            } = i || {};
                        this.toggleInventoryQuantity(s), a && !t.available || s <= 0 && "continue" === n ? this.toggleIncomingInventory(!0, r) : this.toggleIncomingInventory(!1)
                    }
                },
                updateAvailability: function(e) {
                    var t = e.detail.variant;
                    t && this.storeAvailability.updateContent(t.id)
                },
                toggleInventoryQuantity: function(e) {
                    let t = this.container.querySelector(this.selectors.inventory),
                        n = t.closest(".sales-point"),
                        a = !1;
                    parseInt(e) <= parseInt(this.settings.inventoryThreshold) && parseInt(e) > 0 && (a = !0), parseInt(e) > 0 ? (a ? (t.parentNode.classList.add(s), t.textContent = e > 1 ? theme.strings.otherStockLabel.replace("[count]", e) : theme.strings.oneStockLabel.replace("[count]", e)) : (t.parentNode.classList.remove(s), t.textContent = theme.strings.inStockLabel), n && n.classList.remove(i)) : n && n.classList.add(i)
                },
                toggleIncomingInventory: function(e, t) {
                    let s = this.container.querySelector(this.selectors.incomingInventory);
                    if (!s) return;
                    let n = "true" === s.dataset.enabled,
                        a = s.querySelector(".js-incoming-text");
                    n && e ? t ? (a.textContent = theme.strings.willBeInStockAfter.replace("[date]", t), s.classList.remove(i)) : (a.textContent = theme.strings.waitingForStock, s.classList.remove(i)) : s.classList.add(i)
                },
                videoSetup: function() {
                    var e = this.cache.mainSlider.querySelectorAll(n);
                    if (!e.length) return !1;
                    e.forEach(e => {
                        var t = e.dataset.videoType;
                        "youtube" === t ? this.initYoutubeVideo(e) : "vimeo" === t ? this.initVimeoVideo(e) : "mp4" === t && this.initMp4Video(e)
                    })
                },
                initYoutubeVideo: function(t) {
                    e[t.id] = new theme.YouTube(t.id, {
                        videoId: t.dataset.videoId,
                        videoParent: a,
                        autoplay: !1,
                        style: t.dataset.videoStyle,
                        loop: t.dataset.videoLoop,
                        events: {
                            onReady: this.youtubePlayerReady.bind(this),
                            onStateChange: this.youtubePlayerStateChange.bind(this)
                        }
                    })
                },
                initVimeoVideo: function(t) {
                    e[t.id] = new theme.VimeoPlayer(t.id, t.dataset.videoId, {
                        videoParent: a,
                        autoplay: !1,
                        style: t.dataset.videoStyle,
                        loop: t.dataset.videoLoop
                    })
                },
                youtubePlayerReady: function(t) {
                    var i = t.target.getIframe().id;
                    if (e[i]) {
                        var s = e[i],
                            n = s.videoPlayer;
                        "sound" !== s.options.style && n.mute(), s.parent.classList.remove("loading"), s.parent.classList.add("loaded"), s.parent.classList.add("video-interactable"), this._isFirstSlide(i) && "sound" !== s.options.style && n.playVideo()
                    }
                },
                _isFirstSlide: function(e) {
                    return this.cache.mainSlider.querySelector(o + " #" + e)
                },
                youtubePlayerStateChange: function(t) {
                    var i = e[t.target.getIframe().id];
                    switch (t.data) {
                        case -1:
                            i.attemptedToPlay && i.parent.classList.add("video-interactable");
                            break;
                        case 0:
                            i && "true" === i.options.loop && i.videoPlayer.playVideo();
                            break;
                        case 3:
                            i.attemptedToPlay = !0
                    }
                },
                initMp4Video: function(t) {
                    e[t.id] = {
                        id: t.id,
                        type: "mp4"
                    }, this._isFirstSlide(t.id) && this.playMp4Video(t.id)
                },
                stopVideos: function() {
                    for (var [t, i] of Object.entries(e)) i.videoPlayer ? "function" == typeof i.videoPlayer.stopVideo && i.videoPlayer.stopVideo() : "mp4" === i.type && this.stopMp4Video(i.id)
                },
                _getVideoType: function(e) {
                    return e.getAttribute("data-video-type")
                },
                _getVideoDivId: function(e) {
                    return e.id
                },
                playMp4Video: function(e) {
                    var t = this.container.querySelector("#" + e),
                        i = t.play();
                    void 0 !== i && i.then(function() {}).catch(function(e) {
                        t.setAttribute("controls", ""), t.closest(a).setAttribute("data-video-style", "unmuted")
                    })
                },
                stopMp4Video: function(e) {
                    var t = this.container.querySelector("#" + e);
                    t && "function" == typeof t.pause && t.pause()
                },
                initImageZoom: function() {
                    var e = this.container.querySelector(this.selectors.imageContainer);
                    e && (new theme.Photoswipe(e, this.sectionId), e.addEventListener("photoswipe:afterChange", (function(e) {
                        this.flickity && this.flickity.goToSlide(e.detail.index)
                    }).bind(this)))
                },
                getThumbIndex: function(e) {
                    return e.dataset.index
                },
                updateVariantImage: function(e) {
                    var t = e.detail.variant,
                        i = (theme.Images.getSizedImageUrl(t.featured_media.preview_image.src, this.settings.imageSize), this.container.querySelector('.product__thumb[data-id="' + t.featured_media.id + '"]')),
                        s = this.getThumbIndex(i);
                    void 0 !== s && ($(".slider-single").slick("slickGoTo", s), $(".slider-nav").slick("slickGoTo", "0"))
                },
                initProductSlider: function(e) {
                    if (this.cache.mainSlider.querySelectorAll(r).length <= 1) {
                        var t = this.cache.mainSlider.querySelector(r);
                        t && t.classList.add("is-selected")
                    } else {
                        if (this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy(), !e) {
                            var i = this.cache.mainSlider.querySelector(o);
                            this.settings.currentSlideIndex = this._slideIndex(i)
                        }
                        var s = {
                            dragThreshold: 25,
                            adaptiveHeight: !0,
                            avoidReflow: !0,
                            initialIndex: this.settings.currentSlideIndex,
                            childNav: this.cache.thumbSlider,
                            childNavScroller: this.cache.thumbScroller,
                            childVertical: "beside" === this.cache.thumbSlider.dataset.position,
                            pageDots: !0,
                            wrapAround: !0,
                            callbacks: {
                                onInit: this.onSliderInit.bind(this),
                                onChange: this.onSlideChange.bind(this)
                            }
                        };
                        this.settings.imageSetName && (s = Object.assign({}, s, this.imageSetArguments(e))), this.flickity = new theme.Slideshow(this.cache.mainSlider, s)
                    }
                },
                onSliderInit: function(e) {
                    this.settings.imageSetName && this.prepMediaOnSlide(e)
                },
                onSlideChange: function(e) {
                    if (this.flickity) {
                        var t = this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'),
                            i = this.settings.imageSetName ? this.cache.mainSlider.querySelectorAll(".flickity-slider .product-main-slide")[e] : this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + e + '"]');
                        t.setAttribute("tabindex", "-1"), i.setAttribute("tabindex", 0), this.stopMediaOnSlide(t), this.prepMediaOnSlide(i), this.settings.currentSlideIndex = e
                    }
                },
                stopMediaOnSlide(t) {
                    var i = t.querySelector(n);
                    if (i) {
                        var s = this._getVideoType(i),
                            a = this._getVideoDivId(i);
                        if ("youtube" === s) {
                            if (e[a].videoPlayer) return void e[a].videoPlayer.stopVideo()
                        } else if ("mp4" === s) return void this.stopMp4Video(a)
                    }
                    var r = t.querySelector(this.selectors.media);
                    r && r.dispatchEvent(new CustomEvent("mediaHidden", {
                        bubbles: !0,
                        cancelable: !0
                    }))
                },
                prepMediaOnSlide(t) {
                    var i = t.querySelector(n);
                    if (i) {
                        this.flickity.reposition();
                        var s = this._getVideoType(i),
                            a = this._getVideoDivId(i);
                        if ("youtube" === s) {
                            if (e[a].videoPlayer && "sound" !== e[a].options.style) return void e[a].videoPlayer.playVideo()
                        } else "mp4" === s && this.playMp4Video(a)
                    }
                    var r = t.querySelector(this.selectors.media);
                    r && (r.dispatchEvent(new CustomEvent("mediaVisible", {
                        bubbles: !0,
                        cancelable: !0
                    })), t.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0), t.querySelector(".product-single__close-media").setAttribute("tabindex", 0))
                },
                _slideIndex: function(e) {
                    return e.getAttribute("data-index")
                },
                openModalProduct: function() {
                    var e = !1;
                    this.settings.modalInit ? e = !0 : (this.blocksHolder = this.container.querySelector("[data-blocks-holder]"), fetch(this.blocksHolder.dataset.url).then(function(e) {
                        return e.text()
                    }).then((function(e) {
                        var t = (new DOMParser).parseFromString(e, "text/html").querySelector("[data-product-blocks]");
                        t.querySelectorAll("[id]").forEach(e => {
                            var i = e.getAttribute("id");
                            e.setAttribute("id", i + "-modal");
                            var s = t.querySelector(`[for="${i}"]`);
                            s && s.setAttribute("for", i + "-modal");
                            var n = t.querySelector(`[aria-controls="${i}"]`);
                            n && n.setAttribute("aria-controls", i + "-modal")
                        });
                        var i = t.querySelector(this.selectors.form);
                        if (i) {
                            var s = i.getAttribute("id");
                            t.querySelectorAll("[form]").forEach(e => {
                                e.setAttribute("form", s)
                            })
                        }
                        this.blocksHolder.innerHTML = "", this.blocksHolder.append(t), this.blocksHolder.classList.add("product-form-holder--loaded"), this.cacheElements(), this.formSetup(), this.updateModalProductInventory(), Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), theme.collapsibles.init(this.container), document.dispatchEvent(new CustomEvent("quickview:loaded", {
                            detail: {
                                productId: this.productId
                            }
                        }))
                    }).bind(this)), this.productSetup(), this.videoSetup(), this.settings.imageSetName ? this.variants ? this.initProductSlider() : document.addEventListener("quickview:loaded", (function(e) {
                        e.detail.productId === this.productId && this.initProductSlider()
                    }).bind(this)) : this.initProductSlider(), this.customMediaListners(), this.addIdToRecentlyViewed(), this.settings.modalInit = !0), AOS.refreshHard(), document.dispatchEvent(new CustomEvent("quickview:open", {
                        detail: {
                            initialized: e,
                            productId: this.productId
                        }
                    }))
                },
                updateModalProductInventory: function() {
                    window.inventories = window.inventories || {}, this.container.querySelectorAll(".js-product-inventory-data").forEach(e => {
                        var t = e.dataset.productId;
                        window.inventories[t] = {}, e.querySelectorAll(".js-variant-inventory-data").forEach(e => {
                            window.inventories[t][e.dataset.id] = {
                                quantity: e.dataset.quantity,
                                policy: e.dataset.policy,
                                incoming: e.dataset.incoming,
                                next_incoming_date: e.dataset.date
                            }
                        })
                    })
                },
                closeModalProduct: function() {
                    this.stopVideos()
                },
                initModelViewerLibraries: function() {
                    var e = this.container.querySelectorAll(this.selectors.media);
                    e.length < 1 || theme.ProductMedia.init(e, this.sectionId)
                },
                initShopifyXrLaunch: function() {
                    document.addEventListener("shopify_xr_launch", (function() {
                        this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")").dispatchEvent(new CustomEvent("xrLaunch", {
                            bubbles: !0,
                            cancelable: !0
                        }))
                    }).bind(this))
                },
                customMediaListners: function() {
                    document.querySelectorAll(this.selectors.closeMedia).forEach(e => {
                        e.addEventListener("click", (function() {
                            var e = this.cache.mainSlider.querySelector(".is-selected").querySelector(this.selectors.media);
                            e && e.dispatchEvent(new CustomEvent("mediaHidden", {
                                bubbles: !0,
                                cancelable: !0
                            }))
                        }).bind(this))
                    });
                    var e = this.container.querySelectorAll("model-viewer");
                    e.length && e.forEach(e => {
                        e.addEventListener("shopify_model_viewer_ui_toggle_play", (function(e) {
                            this.mediaLoaded(e)
                        }).bind(this)), e.addEventListener("shopify_model_viewer_ui_toggle_pause", (function(e) {
                            this.mediaUnloaded(e)
                        }).bind(this))
                    })
                },
                mediaLoaded: function(e) {
                    this.container.querySelectorAll(this.selectors.closeMedia).forEach(e => {
                        e.classList.remove(i)
                    }), this.flickity && this.flickity.setDraggable(!1)
                },
                mediaUnloaded: function(e) {
                    this.container.querySelectorAll(this.selectors.closeMedia).forEach(e => {
                        e.classList.add(i)
                    }), this.flickity && this.flickity.setDraggable(!0)
                },
                onUnload: function() {
                    theme.ProductMedia.removeSectionModels(this.sectionId), this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy()
                }
            }), c
        }(), theme.RecentlyViewed = function() {
            var e = !1;

            function t(e) {
                e && (this.container = e, this.sectionId = this.container.getAttribute("data-section-id"), this.namespace = ".recently-viewed" + this.sectionId, this.gridItemWidth = this.container.getAttribute("data-grid-item-class"), this.rowOf = this.container.getAttribute("data-row-of"), this.imageSizes = this.container.getAttribute("data-image-sizes"), theme.initWhenVisible({
                    element: this.container,
                    callback: this.init.bind(this),
                    threshold: 600
                }))
            }
            return t.prototype = Object.assign({}, t.prototype, {
                init: function() {
                    if (!e) {
                        if (e = !0, 0 !== Object.keys(theme.recentlyViewed.recent).length || theme.recentlyViewed.recent.constructor !== Object) {
                            this.outputContainer = document.getElementById("RecentlyViewed-" + this.sectionId), this.handle = this.container.getAttribute("data-product-handle");
                            var t = [];
                            Object.keys(theme.recentlyViewed.recent).forEach((function(e) {
                                "undefined" !== e && t.push(this.getProductInfo(e))
                            }).bind(this)), Promise.all(t).then((function(e) {
                                this.setupOutput(e), this.captureProductDetails(e), this.swatches = this.container.querySelectorAll(".color-swatch--with-image"), this.swatches.forEach(e => {
                                    e.addEventListener("mouseenter", (function() {
                                        this.setActiveColorImage(e)
                                    }).bind(this)), e.addEventListener("touchstart", (function(t) {
                                        t.preventDefault(), this.setActiveColorImage(e)
                                    }).bind(this), {
                                        passive: !0
                                    }), e.addEventListener("mouseleave", (function() {
                                        this.removeActiveColorImage(e)
                                    }).bind(this))
                                })
                            }).bind(this))
                        } else this.container.classList.add("hide")
                    }
                },
                getProductInfo: function(e) {
                    return new Promise(function(t, i) {
                        theme.recentlyViewed.productInfo.hasOwnProperty(e) ? t(theme.recentlyViewed.productInfo[e]) : fetch("/products/" + e + ".js").then(function(e) {
                            return e.text()
                        }).then(function(e) {
                            t(e)
                        })
                    })
                },
                setupOutput: function(e) {
                    var t = [],
                        i = this.container.getAttribute("data-recent-count");
                    if (Object.keys(e).forEach((function(i) {
                            if (e[i]) {
                                var s = JSON.parse(e[i]);
                                if (s.handle !== this.handle && void 0 !== s.handle) {
                                    s.url = theme.recentlyViewed.recent[s.handle] ? theme.recentlyViewed.recent[s.handle].url : s.url, s.image_responsive_url = theme.Images.buildImagePath(s.featured_image), s.image_responsive_urls = theme.Images.buildImagePath(s.featured_image, [180, 360, 540, 720, 900]), s.image_aspect_ratio = theme.recentlyViewed.recent[s.handle].aspectRatio;
                                    var n = s.variants[0];
                                    if (n && n.unit_price) {
                                        var a = "";
                                        n.unit_price_measurement && (1 != n.unit_price_measurement.reference_value && (a += n.unit_price_measurement.reference_value + " "), a += n.unit_price_measurement.reference_unit), s.unit_price = theme.Currency.formatMoney(n.unit_price), "" != a && (s.unit_price += "/" + a)
                                    }
                                    t.unshift(s)
                                }
                            }
                        }).bind(this)), 0 === t.length) return this.container.classList.add("hide"), void(document.querySelector('[data-tab="recent-tab"]') && document.querySelector('[data-tab="recent-tab"]').classList.add("hidden"));
                    var s = theme.buildProductGridItem(t.slice(0, i), this.gridItemWidth, this.rowOf, this.imageSizes);
                    this.outputContainer.innerHTML = s, this.slideshow = this.container.querySelector("[data-recent-slideshow]"), window.screen.width <= 767 && this.slideshow.childElementCount > 2 && this.setupSlider(), document.querySelector('.recent-tab') && !document.querySelector('.recent-tab').classList.contains("do_not_hide") && document.querySelector('.recent-tab').classList.add("hidden"), AOS && AOS.refreshHard()
                },
                captureProductDetails: function(e) {
                    for (var t = 0; t < e.length; t++) {
                        var i = e[t];
                        theme.recentlyViewed.productInfo[i.handle] = i
                    }
                    theme.config.hasSessionStorage && sessionStorage.setItem("recent-products", JSON.stringify(theme.recentlyViewed.productInfo))
                },
                setupSlider: function() {
                    let e = !0,
                        t = !1;
                    t = !1, e = !0, this.flickity = new theme.Slideshow(this.slideshow, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        adaptiveHeight: !0,
                        wrapAround: !1,
                        contain: !0,
                        groupCells: !0
                    })
                },
                setActiveColorImage: function(e) {
                    let t = e.dataset.variantId,
                        i = e.dataset.variantImage;
                    this.colorImages = this.container.querySelectorAll(".grid-product__color-image"), this.colorImages.forEach(e => {
                        e.classList.remove("is-active")
                    }), this.swatches.forEach(e => {
                        e.classList.remove("is-active")
                    });
                    let s = this.container.querySelector(`.grid-product__color-image--${t}`);
                    s.style.backgroundImage = "url(" + i + ")", s.classList.add("is-active"), e.classList.add("is-active");
                    let n = e.dataset.url;
                    e.closest(".grid-product").querySelectorAll(".grid-product__link").forEach(e => {
                        e.setAttribute("href", n)
                    })
                },
                removeActiveColorImage: function(e) {
                    let t = e.dataset.variantId;
                    this.container.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active")
                },
                onUnload: function() {
                    e = !1
                }
            }), t
        }(), theme.Testimonials = function() {
            var e = {
                adaptiveHeight: !0,
                avoidReflow: !0,
                pageDots: !0,
                prevNextButtons: !1
            };

            function t(e) {
                this.container = e, this.timeout;
                var t = e.getAttribute("data-section-id");
                this.slideshow = e.querySelector("#Testimonials-" + t), this.namespace = ".testimonial-" + t, this.slideshow && theme.initWhenVisible({
                    element: this.container,
                    callback: this.init.bind(this),
                    threshold: 600
                })
            }
            return t.prototype = Object.assign({}, t.prototype, {
                init: function() {
                    this.slideshow.dataset.count <= 3 && (e.wrapAround = !1), this.flickity = new theme.Slideshow(this.slideshow, e), this.slideshow.dataset.count > 2 && (this.timeout = setTimeout((function() {
                        this.flickity.goToSlide(1)
                    }).bind(this), 1e3))
                },
                onUnload: function() {
                    this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy()
                },
                onDeselect: function() {
                    this.flickity && "function" == typeof this.flickity.play && this.flickity.play()
                },
                onBlockSelect: function(e) {
                    var t = parseInt(this.slideshow.querySelector(".testimonials-slide--" + e.detail.blockId).dataset.index);
                    clearTimeout(this.timeout), this.flickity && "function" == typeof this.flickity.pause && (this.flickity.goToSlide(t), this.flickity.pause())
                },
                onBlockDeselect: function() {
                    this.flickity && "function" == typeof this.flickity.play && this.flickity.play()
                }
            }), t
        }(), theme.isStorageSupported = function(e) {
            if (window.self !== window.top) return !1;
            var t, i = "test";
            "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
            try {
                return t.setItem(i, "1"), t.removeItem(i), !0
            } catch (s) {
                return !1
            }
        }, theme.reinitProductGridItem = function(e) {
            AOS && AOS.refreshHard(), document.documentElement.classList.contains("modal-open") || theme.initQuickShop(), window.SPR && (SPR.initDomEls(), SPR.loadBadges()), theme.collapsibles.init()
        }, theme.config.hasSessionStorage = theme.isStorageSupported("session"), theme.config.hasLocalStorage = theme.isStorageSupported("local"), AOS.init({
            easing: "ease-out-quad",
            once: !0,
            offset: 60,
            disableMutationObserver: !0
        }), theme.config.hasLocalStorage && (theme.recentlyViewed.localStorage = window.localStorage.getItem("theme-recent"), theme.recentlyViewed.localStorage && (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage))), theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage["recent-products"] ? JSON.parse(sessionStorage["recent-products"]) : {}, theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches, matchMedia(theme.config.mediaQuerySmall).addListener(function(e) {
            e.matches ? (theme.config.bpSmall = !0, document.dispatchEvent(new CustomEvent("matchSmall"))) : (theme.config.bpSmall = !1, document.dispatchEvent(new CustomEvent("unmatchSmall")))
        }), theme.initGlobals = function() {
            theme.collapsibles.init(), theme.videoModal()
        }, b(function() {
            if (theme.sections = new theme.Sections, theme.sections.register("slideshow-section", theme.SlideshowSection), theme.sections.register("header", theme.HeaderSection), theme.sections.register("product", theme.Product), theme.sections.register("blog", theme.Blog), theme.sections.register("password-header", theme.PasswordHeader), theme.sections.register("photoswipe", theme.Photoswipe), theme.sections.register("background-image", theme.BackgroundImage), theme.sections.register("testimonials", theme.Testimonials), theme.sections.register("video-section", theme.VideoSection), theme.sections.register("map", theme.Maps), theme.sections.register("footer-section", theme.FooterSection), theme.sections.register("store-availability", theme.StoreAvailability), theme.sections.register("recently-viewed", theme.RecentlyViewed), theme.sections.register("newsletter-popup", theme.NewsletterPopup), theme.sections.register("collection-header", theme.CollectionHeader), theme.sections.register("collection-grid", theme.Collection), theme.initGlobals(), theme.initQuickShop(), theme.rteInit(), document.body.classList.contains("template-cart")) {
                var e = document.getElementById("CartPageForm");
                e && new theme.CartForm(e)
            }
            theme.settings.isCustomerTemplate && theme.customerTemplates(), document.dispatchEvent(new CustomEvent("page:loaded")), window.onscroll = function() {
                window.pageYOffset >= s && window.pageYOffset > 0 ? (t.classList.add("sticky"), i.classList.add("stickymob")) : (t.classList.remove("sticky"), i.classList.remove("stickymob")), window.pageYOffset >= s ? n.classList.add("stickylogo") : n.classList.remove("stickylogo")
            };
            var t = document.getElementById("custom-nav-wrapper"),
                i = document.getElementById("custom-nav-wrapper-mob");
            if (window.screen.width <= 1024) var s = i.getBoundingClientRect().top;
            else s = t.getBoundingClientRect().top;
            var n = document.getElementById("custom-sticky-logo");

            function a() {
                let e = document.getElementById("compare-btn-no"),
                    t = document.querySelector(".SP_CA_Count");
                e && t ? (console.log("update countggggg"), e.innerHTML = t.innerHTML) : console.log("not update countggggg")
            }

            function r() {
                let e = document.querySelector(".SP_CA_Count");
                e && (a(), console.log("ddd", e), new MutationObserver(a).observe(e, {
                    childList: !0,
                    subtree: !0
                }))
            }
            document.querySelector(".SP_CA_Count") ? r() : setTimeout(r, 3e3), $("#togglefilter").click(function() {
                $(".grid__item--sidebar").toggleClass("hide"), $(this).text(function(e, t) {
                    return "Hide Filters" === t ? "Show Filters" : "Hide Filters"
                }), $("#grid-content").toggleClass("full-width"), window.dispatchEvent(new Event("resize"))
            })
        }), b(() => {
            let e = document.querySelector('form.input-group.search-bar[role="search"]');
            e && e.addEventListener("submit", t => {
                let i = e.querySelector('input[type="search"]');
                "" == i.value && "none" != window.getComputedStyle(i, null).display && t.preventDefault()
            })
        })
    }(),
    function(e, t) {
        e.checkElementInterval = e.setInterval(function() {
            if (e.checkElementIntervalCount || (e.checkElementIntervalCount = 0), e.checkElementIntervalCount++, e.checkElementIntervalCount > 100 && clearInterval(e.checkElementInterval), t.querySelectorAll("#sa_ca_wrapper .SP_CA_Count").length > 0) {
                var i = $("#sa_ca_wrapper").find(".SP_CA_Count").text();
                console.log("compareItemCount", i), i = null == i || "" == i ? "0" : i, $("#compare-btn-no").text(i), $(document).find("#sa_ca_wrapper").on("DOMSubtreeModified", function() {
                    var e = $(this).find(".SP_CA_Count").text();
                    e = null == e || "" == e ? "0" : e, $("#compare-btn-no").text(e)
                }), clearInterval(e.checkElementInterval)
            }
        }, 100)
    }(window, document);
var klaviyoBtn = document.querySelector(".klaviyo_form_trigger");
void 0 !== klaviyoBtn && null != klaviyoBtn && klaviyoBtn.addEventListener("click", function() {
    window._klOnsite = window._klOnsite || [], window._klOnsite.push(["openForm", "R2wtQJ"])
}), window.onload = function() {
    var e = window.jQuery,
        t = document.querySelector("[data-add-to-cart]");
    t && (t.on("click", function(t) {
        return "" == e("#ring_size_dropdown_option").val() || null === e("#ring_size_dropdown_option").val() ? (e("html, body").stop().animate({
            scrollTop: e("#ring_size_dropdown_option").offset().top - parseInt(e("#custom-nav-wrapper-mob").outerHeight())
        }, 400), !1) : e("#engraving-text-input").length && e("#engraving-text-input").prop("required") && "" == e("#engraving-text-input").val() ? (e("html, body").stop().animate({
            scrollTop: e("#engraving-text-input").offset().top - parseInt(e("#custom-nav-wrapper-mob").outerHeight())
        }, 400), !1) : void 0
    }), window.screen.width <= 768 && (currStickyPos = t.getBoundingClientRect().top, window.onscroll = function() {
        if (screen.height + window.pageYOffset - 100 > currStickyPos) {
            t.classList.add("sticky-bottom");
            var e = document.querySelector(".needsclick.kl-teaser-R2wtQJ");
            e && e.classList.add("hide")
        } else t.classList.remove("sticky-bottom")
    })), jquery("body").on("click", ".engraving__label", function(e) {
        jquery(this).parent().hasClass("active") ? (jquery(this).siblings(".grid-product-option").toggle("slow"), jquery(this).parent().removeClass("active"), jquery(this).siblings(".grid-product-option").find("#engraving-text-input").attr("required", !1)) : (jquery(this).siblings(".grid-product-option").toggle("slow"), jquery(this).parent().addClass("active"), jquery(this).siblings(".grid-product-option").find("#engraving-text-input").attr("required", !0))
    }), $("#engraving-text-input").keyup(function(e) {
        $(this).val().length > 20 && e.preventDefault()
    }), $(".parent-link-mb").on("click", function() {
        var e = $(this).attr("data-list");
        $("#btn-" + e).trigger("click")
    }), document.querySelector("#carousel-top-panel .headline") && (document.querySelector("#carousel-top-panel .headline").innerHTML = "Customer Reviews")
};
var jquery = window.jQuery;
if (window.screen.width <= 768) {
    jquery(".new-pdp-des-btn").length && (jquery(".new-pdp-des-btn").removeClass("is-open"), jquery(".new-pdp-des-content").removeClass("is-open"), jquery(".new-pdp-des-content").css("height", "0px"));
    var e = document.querySelector("#learning-slide");
    if (e) {
        var t = e.querySelectorAll(".grid__item");
        if (t.length > 1) var i = {
                prevNextButtons: !0,
                pageDots: !0,
                fade: !0,
                setGallerySize: !1,
                initialIndex: 0,
                adaptiveHeight: !0,
                lazyLoad: !0,
                imagesLoaded: !0
            },
            s = new Flickity(e, i);
        else t[0].classList.add("is-selected")
    }
}
jquery(".cust-mob-search-icon").on("click", function(e) {
    e.preventDefault(), jquery(".right-search--content").toggle()
}), jquery(document).click(function(e) {
    var t = $(e.target);
    t.parent().is(".cust-mob-search-icon") || t.is(".right-search--content") || t.is(".custom-search-input") || jquery(".right-search--content").hide(), t.closest(".win-wishlist-popup__inner").length || t.closest(".wishlist-popup-link").length || jquery("#win-wishlist-popup").hasClass("modal--is-active") && closeWinWishListPopup()
});
var featureSlider = document.querySelectorAll(".featured-col-slider");

function closeWinWishListPopup() {
    jquery("html").removeClass("modal-open"), jquery("#win-wishlist-popup").removeClass("modal--is-active"), jquery("#win-wishlist-popup").addClass("modal--is-closing"), jquery("html").removeClass("modal-open--solid"), jquery("html").addClass("modal-closing"), window.setTimeout((function() {
        jquery("html").removeClass("modal-closing"), jquery("#win-wishlist-popup").removeClass("modal--is-closing")
    }).bind(this), 500)
}
featureSlider && featureSlider.forEach(e => {
    this.flickity = new theme.Slideshow(e, {
        prevNextButtons: !0,
        pageDots: !1,
        adaptiveHeight: !0,
        wrapAround: !1,
        contain: !0,
        groupCells: !0
    })
}), jquery(".string-color-input").on("click", function() {
    jquery(".string-color-input").removeClass("active"), jquery(this).addClass("active");
    var e = jquery(this).attr("data-value"),
        t = jquery(".variant-input").find("input[type='radio']:checked").attr("data-string-swatch-name") + " / " + e;
    jquery("#string-color-property").val(e), jquery(`[data-group="${t}"]`).length && ($(".slider-nav").slick("slickUnfilter"), $(".slider-nav").slick("slickFilter", `[data-group="${t}"]`), $(".product__thumb-item.slick-current").trigger("click"), $(".slider-nav").slick("slickGoTo", "0"))
}), jquery(".featured-col-slider").each(function(e) {
    var t = jquery(this);
    if (t.hasClass("flickity-enabled")) {
        var i = "yes",
            s = t.find(".flickity-button");
        s.each(function() {
            jquery(this).prop("disabled") || (i = "no")
        }), "yes" == i && s.addClass("hide")
    }
}), jquery(document).on('click', '.pr-rel-rec-tab-heading', function () {
    //jquery(".pr-rel-rec-tab-heading").on("click", function() {
    var e = jquery(this).attr("data-tab");
    jquery(".pr-rel-rec-tab-heading").removeClass("active"), jquery(this).addClass("active"), jquery(".tab-section-content").addClass("hidden"), jquery("." + e).removeClass("hidden")
}), jquery(".wishlist-popup-link").on("click", function(e) {
    e.preventDefault(), jquery("html").addClass("modal-open"), jquery("#win-wishlist-popup").addClass("modal--is-active")
}), jquery(".win-wishlist-popup-close").on("click", function() {
    closeWinWishListPopup()
});
var priceComparisonInfo = document.querySelector(".dtlcompare-info");
priceComparisonInfo && (priceComparisonInfo.addEventListener("mouseenter", function() {
    document.querySelector(".dtlcompare-infobox").classList.remove("hide")
}), priceComparisonInfo.addEventListener("mouseleave", function() {
    document.querySelector(".dtlcompare-infobox").classList.add("hide")
})), jquery("body").on("mouseenter", ".variant-btn-info", function(e) {
    jquery(this).find(".variant-btn-infobox").removeClass("hide")
}), jquery("body").on("mouseleave", ".variant-btn-info", function(e) {
    jquery(this).find(".variant-btn-infobox").addClass("hide")
});
var klaviyocustomEl = document.querySelectorAll(".cutom-klaviyo-popup-open");
klaviyocustomEl && klaviyocustomEl.forEach(e => {
    e.addEventListener("click", function() {
        window._klOnsite = window._klOnsite || [], window._klOnsite.push(["openForm", "TeEfBN"])
    })
});
var promoCounterEl = jquery(".promo-countdown-timer");
if (promoCounterEl.length > 0) var counterDate = promoCounterEl.attr("data-date"),
    countDownDate = new Date(counterDate.toLocaleString("en-US", {
        timeZone: "America/New_York"
    })).getTime(),
    counterHTML = promoCounterEl.innerHTML,
    x = setInterval(function() {
        var e = new Date((new Date).toLocaleString("en-US", {
                timeZone: "America/New_York"
            })).getTime(),
            t = countDownDate - e,
            i = Math.floor(t / 864e5).toString();
        jquery(".promo-days-timer").html('<span class="promo-countdowndigit">' + i + "</span>");
        var s = Math.floor(t % 864e5 / 36e5).toString(),
            n = Math.floor(t % 36e5 / 6e4).toString(),
            a = Math.floor(t % 6e4 / 1e3).toString();
        jquery(".promo-hours-timer").html(' <span class="promo-countdowndigit">' + s + "</span>"), jquery(".promo-minutes-timer").html(' <span class="promo-countdowndigit">' + n + "</span>"), jquery(".promo-seconds-timer").html(' <span class="promo-countdowndigit">' + a + "</span>")
    }, 1e3);
$(document).ready(function() {
    $(".ring-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: !0,
        variableWidth: !1,
        dots: !1,
        infinite: !1,
        speed: 300,
        autoplay: !1,
        prevArrow: '<button type="button" class="slick-prev"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg></button>',
        responsive: [{
            breakpoint: 1451,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 1300,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }]
    })
});
let diamondOptions = document.querySelectorAll(".variant-diamond-input");
diamondOptions && diamondOptions.forEach(e => {
    e.addEventListener("click", function(t) {
        let i = document.querySelector(".check_if_page_loaded").value;
        var s = !1;
        if (e.classList.contains("diamond-pdp-metal")) {
            s = !0, e.classList.contains("selected") ? e.classList.remove("selected") : (document.querySelector(".diamond-pdp-metal.selected") && document.querySelector(".diamond-pdp-metal.selected").classList.remove("selected"), e.classList.add("selected")), document.querySelector("[data-variant-color-label]").innerHTML = e.getAttribute("data-value");
            var n = e.getAttribute("data-value-handle");
            if (document.querySelector(".diamond-pdp-setting.selected") || "no" != i || (document.querySelectorAll(".diamond-pdp-setting")[0].click(), document.querySelector(".check_if_page_loaded").value = "yes"), document.querySelector(".diamond-pdp-setting.selected")) var a = document.querySelector(".diamond-pdp-setting.selected").getAttribute("data-id");
            var selectedDiamondPdpSetting =  document.querySelector('.diamond-pdp-setting.selected');
            if(selectedDiamondPdpSetting){
                var productId = document.querySelector('.diamond-pdp-setting.selected').getAttribute('data-id');
                var productUrl = document.querySelector('.diamond-pdp-setting.selected').getAttribute('data-url');
            }else{
                var productId = '';
                var productUrl = '';
            }
            if (document.querySelector(".diamond-pdp-setting.selected")) var r = document.querySelector(".diamond-pdp-setting.selected").getAttribute("data-value")
        } else {
            if (
                document.querySelectorAll(".diamond-pdp-setting.selected").length != 0 &&
                document.querySelectorAll(".diamond-pdp-metal.selected").length === 0 && !e.classList.contains("selected")){
                const pageLoaded = document.querySelector(".check_if_page_loaded");
                    if (pageLoaded) {
                        pageLoaded.value = "no";
                    }
            }
            let i = document.querySelector(".check_if_page_loaded").value;
            if (e.classList.contains("selected") ? e.classList.remove("selected") : (document.querySelector(".diamond-pdp-setting.selected") && document.querySelector(".diamond-pdp-setting.selected").classList.remove("selected"), e.classList.add("selected")), document.querySelector(".diamond-pdp-metal.selected") || "no" != i || (document.querySelectorAll(".diamond-pdp-metal")[0].click(), document.querySelector(".check_if_page_loaded").value = "yes"), document.querySelector("[data-variant-setting-label]").innerHTML = e.getAttribute("data-value"), document.querySelector(".diamond-pdp-metal.selected")) var n = document.querySelector(".diamond-pdp-metal.selected").getAttribute("data-value-handle");
            
            var a = e.getAttribute("data-id");
                if(e.classList.contains("selected")){
               var productId = e.getAttribute('data-id');
               var productUrl = e.getAttribute('data-url');
            }else{
               var productId = '';
                var productUrl = '';
            }
               var  r = e.getAttribute("data-value");
            "Classic Studs" == r ? document.querySelector(".item_qty_input").value = "2" : document.querySelector(".item_qty_input").value = "1"
        }
          if(productId != '' && typeof productId !== "undefined"){
              if(productUrl !='' && typeof productUrl !== "undefined")
              fetch(productUrl+'?view=sizelengthview')
              .then(response => response.text())
              .then(html => {
                // if(html!=''){
                //   document.getElementById('size_length_dropdown').innerHTML = html;
   
                // }
                   if (!html || !html.trim()) {
                document.getElementById('size_length_dropdown').innerHTML = '';
                    const setting_product_size_length = document.querySelector('.setting_product_size_length');
                     if(setting_product_size_length){
                        setting_product_size_length.setAttribute('disabled', '');
                        document.querySelector(".setting_product_size_length").value = '';
                        document.querySelector(".setting_product_size_length").setAttribute('name', '');
                     }
                }else{
                  document.getElementById('size_length_dropdown').innerHTML = html;
                   const setting_product_size_length = document.querySelector('.setting_product_size_length');
                     if(setting_product_size_length){
                        setting_product_size_length.setAttribute('disabled', '');
                        document.querySelector(".setting_product_size_length").value = '';
                        document.querySelector(".setting_product_size_length").setAttribute('name', '');
                     }
                    
                }
              })
                .catch(error => console.error(error));
            }
       // if (0 == document.querySelectorAll(".diamond-pdp-setting.selected").length && 0 == document.querySelectorAll(".diamond-pdp-metal.selected").length) document.querySelector(".setting_product_opt").disabled = !0, document.querySelector(".setting_product_opt").value = "", document.querySelector(".setting_product_opt.skus").disabled = !0, document.querySelector(".setting_product_opt.skus").value = "", document.querySelector(".ring_customize").disabled = !0, document.querySelector(".ring_customize").value = "", document.querySelector(".setting_properties").disabled = !0, document.querySelector(".setting_properties").value = "";
       if (
  document.querySelectorAll(".diamond-pdp-setting.selected").length === 0 &&
  document.querySelectorAll(".diamond-pdp-metal.selected").length === 0
) {
  const productOpt = document.querySelector(".setting_product_opt");
  const skusOpt = document.querySelector(".setting_product_opt.skus");
  const ringCustomize = document.querySelector(".ring_customize");
  const settingProps = document.querySelector(".setting_properties");
  const pageLoaded = document.querySelector(".check_if_page_loaded");
const setting_product_size_length = document.querySelector('.setting_product_size_length');
            

  if (productOpt) {
    productOpt.disabled = true;
    productOpt.value = "";
  }

  if (skusOpt) {
    skusOpt.disabled = true;
    skusOpt.value = "";
  }

  if (ringCustomize) {
    ringCustomize.disabled = true;
    ringCustomize.value = "";
  }

  if (settingProps) {
    settingProps.disabled = true;
    settingProps.value = "";
  }

  if (pageLoaded) {
    pageLoaded.value = "no";
  }
  if(setting_product_size_length){
    setting_product_size_length.setAttribute('disabled', '');
    document.querySelector(".setting_product_size_length").value = '';
    document.querySelector(".setting_product_size_length").setAttribute('name', '');
    var ringSizeFlexBoxCreate = document.querySelectorAll('.ringSizeFlexBoxCreate');
        if(ringSizeFlexBoxCreate){
            ringSizeFlexBoxCreate.forEach(el => el.remove());
        }
  }
}
        else {
            let o = n + "-" + a,
                c = "",
                l = "";
            if ("" != a && void 0 !== a && (c = setting_variants[o].id, l = setting_variants[o].sku), s)
                for (let d in setting_variants) {
                    let u = setting_variants[d],
                        h = u.metal,
                        p = u.pid;
                    n == h && (document.querySelector(".prd-img-" + p) && "" != u.image && document.querySelector(".prd-img-" + p).setAttribute("src", u.image), document.querySelector(".prd-price-" + p) && "" != u.price && (document.querySelector(".prd-price-" + p).innerHTML = "+" + u.price))
                }
            document.querySelector(".setting_product_opt").removeAttribute("disabled"), document.querySelector(".setting_product_opt").value = c, document.querySelector(".setting_product_opt.skus").removeAttribute("disabled"), document.querySelector(".setting_product_opt.skus").value = l, document.querySelector(".ring_customize").removeAttribute("disabled"), document.querySelector(".ring_customize").value = l, document.querySelector(".setting_properties").removeAttribute("disabled"), document.querySelector(".setting_properties").value = r
        }
         var setting_product_size_length = document.querySelector('.setting_product_size_length');
            if(setting_product_size_length){
            setting_product_size_length.setAttribute('disabled', '');
            document.querySelector(".setting_product_size_length").value = '';
            document.querySelector(".setting_product_size_length").setAttribute('name', '');
            }
    })
});

document.addEventListener('change', function (e) {
  const setting_product_size_length = document.querySelector(".setting_product_size_length");
  if(setting_product_size_length){
    setting_product_size_length.removeAttribute('disabled'), document.querySelector(".setting_product_size_length").value = '';
  }
  if (!e.target.matches('.ring_size_dropdown-js')) return;
const select = e.target;

  const value = select.value;        // selected value
  const name  = select.name;         // name attribute
  const text  = select.options[select.selectedIndex].text; // label
  const input = document.querySelector('.setting_product_size_length');

if (input) {
  input.removeAttribute('disabled');   // enable field
  input.value = value;                    // clear value
  input.setAttribute('name', name); // ✅ add name
}
  
});